/*!
* ------------------------------------------------------------
*  @alegradev/app-alegra-items v3.0.14
*  (c) Alegra 2022 - present
* ------------------------------------------------------------
*/
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 4050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    accepted: "Issued",
    accounting: {
      account: "Account",
      cost: "Inventariable purchase account",
      costHelp: "Select the ledger account in which the value of the cost of sales of the product will be registered.",
      credit: "Credit",
      debit: "Debit",
      electronic: "Electronic accounting",
      help: "Displays the accounting transaction for this receipt. You can customize the accounts and their codes",
      inventory: "Inventory account",
      inventoryHelp: "Select the ledger account in which the values of inputs and outputs are recorded product.",
      nature: {
        label: "Nature",
        credit: "Credit",
        debit: "Debit"
      },
      number: "Account number",
      thirdParty: "Third party",
      label: "Accounting",
      setup: "Accounting configuration",
      title: "Title",
      unassigned: "Unassigned"
    },
    accountingSectionHelp: "Set up ledger accounts in which the movements you make with your sales item will be recorded.",
    actions: "actions",
    activateItem: "Activate item",
    activeFilters: "Active filters",
    activeItems: "actives",
    inactiveItems: "inactives",
    activate: "Activate",
    activated: "Activated",
    add: {
      label: "Add",
      payment: "Add payment",
      subAccount: "Add sub-account",
      variant: "Add variant"
    },
    addAnotherList: "Add another list",
    addAnotherListHelp: "Indicate the price of your item in this list. If your list is in percentage, the value will be displayed with the discount indicated in your list.",
    address: "address",
    addVariantOptionHelp: "Select a variant to add options",
    allocation: "Allocation",
    are3rd: "are",
    areYouSureYouWantTo: "Are you sure you want to",
    attachedFiles: "Attached files",
    attachFile: "Attach a file",
    attachItemImage: "Attach item's image",
    averageCost: "Average cost",
    basePrice: "Base price",
    brand: "Brand",
    belongsTo: "It belongs to ",
    bill: "Supplier invoice",
    billItem: "Bill this item",
    bills: "Supplier invoices",
    buyItem: "Buy this item",
    cancel: "Cancel",
    cashedIn: "Cashed in",
    category: "Income account",
    categoryHelp: "Select the account where the amounts due to sales of the item will be recorded.",
    categoryModalHeader: "Select the account of income to which your item belongs",
    categoryInventoryModalHeader: "Select the inventory accounting account to which your item belongs",
    categoryPurchaseModalHeader: "Select the sales cost accounting account to which your item belongs",
    categoryModalHeaderDescription: "Customize your accounts, create new ones and add the code from the icons in the action column.",
    categoryModalHeaderHelp: "If you need help managing your accounts ",
    categoryRuleAutoFor: "This account works automatically for the records of ",
    categoryRuleConfirmText: "This account has an automatic configuration, changing the name will affect all registers made to date",
    cause: "Cause",
    cabysDeprecated: "Outdated product key",
    cabysDeprecatedHelp: "Activate to get the list of items whose product key was eliminated by the Treasury.",
    cabysDeprecatedSearch: "This process will take a few seconds, if you have many items with the product key outdated you can use the mass update.",
    cabysDeprecatedSearchTitle: "Looking for items without product key 🔍",
    cabysHelp: "Enter the code of your product or service defined in Cabys, if you do not know it <a target='_blank' href='https://app.powerbi.com/view?r=eyJrIjoiZDdmNTBlYTktYmE0Ni00NGM3LWJhNzYtMGZhNjBlNTQyYTdmIiwidCI6IjYxOGQwYTQ1LTI1YTYtNDYxOC05ZjgwLThmNzBhNDM1ZWU1MiJ9'>click here</a>.",
    checkIn: "Check in",
    clickHere: "click here",
    client: "Client",
    code: "Code",
    contact: "Contact",
    cost: "Cost",
    complete: "Complete",
    confirm: "Confirm",
    currency: "Currency",
    create: "Create",
    createdTitle: "Successfully created item",
    createdMessage: "The item {{name}} has been added to your inventory",
    editedTitle: "Successfully edited item",
    editedMessage: "The item {{name}} has been edited",
    deletedTitle: "Successfully deleted item",
    deletedMessage: "Item successfully deleted from your inventory",
    creationDate: "Creation date",
    creditNote: "Credit note",
    creditNotes: "Credit notes",
    currentQuantity: "Current quantity",
    customFields: "Custom Fields",
    customFieldsHelp: "Add additional information about your products such as expiration dates or barcodes.",
    date: "Date",
    deactivate: "Deactivate",
    deactivated: "Deactivated",
    debitNote: "Debit note",
    debitNotes: "Debit notes",
    delete: "delete",
    description: "description",
    descriptionHelp: "Add details about your product or service.",
    destinationWarehouse: "Destination warehouse",
    distributeHelp: "If you need help to distribute your",
    distributeInWarehouses: "Distribute in warehouses",
    document: "Document",
    download: {
      pdf: "Download PDF",
      xml: "Download XML"
    },
    draft: "Draft",
    dropImg: "Drag and drop image here",
    edit: "Edit",
    editProduct: "Edit products and services",
    editService: "Edit products and services",
    emissionStatus: "Emission status",
    errorOperation: "Failed Operation",
    errors: {
      "1111Title": "The item has associated movements",
      1111: "To make it 'inventoryable' it cannot be linked to records, we recommend that you deactivate it and create a new one.",
      unknownError: "To avoid duplicating it, we recommend checking if it is already created before saving again. Do it <a target='_blank' href='https://app.alegra.com/item'>here</a>",
      unknownErrorTitle: "Check if this item is already available.",
      cantRemoveVariant: "The variant item cannot be removed or replaced",
      cantRemoveVariantTooltip: "The variant cannot be removed or replaced when it is associated to a document",
      decimal: "Only numerical values are allowed with the period (.) as a decimal separator",
      integer: "Only integer numbers are allowed",
      descriptionLength: "The maximum length of this field is 500 characters",
      nameDescriptionLengthMax: "If you are going to include it in an electronic invoice, the sum of the 'name' and the 'description' cannot exceed {{maxLength}} characters.",
      nameDescriptionLengthMaxTitle: "Shorten the item description",
      nameDescriptionLengthMin: "To include this item in an electronic invoice, the sum of the 'name' and the 'description' cannot be less than {{minLength}} characters.",
      nameDescriptionLengthMinTitle: "Make the name longer or add a description",
      nameLength: "The item name must contain a maximum of 150 characters.",
      form: "You must check the fields marked in red to continue",
      maxLength: "NEED TO BE DEFINED",
      required: "This field is required",
      selectedWarehouse: "This warehouse has already been selected",
      shouldNotBeNotApplicable: "The 'Not Applicable' unit of measure is no longer available. Choose a new unit from the catalog for your item.",
      atLeastOneWarehouse: "At least one warehouse must be selected",
      REP2001Title: "This exportable is already downloading!",
      REP2001: "Check your <a target='_blank' href='{{baseUrl}}report/exportables-history'>exportables history</a> and try again after the download is complete",
      REP2002Title: "You have several exportables queued!",
      REP2002: "We recommend that you wait for the download to finish before trying to export it again."
    },
    estimate: "Estimate",
    estimates: "Estimates",
    estimatesTableID: "Number",
    expirationDate: "Expiration date",
    export: "export",
    exportableHistory: "Exportable history",
    exportToExcel: "Export to Excel",
    exportToCSV: "Export to CSV",
    exportExcelSuccess: "Alegra is generating your excel file and it may take a few minutes. When the process is completed, the file will be sent to your email",
    exportInvoiceFieldsHelp: "Complete this information if the product you are creating will be used in export invoices.",
    exportItemsHint: "Extract the complete list of your items.",
    favorite: "Favorite",
    fieldsMarkedWith: "Fields marked with",
    finalOperation: "This operation cannot be undone.",
    fillFormHelp: "Create your inventory products and/or services that you offer to record in your sales. <a target='_blank' href='https://ayuda.alegra.com/create-products-and-services-in-alegra'>See more</a>",
    form: {
      product: "Product",
      kit: "Kit",
      service: "Service",
      showAdvancedForm: "Show advanced form",
      hideAdvancedForm: "Hide advanced form",
      mainSection: {
        title: "General information",
        helper: "Add the basic data to indentify your product.",
        customFieldsRequired: "Required Custom fields",
        productWithVariants: "Product with variants",
        customFieldsRequiredHelp: "Complete your required fields before creating your",
        productWithoutVariants: "Product without variants"
      },
      configurationSection: {
        title: "Configuration"
      },
      priceSection: {
        title: "Price",
        helper: "Indicate the sale value and the purchase cost of your",
        helperBasePrice: "The total price is calculated automatically or you can enter it to find the base price."
      },
      pricesListsSection: {
        title: "Prices lists",
        helper: "Assign some prices with fixed value or a discount percentage on the base price.",
        addPriceList: "Add price list"
      },
      customFieldsSection: {
        title: "Custom fields",
        helper: "Learn how to create custom fields <a href='https://ayuda.alegra.com/configura-informaci%C3%B3n-adicional-a-tus-productos-para-l' target='_blank'>here</a>."
      },
      warehousesSection: {
        title: "Inventory detail",
        helper: "Distribute and control the quantities of your products in different places.",
        info: "Add your product inventory information",
        titleError: "Add the initial quantity of your warehouse",
        bodyError: "You can do it from the inventory detail to have control of the units of your product.",
        initialQuantityHelp: "Add here the initial quantity of your product",
        selectWarehouse: "Select warehouse",
        addWarehouse: "Add warehouse"
      },
      kitSection: {
        title: "Kit",
        helper: "Select the products and their quantities to build a kit",
        changeWarehouse: "By doing this, you will have to choose the associated products again. Do you want to continue?",
        titleError: "Add the products that make up your kit.",
        bodyError: "You can assign the amount of each one to start selling it and have control of the available units and income.",
        componentInfo: "Add here one of the products of your kit",
        selectItem: "Select product",
        addProduct: "Add product"
      },
      variantsSection: {
        title: "Variants",
        helper: "Add attributes to categorize your products, such as size and color.",
        addVariant: "New variant",
        addOption: "New option",
        typeName: "Type the name here",
        editVariant: "Edit variant",
        selectVariant: "Select or create a variant to define its options",
        setupVariants: "Create qualities or activate the predefined options to classify your products.",
        configVariants: "Setup variants",
        radioButtonHelper: "Indicate if you handle products with variants such as color, size or other quality.",
        bodyError: "From the variants section you must select at least one option and indicate the quantity available in the warehouse of the ones you choose.",
        titleError: "Set up the variant section"
      },
      exportInvoiceColSection: {
        title: "Additional data for export invoice",
        helper: "Complete this information if the product you are creating will be used in export invoices."
      },
      exportInvoiceMexSection: {
        title: "Additional data for export invoice",
        helper: "Complete this information if the product you are creating will be used in export invoices.",
        tariffFraction: "Tariff fraction",
        foreignTradeUnit: "Foreign trade unit"
      },
      accountingConfigSection: {
        title: "Accounting configuration",
        helper: "Set up the accounting accounts in which the movements will be recorded."
      },
      imageSection: {
        productGallery: "gallery",
        productImages: "images",
        helperModal: "Add reference images for your"
      }
    },
    itemBasicForm: "Items basic form",
    images: "Images",
    itemDetailsTables: {
      invoices: "Invoices",
      bills: "Supplier Invoices",
      bill: "Supplier Invoice",
      creditNotes: "Credit notes",
      creditNote: "Credit note",
      debitNotes: "Debit notes",
      debitNote: "Debit note",
      estimates: "Estimates",
      estimate: "Estimate",
      estimatesTableID: "Number",
      remissions: "Remissions",
      remission: "Remission",
      remissionGuides: "Remission guides",
      remissionGuide: "Remission guide",
      adjustmentNotes: "Adjustment notes",
      adjustmentNote: "Adjustment note",
      purchaseOrders: "Purchase orders",
      purchaseOrder: "Purchase order",
      warehousesTransfers: "Warehouses transfers",
      warehousesTransfer: "Warehouses transfer",
      incomeDebitNotes: "Income debit notes",
      incomeDebitNote: "Income debit note",
      supportDocuments: "Support documents",
      supportDocument: "Support document",
      open: "open",
      invoiced: "invoiced",
      unbilled: "unbilled",
      charged: "charged",
      cancelled: "cancelled",
      voided: "voided",
      pending: "pending",
      emissionPending: "to stamp",
      emissionAccepted: "stamped",
      emissionRejected: "rejected",
      emissionWaiting: "in progress",
      emissionCancelled: "cancelled",
      emissionCancelledWaiting: "pending",
      draft: "draft",
      noStatus: "no status"
    },
    generalSettings: "General settings",
    generateExcelFile: "Generating Excel file",
    groupingCode: "SAT grouper",
    groupingCodeHelp: "To learn more about the SAT grouper, click",
    referenceHelp: "Add a unique code to identify your product. Example: CAS002",
    here: "here",
    hideDetail: "Hide detail",
    hideInStore: "Hide in store",
    serviceHelper: "Create the commercial or consulting activities that you offer to your clients.",
    productHelper: "Create the goods and merchandise that you sell and indicate if you want to have control of your inventory.",
    kitHelper: "Groups in a single item a set of products, services or a combination of both.",
    importFrom: "import from ",
    importItemsHint: "Create up to 1,000 new products or services.",
    inAnotherWarehouse: "in another warehouse",
    incomeDebitNote: "Client debit note",
    incomeDebitNotes: "Client debit notes",
    inInventory: "In inventory",
    initialQuantity: "Initial quantity",
    initialQuantityHelp: "It indicates the amount you start the inventory of this product.",
    inProcess: "In process",
    inRemissions: "In remissions",
    inventory: "Inventory",
    inventoryable: "Inventoryable",
    inventoryableHelper: "With this option activated, you will be able to control costs and quantities.",
    inventoryableTooltip: "This condition is irreversible, you will only be able to edit it on 'non-inventoriable' items that you haven't associated in documents or transactions.",
    inventoryableItem: "Inventory item",
    inventoryDetails: "Inventory details",
    inventoryDetailsHelp: "Easily control your inventory by including this information in your sales items.",
    inventoryHistory: "Inventory history",
    invoice: "invoice",
    itemActivated: "Item activated",
    itemCategory: "Item category",
    itemCategoryHelp: "Select the category to which your product and/or service belongs.",
    itemCategoryImg: "Image of the item category",
    itemDeactivated: "Item deactivated",
    itemImg: "Image of the item",
    itemsIncluded: "Items included",
    itemKitHelp: "Groups a set of products or services into a single item.",
    itemHistory: "Record",
    itemServiceHelp: "Activity that you offer to another person or company.",
    itemSimpleHelp: "Create service or product.",
    itemType: "Type of item",
    itemTypeHelp: "The type of item determines the characteristics to assign about your product or service.",
    itemTypeService: "Type of service",
    itemWithInventoryHelp: "Keep track of quantities and costs.",
    itemWithNoInventoryHelp: "Avoid keeping records of quantities and costs.",
    itemsWithVariants: "Item with variants",
    itemsWithVariantsHelp: "Quickly create products with variables such as size and color.",
    iva: {
      modalTitle: "Select the exempt products for the day without IVA",
      applyIVAButton: "Apply days without IVA",
      configIVA: "Setup items for the day without IVA",
      ivaSwitchHelp: "You can only activate this option on items that have at least an iva type tax associated to them",
      daysWithoutIvaTooltip: "Activate the items you want to sell during the days without IVA.",
      ivaCategoryTooltip: "Assign a category to the items you want to sell during the days without IVA, it is a requirement to invoice correctly.",
      category: "Category",
      ivaToday: "Today is the day without IVA",
      daysWithoutIva: "Days without IVA",
      editCategory: "Edit category",
      subTitle: "You can mark them one by one or select all your products in bulk, once your items are configured they will be available to invoice the next day without IVA. Find out everything you need to keep in mind to sell on the day without IVA.",
      the: "The",
      nextDay: "will be the next day without IVA",
      deactivateIVA: "Remove days without IVA",
      genre: "Genre",
      categoryIVAModalHeader: "Item category",
      categoryIVAModalDescription: "Select the category of your items for the days without IVA.",
      selectGenreCategoryIVA: "Category days without IVA",
      noIvaDays: "Days without IVA",
      setup: "Setup"
    },
    kit: "Kit",
    cabysPureLife: "¡Pure Life! 🦥",
    listFilteredEmpty: "It seems that there are no results for your search filters",
    listCabysDeprecatedEmpty: "All your items have a valid CAByS code at the Treasury.",
    listTitle: "products and services",
    listTitleHelp: "Create, edit and manage every detail of your sales items. <a target='_blank' href='https://ayuda.alegra.com/create-products-and-services-in-alegra'>See more</a>",
    linkToAdvancedForm: "Go to advanced form",
    loadAverageCost: "Load average cost",
    loadingAverageCost: "Loading average cost",
    loading: "Loading",
    loadingApp: "Loading Application",
    makeClick: "make click",
    mandatories: "required",
    massiveActions: "Massive actions",
    maximumQuantity: "Maximum quantity",
    maxQuantityHelp: "Activate an alert and when you buy this product you will know if you have reached the maximum inventory stock.",
    maximumSize: "Maximum size",
    message: "Message",
    minimumQuantity: "Minimum quantity",
    minQuantityHelp: "Activate an alert and when you sell this product you will know if you have reached the minimum inventory stock.",
    model: "Model",
    moreActions: "More actions",
    multipleSelectionHelp: "To learn more about multiple selection, ",
    name: "name",
    negativeSale: "Negative sale",
    negativeSaleHelper: "Sold without units available",
    new: {
      bill: "New bill",
      creditNote: "New credit note",
      debitNote: "New debit note",
      documentDisabledHelp: "The item is deactivated, if you want to create documents you must activate it again",
      estimate: "New estimate",
      field: "New field",
      incomeDebitNote: "New income debit note",
      invoice: "New invoice",
      option: "New option",
      product: "New product/service",
      purchaseOrder: "New purchaseOrder",
      remission: "New remission",
      remissionGuide: "New remission guide",
      transfer: "New transfer",
      variant: "New variant",
      supportDocument: "New support document",
      warehouse: "New warehouse"
    },
    newItemCategory: "New item category",
    newTax: "New tax",
    noBreakdown: "No breakdown",
    doesNotCauseTax: "Does not cause tax",
    no: "No",
    noCost: "The cost of this item is not defined. <b>Sale price: $ </b>",
    noContentText: "The search did not return any results",
    noFirstItemYet: "You have not created your first product/service yet!",
    noRowsToExport: "No records were found to export.",
    none: "None",
    nonInventoryableItem: "Non-inventory item",
    notFirstYet: "You have not yet created your first",
    observations: "observations",
    opResume: "Operation's resume",
    opResumeDescriptionp1: "Operation applied to ",
    opResumeDescriptionp2: " records, with the following results",
    originWarehouse: "Origin warehouse",
    paginationTexts: {
      page: "Page",
      of: "of",
      showing: "Displaying",
      resultsPerPage: "Results per page"
    },
    paid: "Paid",
    pending: "Pending",
    PENDING: "Pending",
    pressEnterNewOption: "Press ENTER to addd options",
    price: "price",
    priceList: "price list",
    priceLists: "price lists",
    priceWithoutTax: "Price without tax",
    print: "Print",
    product: "item",
    productKeyEmptySlot: "Enter product's name or code",
    products: "Items",
    publishAlegrastore: "Publish in Alegra Store",
    publishAlegrastoreHelperproduct: "Publish this product in your store",
    publishAlegrastoreHelperservice: "Publish this service in your store",
    publishAlegrastoreHelperkit: "Publish this kit in your store",
    publishAlegracatalogue: "Publish in Virtual Catalogue",
    publishAlegracatalogueHelperproduct: "Publish this product in your catalogue",
    publishAlegracatalogueHelperkit: "Publish this kit in your catalogue",
    publishAlegracatalogueHelperservice: "Publish this service in your catalogue",
    purchaseOrder: "Purchase order",
    purchaseOrders: "Purchase orders",
    quantity: "Quantity",
    record: "record",
    recipient: "Destinatario",
    reference: "reference",
    referenceType: "Type reference",
    rejected: "Rejected",
    rejectedByClient: "Rejected by client",
    remission: "Remission",
    remissions: "Remissions",
    theRemissionGuide: "the remission guide",
    remissionGuide: "Remission guide",
    inRemissionGuideS: "in remission guides",
    remissionGuideVoided: "The remission guide was successfully voided.",
    remissionGuideTransformedToOpen: "The remission guide was successfully converted to open.",
    remissionGuideDeleted: "The remission guide was successfully deleted.",
    remissionGuides: "Remission guides",
    remove: "Remove",
    result: "Result",
    salesInvoiceTableID: "Number",
    salePrice: "Selling price",
    salePriceHelp: "Indicates the selling price before tax",
    searchProduct: "Search item...",
    searchItemWithInventory: "Search inventory item",
    save: "Save",
    saveCreate: "Save and create new",
    search: "Search",
    seeDetail: "See detail",
    seeMore: "See more",
    select: "Select",
    selectYour: "Select your",
    selected: "Selected",
    selectItemType: "Select a type",
    service: "service",
    setUpAccounts: "Set up accounts",
    setUpInventoryAccounts: "Set up inventory accounts",
    setUpInventariablePurchaseAccounts: "Set up cost accounts",
    showInStore: "Show in store",
    showItemInStore: "Show item in store",
    showItemInStoreHelp: "With this option you can control whether sales items are visible or remain hidden in your online store",
    showMore: "Show more",
    showLess: "Show less",
    stamped_and_accepted: "Issued",
    stamped_and_rejected: "Rejected",
    status: "Status",
    statusSunat: "Sunat status",
    storage: "warehouse",
    storages: "warehouses",
    supportDocuments: "Support Documents",
    supportDocument: "Support document",
    supportDocumentDeleted: "El documento soporte fue eliminado exitosamente.",
    successfulOperation: "Successful operation",
    supplier: "Supplier",
    tariffHeading: "Tariff heading",
    tax: "Tax",
    taxType: "Type of tax",
    taxCreated: "The tax was successfully created",
    taxes: {
      typeIVA: "IVA",
      typeIEPS: "IEPS",
      typeOTRO: "Other taxes",
      typeLOCAL: "Locals",
      typeEXENTO: "IVA Exempt",
      typeIEPS_EXEMPT: "IEPS Exempt"
    },
    term: "Term",
    theFile: "the file",
    theInvoice: "the invoice",
    toClose: "Close",
    toFilter: "Filter",
    toPay: "To pay",
    total: "Total",
    totalCost: "Total cost",
    totalPrice: "Total price",
    trackInventory: "Track Inventory",
    trackNoInventory: "Do not tranck inventory",
    trackInventoryHelp: "They are items to which you take control of quantities and unit costs, usually they are tangible products.",
    transfer: "Transfer",
    transfers: "Transfers",
    transformToOpen: "transform to open",
    success: "Success",
    unit: "Unit",
    unitCost: "Initial cost",
    unitCostHelp: "Enter the acquisition value of your sales products.",
    unitMeasurement: "Measurement unit",
    unitMeasurementHelp: "Select a measurement reference for your product. Example: Unit, Kilogram, Liter.",
    unitMeasurementHelpOther: "Add a measurement reference to your inventory and variant items. Example: unit, kilogram, liter.",
    updating: "Updating",
    uploadImage: "Upload image",
    usePriceList: "Use price list",
    usePriceListHelp: "Assign different sales prices to your product or service.",
    value: "Value",
    variantItems: "Variant items",
    variant: "variant",
    variants: "variants",
    variantsHelp: "Customize every detail of your sales items by adding characteristics such as size, color or brand.<a target='_blank' href='https://ayuda.alegra.com/agrega-variantes-a-tus-productos-de-venta#paso2'>See more</a>",
    viewGallery: "Ver galería",
    visibleInstore: "Visible in shop",
    visibleIncatalogue: "Visible in catalogue",
    voided: "Voided",
    void: "void",
    wantToContinue: "Do you want to continue?",
    with: "with",
    withoutName: "without name",
    yes: "Yes"
  },
  itemCategoriesPage: {
    fillFormHelp: "Create new item categories to clasify products.",
    itemCategory: "Item category",
    itemCategoryCreated: "The item category has been successfully created",
    itemCategoryEdited: "The item category has been successfully edited",
    itemCategoryDeleted: "The item category has been successfully deleted",
    itemCategoryImg: "Image of the item category",
    listTitle: "Item categories",
    listTitleHelp: "Use item categories to clasify products.",
    new: {
      itemCategory: "New category"
    },
    errors: {
      26001: "The item category cannot be deleted",
      26002: "Already exist an item category with that name",
      26003: "Id is required",
      26004: "Item category not found",
      26005: "Name is required",
      26006: "The status value must be active or inactive",
      26007: "The field 'name' must be a string with at least one character.",
      26009: "The id must be an integer",
      26010: "The field 'description' must be a string.",
      26011: "The body must be an object.",
      26012: "The field 'image' is required.",
      26013: "The field 'fields' must be a string.",
      26014: "The field 'start' must be an integer greater than or equal to 0",
      26015: "The field 'limit' must be an integer between 0 and 30 inclusive.",
      26016: "The field 'metadata' must be boolean.",
      26017: "The field 'order_direction' must be equal to 'ASC' or 'DESC'",
      26018: "The field 'order_field' must be one of these values: 'name'.",
      1702: "The image field is required"
    },
    noFirstItemCategoryYet: "You have not yet created your first item category!"
  },
  customFieldsPage: {
    active: "Active",
    associatedProducts: "Associated products/services",
    barcode: "Barcode",
    create: "create",
    customField: "custom field",
    defaultValue: "Default Value",
    errros: {
      1801: "The field 'name' is required.",
      1802: "The field 'name' must be a string and should not be empty.",
      1803: "The field 'status' should be one of these values: 'active', 'inactive'.",
      1806: "The field 'type' is required.",
      1807: "The field 'type' should be one of these values: text, int, decimal, date, boolean, optionsList.",
      1808: "The field 'options' must be an unique array with at least one element.",
      1809: "The field 'key' should be one of these values: 'barcode', 'importRequest'.",
      1810: "The field 'options' is required when the field type is 'optionList'.",
      1811: "The field 'name' must be a string and should not be empty.",
      1812: "The field 'description' must be a string and should have less than 250 characters.",
      1813: "The field 'defaultValue' must be a string.",
      1814: "The field 'settings' must be an object.",
      1815: "The field 'isRequired' must be boolean.",
      1816: "The field 'printOnInvoices' must be boolean.",
      1817: "The body should be an object.",
      1818: "The field 'id' is required.",
      1819: "The field 'id' must be an integer.",
      1820: "The custom field does not exist.",
      1821: "The field 'start' must be an integer greater than or equal to 0.",
      1822: "The field 'limit' must be an integer between 0 and 30 inclusive.",
      1823: "The field 'metadata' must be boolean.",
      1824: "The field 'order_direction' must be equal to 'ASC' or 'DESC'.",
      1825: "The field 'order_field' must be one of these values: 'name'.",
      1826: "The field 'fields' must be a string."
    },
    fieldType: "Type of field",
    fillFormHelp: "Configure specific features to your products creating new additional fields",
    inactive: "Inactive",
    inactiveHelp: "This field is deactivated, to modify this information you must activate it again",
    invalidValueForType: "Default value is not appropriate for the field type",
    landingDescription: "Create custom fields to add extra information on your items, like the barcode.",
    listTitle: "Custom Fields",
    listTitleHelp: "Create and manage additional fields to add extra information to your items",
    modify: "Modify",
    new: {
      customField: "New custom field",
      nameHelp: "This will be the label that you will find in your custom field",
      typeHelp: "The type of field will indicate what data you want to record in your custom field",
      defaultValueHelp: "Set a default value for your custom field",
      requiredHelp: "Indicate if you want your custom field to be required",
      invoiceHelp: "Indicate if you want your custom field to be printed on your invoices next to the name of your items",
      pressEnter: "Press ENTER for add more options",
      option: "New option"
    },
    noFirstCustomFieldYet: "You have not created your first custom field yet!",
    options: "Options",
    printOnInvoices: "Print on invoices",
    required: "Required",
    showInItemVariants: "Show in item variants",
    unlink: "Remove",
    alreadyExist: "Already exist a custom field with that name."
  },
  pricesListsPage: {
    amountHelp: "Amount: It indicates a specific price for each product/sevices",
    cannotDeletePriceList: "To delete price lists, you must have the 'See list of all' permission enabled in the contacts section.",
    percentageHelp: "Percentage: It is calculated based on the price indicated in the general list",
    editPricesList: "Edit prices list",
    errors: {
      loadError: "There was problem while loading the prices list"
    },
    listTitle: "Prices lists",
    listTitleHelp: "Define special prices for your products and services.",
    percentage: "percentage",
    amount: "amount",
    pricesList: "prices list",
    main: "main",
    new: {
      pricesList: "New prices list"
    },
    noFirstPricesListYet: "You have not created your first prices list yet!",
    type: "type",
    true: "yes",
    false: "no"
  },
  attributesPage: {
    fillFormHelp: "Add extra information and customize the characteristics of your sales items"
  },
  variantAttributesPage: {
    active: "Active",
    associatedProducts: "Ítems asociados",
    errors: {
      loadVariants: "There was a problem while loading the variantes"
    },
    fillFormHelp: "Add the name of the variant and indicate the different options it can have",
    inactive: "Inactive",
    landingDescription: "Configure variable attributes that define the characteristics of your products, such as color and size.",
    listTitle: "Variants",
    listTitleHelp: "Create and manage variables to identify a product that has different characteristics",
    new: {
      variantAttribute: "New variant"
    },
    noFirstVariantAttributeYet: "You have not created your first variant yet!",
    notEditableHelp: "The general configuration cannot be edited in variants that have associated items, you can only add new options.",
    option: "Option",
    options: "Options",
    variantAttribute: "variant",
    alreadyExist: "Already exist a variant with that name."
  },
  inventoryAdjustmentsPage: {
    adjustmentTotal: "Adjusted total",
    adjustmentType: "Type of adjustment",
    confirmOriginChange: "By doing this, you will have to choose the associated products again. Do you want to continue?",
    costCenter: "Cost center",
    dateHelp: "Date on which the inventory adjustment was made",
    decrement: "Decrease",
    export: "Export inventory adjustment",
    unitCostWarning: {
      title: "Avoid editing the average cost!",
      content: "Editing this value will record an adjustment for the difference that could generate an accounting and tax error.",
      confirmButton: "Continue with modification"
    },
    exportAll: "export all",
    fillFormHelp: "Adjust quantities of your physical products by recording Increases or Decreases as increases or losses of merchandise. <a href='https://ayuda.alegra.com/ajustes-de-inventario' target='_blank' style='font-weight: bold;'>See more</a>",
    finalQuantity: "Final quantity",
    from: "from",
    to: "to",
    present: "present",
    prefix: "Prefix",
    today: "today",
    thisWeek: "this week",
    thisMonth: "this month",
    thisYear: "this year",
    before: "before",
    yesterday: "yesterday",
    lastWeek: "last week",
    lastMonth: "last month",
    lastYear: "last year",
    manual: "manual",
    inventoryAdjustment: "inventory adjustment",
    increment: "Increase",
    listTitle: "Inventory adjustments",
    listTitleHelp: "Control quantities of your inventory by registering Increases or Decreases. <a href='https://ayuda.alegra.com/ajustes-de-inventario' target='_blank' style='font-weight: bold;'>See more</a>",
    new: {
      inventoryAdjustment: "New inventory adjustment"
    },
    errors: {
      quantity: "The quantity must be greater than zero.",
      averageCost: "Error loading initial cost",
      loadNumberTemplates: "Error while loading numerations."
    },
    noFirstInventoryAdjustmentYet: "You have not yet created your first inventory adjustment!",
    number: "Number",
    numeration: "Numeration"
  },
  restrictedPage: {
    titleError: "You don't have permissions for access",
    bodyError: "It appears that you are not authorized to perform this action. For more information, contact your account manager",
    needPermission: "You need permission to continue",
    limitedUser: "Your user has a limited profile and you do not have permission to enter this area.",
    limitedUserAction: "Your user has a limited profile and you do not have permission to execute this action.",
    contactAdmin: "To access contact the administrator user.",
    contactInfo: "If you have any concerns write to us at ",
    goBack: "Go back"
  },
  warehousesPage: {
    addTitleHelp: "Create warehouses and distribution points for your products.",
    costCenter: "Cost center",
    district: "District",
    districtProvince: "District/Province",
    sunatCode: "SUNAT code",
    sunatCodeHelp: "It is the code assigned by SUNAT when you register your establishment. If it corresponds to your tax address, you must put '0000'.",
    listTitle: "Warehouses",
    errors: {
      sunatCode: "The Establishment code must have 4 alphanumerics characters"
    },
    listTitleHelp: "Create new warehouses to distribute and manage your inventory.",
    modify: "Edit",
    new: {
      warehouse: "New warehouse"
    },
    noFirstWarehouseYet: "You have not created your first warehouse yet!",
    warehouse: "warehouse",
    warehousesTransfer: "Warehouses Transfer"
  },
  warehouseTransfersPage: {
    code: "Code",
    confirmOriginChange: "By doing this, you will have to choose the associated products again. Do you want to continue?",
    date: "Date",
    destination: "Destination warehouse",
    errors: {
      atLeastOne: "You must select at least one item"
    },
    listTitle: "Warehouse transfers",
    listTitleHelp: "If you need help, <a href='https://ayudas.alegra.com/es/articles/1711667' target='_blank'>click here.</a>",
    observations: "Observations",
    origin: "Origin warehouse",
    new: {
      warehouseTransfer: "New warehouse transfer"
    },
    noFirstWarehouseTransferYet: "You have not created your first warehouse transfer yet!",
    quantityToTransfer: "Quantity to transfer",
    searchProduct: "Search item",
    transferedQuantity: "Transfered quantity",
    totalTransferred: "Total transferred",
    warehouseTransfer: "Warehouse transfers"
  }
});

/***/ }),

/***/ 9384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4050);

/* harmony default export */ __webpack_exports__["default"] = (_common__WEBPACK_IMPORTED_MODULE_0__["default"]);

/***/ }),

/***/ 7865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 1367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Add a measurement reference to your inventory and variant items. Example: unit, kilogram, liter."
  }
});

/***/ }),

/***/ 8009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 9924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    errors: {
      referenceLength: "The maximun length of this field is 20 characters."
    }
  }
});

/***/ }),

/***/ 1978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    itemImg: "Image of the product",
    itemType: "Type of product",
    referenceHelp: "Include a code with a maximum of 35 characters to identify your products or services.",
    errors: {
      nameLength: "Limit: 80 characters",
      referenceLength: "Limit: 35 characters"
    },
    itemTypeService: "Type of service",
    inventoryableItem: "Inventory product",
    listTitle: "Products and services",
    noFirstItemYet: "¡You have not yet created your first product/service!",
    product: "product"
  }
});

/***/ }),

/***/ 636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Add a measurement reference to your inventory and variant items. Example: unit, kilogram, liter."
  }
});

/***/ }),

/***/ 8813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Add a measurement reference to your inventory and variant items. Example: unit, kilogram, liter."
  }
});

/***/ }),

/***/ 3130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 5721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Add a measurement reference to your inventory and variant items. Example: unit, kilogram, liter."
  }
});

/***/ }),

/***/ 856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    errors: {
      referenceLength: "Keep in mind that if you are going to include this item in an electronic invoice, the reference must not exceed 20 characters."
    }
  }
});

/***/ }),

/***/ 6341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    referenceHelp: "Include a code with a maximum of 100 characters to identify your products or services.",
    inRemissions: "In sales notes",
    errors: {
      referenceLength: "Limit: 100 characters"
    },
    new: {
      remission: "New sale note"
    },
    itemDetailsTables: {
      remissions: "Sales notes"
    },
    remission: "Sale note",
    remissions: "Sales notes"
  }
});

/***/ }),

/***/ 2523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Add a measurement reference to your inventory and variant items. Example: unit, kilogram, liter."
  }
});

/***/ }),

/***/ 4444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Add a measurement reference to your inventory and variant items. Example: unit, kilogram, liter."
  }
});

/***/ }),

/***/ 3902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    accepted: "Aceptada",
    accept: "Aceptar",
    accounting: {
      account: "Cuenta Contable",
      code: "Código de la cuenta",
      cost: "Cuenta de costo de venta",
      costHelp: "Selecciona la cuenta contable en la que se registrarán el valor del costo de venta del producto.",
      credit: "Abono",
      debit: "Cargo",
      electronic: "Contabilidad electrónica",
      help: "Visualiza el movimiento contable de este comprobante. Puedes personalizar las cuentas\
        contables y sus códigos",
      inventory: "Cuenta de inventario",
      inventoryHelp: "Selecciona la cuenta contable en la que se registrarán los valores de entradas y salidas del producto.",
      nature: {
        label: "Naturaleza",
        credit: "Acreedora",
        debit: "Deudora"
      },
      number: "Número de la cuenta",
      thirdParty: "Tercero",
      label: "Contabilidad",
      setup: "Configuración contabilidad",
      title: "Cuenta",
      unassigned: "Sin asignar"
    },
    accountingSectionHelp: "Configura las cuentas contables en las que se registrarán los movimientos que realices con tu ítem de venta.",
    actions: "acciones",
    activate: "Activar",
    activated: "Activado",
    activateItem: "Activar ítem",
    activeFilters: "Filtros Activos",
    activeItems: "activos",
    inactiveItems: "inactivos",
    add: {
      label: "Agregar",
      payment: "Agregar pago",
      subAccount: "Agregar sub-cuenta contable",
      variant: "Agregar variante"
    },
    addAnotherList: "Agregar otra lista",
    addAnotherListHelp: "Indica el precio de tu item en esta lista. Si tu lista es de porcentaje, se mostrará el valor con el descuento indicado en tu lista",
    address: "dirección",
    addVariantOptionHelp: "Selecciona una variante para agregarle opciones",
    allocation: "Por aplicar",
    are3rd: "son",
    areYouSureYouWantTo: "¿Está seguro de que desea",
    attachedFiles: "Archivos adjuntos",
    attachFile: "Adjuntar archivo",
    attachItemImage: "Adjuntar imagen del ítem",
    averageCost: "Costo promedio",
    basePrice: "Precio base",
    brand: "Marca",
    belongsTo: "Pertenece a ",
    betweenStorages: "entre almacenes",
    bill: "Factura de proveedor",
    billItem: "Facturar este ítem",
    bills: "Facturas de Compras",
    buyItem: "Comprar este ítem",
    cancel: "Cancelar",
    cashedIn: "Cobrada",
    category: "cuenta contable",
    categoryHelp: "Selecciona la cuenta contable en la que se registrarán los valores por ventas del producto.",
    categoryModalHeader: "Selecciona la cuenta contable de ingreso a la que pertenece tu producto",
    categoryInventoryModalHeader: "Selecciona la cuenta contable de inventario a la que pertenece tu ítem",
    categoryPurchaseModalHeader: "Selecciona la cuenta contable de costos de venta a la que pertenece tu ítem",
    categoryModalHeaderDescription: "Personaliza tus cuentas contables, crea nuevas y agrégales el código desde los íconos en la columna de acciones.",
    categoryModalHeaderHelp: "Si necesitas ayuda para gestionar tus cuentas contables, haz",
    categoryRuleAutoFor: "Esta cuenta funciona de manera automática para los registros de ",
    categoryRuleConfirmText: "Esta cuenta contable tiene una configuración automática, al cambiar el nombre se afectarán todos los registros realizados hasta la fecha",
    cause: "Motivo",
    cabysDeprecated: "Código de producto eliminado",
    cabysDeprecatedHelp: "Activa para obtener el listado de ítems cuyo código de producto fue eliminado por Hacienda.",
    cabysDeprecatedSearch: "Este proceso tardará algunos segundos, si tienes muchos ítems sin código CAByS puedes usar la <a href='https://ayuda.alegra.com/es/agrega-el-c%C3%B3digo-cabys-a-tus-%C3%ADtems-de-venta-creados-en-alegra-contabilidad-costa-rica#:~:text=4.%20Actualiza%20de%20forma%20masiva%20el%20c%C3%B3digo%20(CAByS)%20en%20tus%20productos' target='_blank'>actualización masiva</a>.",
    cabysDeprecatedSearchTitle: "Buscando ítems sin código de producto 🔍",
    cabysHelp: "Ingresa el código de tu producto o servicio definido en el Cabys, si no lo conoces haz <a target='_blank' href='https://app.powerbi.com/view?r=eyJrIjoiZDdmNTBlYTktYmE0Ni00NGM3LWJhNzYtMGZhNjBlNTQyYTdmIiwidCI6IjYxOGQwYTQ1LTI1YTYtNDYxOC05ZjgwLThmNzBhNDM1ZWU1MiJ9'>clic aquí</a>.",
    checkIn: "Facturar",
    clickHere: "clic aquí",
    client: "Cliente",
    code: "Código",
    cost: "Costo",
    confirm: "Confirmar",
    contact: "Contacto",
    complete: "Completar",
    currency: "Moneda",
    create: "Crear",
    createdTitle: "Item creado exitosamente",
    createdMessage: "El item {{name}} ha sido agregado a tu inventario",
    editedTitle: "Item editado exitosamente",
    editedMessage: "El item {{name}} ha sido editado",
    deletedTitle: "Item eliminado exitosamente",
    deletedMessage: "El item {{name}} ha sido eliminado de tu inventario",
    creationDate: "Creación",
    creditNote: "Nota de crédito",
    creditNotes: "Notas de crédito",
    currentQuantity: "Cantidad actual",
    customFields: "Campos adicionales",
    customFieldsHelp: "Agrega información adicional a tus productos como fechas de vencimiento o códigos de barras.",
    date: "Fecha",
    deactivate: "Desactivar",
    deactivated: "Desactivado",
    debitNotes: "Notas débito",
    debitNote: "Nota débito",
    delete: "eliminar",
    deliveryDate: "Plazo de pago",
    description: "descripción",
    descriptionHelp: "Agrega detalles sobre tu producto o servicio.",
    distributeInWarehouses: "Distribuir en bodegas",
    distributeHelp: "Si necesitas ayuda para distribuir tus",
    document: "Documento",
    download: {
      pdf: "Descargar PDF",
      xml: "Descargar XML"
    },
    draft: "Borrador",
    dropImg: "Arrastre la imagen hasta aquí",
    edit: "Editar",
    editProduct: "Editar producto de venta",
    editService: "Editar servicio",
    emissionStatus: "Estado emisión",
    estimate: "Cotización",
    estimates: "Cotizaciones",
    estimatesTableID: "Número",
    expirationDate: "Vencimiento",
    export: "exportar",
    exportableHistory: "Historial de exportables",
    exportToExcel: "Exportar a Excel",
    exportToCSV: "Exportar a CSV",
    exportExcelSuccess: "Alegra está generando tu archivo de Excel y puede demorar unos minutos. Cuando se termine el proceso, el archivo será enviado a tu correo electrónico",
    exportInvoiceFieldsHelp: "Completa estos datos si el producto que estás creando se usará en facturas de exportación.",
    exportItemsHint: "Extrae el listado completo de tus ítems.",
    errorOperation: "Ha ocurrido un error",
    errors: {
      "1111Title": "El ítem tiene movimientos asociados",
      1111: "Para volverlo 'inventariable' no puede estar vinculado a registros, te recomendamos desactivarlo y crear uno nuevo.",
      unknownError: "Para evitar duplicarlo te recomendamos verificar si ya está creado antes de guardar de nuevo. Hazlo <a target='_blank' href='https://app.alegra.com/item'>aquí</a>",
      unknownErrorTitle: "Revisa si este ítem ya está disponible.",
      cantRemoveVariant: "El item variante no puede ser eliminado o reemplazado",
      cantRemoveVariantTooltip: "La variante no puede ser eliminada o reemplazada cuando tiene un documento asociado",
      decimal: "Solo se admiten valores numéricos con el punto (.) como separador decimal",
      integer: "Solo se admiten números enteros",
      descriptionLength: "El tamaño máximo de este campo es de 500 caracteres",
      form: "Debes verificar los campos marcados en rojo para continuar",
      nameDescriptionLengthMax: "Si vas a incluirlo en una factura electrónica, la suma del 'nombre' y la 'descripción' no puede superar {{maxLength}} caracteres.",
      nameDescriptionLengthMaxTitle: "Acorta la descripción del ítem",
      nameDescriptionLengthMin: "Para incluir este ítem en una factura electrónica, la suma del 'nombre' y la 'descripción' no puede ser menor a {{minLength}} caracteres.",
      nameDescriptionLengthMinTitle: "Alarga el nombre o agrega una descripción",
      nameLength: "El nombre del ítem debe contener un máximo de 150 caracteres.",
      shouldNotBeNotApplicable: "La unidad de medida 'No aplica' ya no está disponible. Elige una nueva unidad del catálogo para tu item.",
      tariffHeading: "La partida arancelaría debe contener 12 caracteres",
      required: "Este campo es obligatorio",
      selectedWarehouse: "Esta bodega ya ha sido seleccionada",
      atLeastOneWarehouse: "Debes seleccionar al menos una bodega",
      REP2001Title: "¡Este exportable ya se está descargando!",
      REP2001: "Revisa tu <a target='_blank' href='{{baseUrl}}report/exportables-history'>historial de exportables</a> y vuelve a intentarlo una vez finalice la descarga.",
      REP2002Title: "¡Tienes varios exportables en cola!",
      REP2002: "Te recomendamos esperar a que alguno termine de descargarse para intentar exportar este de nuevo."
    },
    fieldsMarkedWith: "Los campos marcados con",
    fillFormHelp: "Crea tus productos inventariables y/o servicios que ofreces para registrar en tus ventas. <a target='_blank' href='https://ayuda.alegra.com/crea-productos-de-inventario-y-servicios-no-inventariables-para-facturar-en-alegra#formulario'>Ver más</a>",
    finalOperation: "Esta operación no se puede deshacer.",
    form: {
      product: "Producto",
      kit: "Combo",
      service: "Servicio",
      showAdvancedForm: "Mostrar formulario avanzado",
      hideAdvancedForm: "Ocultar formulario avanzado",
      mainSection: {
        title: "Información general",
        helper: "Agrega los datos básicos para identificar tu producto.",
        productWithVariants: "Producto con variantes",
        customFieldsRequired: "Campos adicionales obligatorios",
        customFieldsRequiredHelp: "Completa tus campos obligatorios antes de crear tu",
        productWithoutVariants: "Producto sin variantes"
      },
      configurationSection: {
        title: "Configuración"
      },
      priceSection: {
        title: "Precio",
        helper: "Indica el valor de venta y el costo de compra de tu",
        helperBasePrice: "El precio total se calcula de forma automática o puedes indicarlo para encontrar el precio base."
      },
      pricesListsSection: {
        title: "Listas de precios",
        helper: "Asigna varios precios con valor fijo o un % de descuento sobre el precio base. <a href='https://ayuda.alegra.com/creaci%C3%B3n-de-listas-de-precio-en-alegra' target='_blank'>Ver más</a>.",
        addPriceList: "Agregar lista de precio"
      },
      customFieldsSection: {
        title: "Campos adicionales",
        helper: "Conoce cómo crear campos personalizables <a href='https://ayuda.alegra.com/configura-informaci%C3%B3n-adicional-a-tus-productos-para-l' target='_blank'>aquí</a>."
      },
      warehousesSection: {
        title: "Detalle de inventario",
        helper: "Distribuye y controla las cantidades de tus productos en diferentes lugares. <a href='https://ayuda.alegra.com/es/gestiona-tu-inventario-en-diferentes-bodegas-almacenes-dep%C3%B3sitos' target='_blank'>Ver más</a>.",
        info: "Agrega la información del inventario de tu producto",
        selectWarehouse: "Seleccionar bodega",
        titleError: "Agrega la cantidad inicial en tu bodega.",
        bodyError: "Puedes hacerlo desde el detalle del inventario para tener el control de las unidades de tu producto.",
        initialQuantityHelp: "Agrega aquí la cantidad inicial de tu producto",
        addWarehouse: "Agregar bodega"
      },
      kitSection: {
        title: "Combo",
        helper: "Selecciona los productos y sus cantidades para armar un combo",
        selectItem: "Seleccionar producto",
        titleError: "Agrega los productos que integran tu combo.",
        bodyError: "Podrás asignar la cantidad de cada uno para empezar a venderlo y tener el control de las unidades disponibles e ingresos.",
        componentInfo: "Agrega aquí uno de los productos de tu combo",
        changeWarehouse: "Al realizar esta acción deberás elegir de nuevo los productos asociados. ¿Deseas continuar?",
        addProduct: "Agregar producto"
      },
      variantsSection: {
        title: "Variantes",
        helper: "Agrega atributos para categorizar tus productos, como talla y color. <a href='https://ayuda.alegra.com/es/crea-atributos-y-campos-adicionales-para-tus-productos-de-venta' target='_blank'>Ver más</a>.",
        addVariant: "Nueva variante",
        addOption: "Nueva opción",
        typeName: "Escribe el nombre aquí",
        editVariant: "Editar variante",
        selectVariant: "Selecciona o crea una variante para definir sus opciones",
        setupVariants: "Crea cualidades o activa las opciones predefinidas para clasificar tus productos.",
        configVariants: "Configurar variantes",
        variantInfo: "Indica aquí las cantidades en tus bodegas",
        radioButtonHelper: "Indica si manejas productos con variantes como color, talla u otra cualidad.",
        bodyError: "Desde la sección variantes debes seleccionar por lo menos una opción e indicar la cantidad disponible en bodega de las que elijas.",
        titleError: "Configura la sección de variantes."
      },
      exportInvoiceColSection: {
        title: "Datos adicionales para factura de exportación",
        helper: "Completa estos datos si el producto que estás creando se usará en facturas de exportación."
      },
      exportInvoiceMexSection: {
        title: "Datos adicionales para factura de exportación",
        helper: "Completa estos datos si el producto que estás creando se usará en facturas de exportación.",
        tariffFraction: "Fracción arancelaria",
        foreignTradeUnit: "Unidad Aduana"
      },
      accountingConfigSection: {
        title: "Configuración contable",
        helper: "Configura las cuentas contables en las que se registrarán los movimientos."
      },
      imageSection: {
        productGallery: "Galería del",
        productImages: "Imágenes del",
        helperModal: "Agrega imágenes de referencia para tu"
      }
    },
    favorite: "Favorita",
    itemBasicForm: "Formulario básico de items",
    images: "Imágenes",
    generalSettings: "Configuración general",
    generateExcelFile: "Generando archivo de Excel",
    groupingCode: "Agrupador SAT",
    groupingCodeHelp: "Para saber más sobre el agrupador SAT, haz clic",
    referenceHelp: "Agrega un código único para identificar tu producto. Ejemplo: CAS002",
    here: "aquí",
    serviceHelper: "Crea las actividades comerciales o de consultoría que ofreces a tus clientes.",
    productHelper: "Crea los bienes y mercancías que vendes e indica si deseas tener el control de tu inventario.",
    kitHelper: "Agrupa en un solo ítem un conjunto de productos, servicios o una combinación entre ambos.",
    hideDetail: "Ocultar detalle",
    hideInStore: "Ocultar en tienda",
    importFrom: "importar desde ",
    importItemsHint: "Crea hasta 1.000 nuevos productos o servicios.",
    inAnotherWarehouse: "en otra bodega",
    incomeDebitNotes: "Notas débito clientes",
    incomeDebitNote: "Nota débito cliente",
    inInventory: "En inventario",
    initialQuantity: "Cantidad inicial",
    initialQuantityHelp: "Indica la cantidad con la que inicias el inventario de este producto.",
    inProcess: "En proceso",
    inRemissions: "En remisiones",
    inventory: "Inventario",
    inventoryableItem: "Ítem inventariable",
    inventoryable: "Inventariable",
    inventoryableHelper: "Mantén activada esta opción para llevar el control de costos y cantidades",
    inventoryableTooltip: "Esta condición es irreversible, solo la podrás editar en productos 'no inventariables' que no hayas asociado en documentos o transacciones.",
    inventoryDetails: "Detalles de inventario",
    inventoryDetailsHelp: "Controla fácilmente tu inventario incluyendo esta información en tus ítems de venta.",
    inventoryRecord: "Historial del inventario",
    itemActivated: "Ítem activado",
    itemCategory: "Categoría",
    itemCategoryHelp: "Selecciona la categoría a la que pertenece tu producto y/o servicio.",
    itemCategoryImg: "Imagen de la categoría",
    itemDeactivated: "Ítem desactivado",
    itemImg: "Imagen del Producto",
    itemsIncluded: "Ítems incluidos",
    itemKitHelp: "Agrupa en un solo ítem un conjunto de productos o servicios.",
    itemHistory: "Historial",
    itemServiceHelp: "Actividad que ofreces a otra persona o empresa.",
    itemSimpleHelp: "Crea un servicio o un producto.",
    itemType: "Tipo de ítem",
    itemTypeHelp: "Indica el tipo de tu producto",
    itemTypeService: "Tipo de servicio",
    itemWithInventoryHelp: "Lleva el  control de cantidades y costos.",
    itemWithNoInventoryHelp: "Evita llevar registros de cantidades y costos.",
    itemsWithVariants: "Item con variantes",
    itemsWithVariantsHelp: "Crea de forma rápida productos con variables como talla y color.",
    itemDetailsTables: {
      invoices: "Facturas de ventas",
      bills: "Facturas de compras",
      bill: "Factura de compra",
      creditNotes: "Notas de crédito",
      creditNote: "Nota de crédito",
      debitNotes: "Notas débito",
      debitNote: "Nota de débito",
      estimate: "Cotización",
      estimates: "Cotizaciones",
      estimatesTableID: "Número",
      remissions: "Remisiones",
      remissionGuide: "Guía de remisión",
      remissionGuides: "Guías de remisión",
      adjustmentNotes: "Notas de ajuste",
      adjustmentNote: "Nota de ajuste",
      purchaseOrders: "Órdenes de compra",
      warehousesTransfers: "Transferencias de bodegas",
      incomeDebitNotes: "Notas débito clientes",
      incomeDebitNote: "Nota débito cliente",
      supportDocuments: "Documentos soporte",
      supportDocument: "Documento soporte",
      open: "abierta",
      invoiced: "facturada",
      unbilled: "no facturada",
      charged: "cobrada",
      cancelled: "cancelada",
      voided: "anulada",
      pending: "por cobrar",
      emissionPending: "por emitir",
      emissionAccepted: "emitida",
      emissionRejected: "rechazada",
      emissionWaiting: "en proceso",
      emissionCancelled: "cancelado",
      emissionCancelledWaiting: "pendiente",
      draft: "borrador",
      noStatus: "Sin estado"
    },
    iva: {
      modalTitle: "Selecciona los productos exentos para el día sin IVA",
      applyIVAButton: "Aplicar días sin IVA",
      ivaSwitchHelp: "Solo puedes activar esta opción en productos que tengan asociado un impuesto de tipo IVA.",
      configIVA: "Configurar ítems para el día sin IVA",
      daysWithoutIvaTooltip: "Activa los ítems que deseas vender durante los días sin IVA.",
      ivaCategoryTooltip: "Asigna una categoría a los ítems que deseas vender durante los días sin IVA, es un requisito para facturar correctamente.",
      category: "Categoría",
      editCategory: "Editar categoría",
      deactivateIVA: "Quitar días sin IVA",
      daysWithoutIva: "Días sin IVA",
      the: "El",
      subTitle: "Puedes marcarlos uno por uno o seleccionar todos tus productos de forma masiva, una vez tus ítems estén configurados estarán disponibles para facturar el siguiente día sin IVA.  Conoce todo lo que debes tener en cuenta para <a href='https://ayuda.alegra.com/es/prep%C3%A1rate-y-factura-durante-los-d%C3%ADas-sin-iva-en-colombia' target='_blank'>vender en el día sin IVA.<a/>",
      ivaToday: "Hoy es el Día sin IVA",
      nextDay: "será el próximo día sin IVA",
      genre: "Género",
      categoryIVAModalHeader: "Categoría del ítem",
      categoryIVAModalDescription: "Selecciona la categoría de tus items para los días sin IVA.",
      noIvaDays: "Días sin IVA",
      selectCategoryIVA: "Categoría días sin IVA",
      setup: "Configuración"
    },
    kit: "Combo",
    cabysPureLife: "¡Pura vida! 🦥",
    listFilteredEmpty: "Parece que no hay resultados para tus filtros de búsqueda",
    listCabysDeprecatedEmpty: "Todos tus ítems tienen un código CAByS vigente en Hacienda.",
    listTitle: "Ítems de venta",
    listTitleHelp: "Crea, edita y administra cada detalle de tus ítems de venta. <a target='_blank' href='https://ayuda.alegra.com/crea-productos-de-inventario-y-servicios-no-inventariables-para-facturar-en-alegra'>Ver más</a>",
    linkToAdvancedForm: "Ir al formulario avanzado",
    loadAverageCost: "Cargar costo promedio",
    loadingAverageCost: "Cargando costo promedio",
    loading: "Cargando",
    loadingApp: "Cargando Aplicación",
    makeClick: "haz clic",
    mandatories: "obligatorios",
    massiveActions: "Acciones masivas",
    maximumQuantity: "Cantidad máxima",
    maxQuantityHelp: "Activa una alerta y al comprar este producto sabrás si has llegado al stock máximo de inventario.",
    maximumSize: "Tamaño máximo",
    message: "Mensaje",
    minimumQuantity: "Cantidad mínima",
    minQuantityHelp: "Activa una alerta y al vender este producto sabrás si has llegado al stock mínimo de inventario.",
    model: "Modelo",
    moreActions: "Más acciones",
    multipleSelectionHelp: "Para conocer más sobre la selección múltiple, haz",
    name: "nombre",
    negativeSale: "Venta en negativo",
    negativeSaleHelper: "Vende sin unidades disponibles",
    newItemCategory: "Nueva categoría",
    new: {
      bill: "Nueva factura de compra",
      creditNote: "Nueva nota de crédito",
      debitNote: "Nueva nota de débito",
      documentDisabledHelp: "El ítem está desactivado, si deseas crear documentos debes activarlo de nuevo",
      estimate: "Nueva cotización",
      field: "Nuevo campo",
      incomeDebitNote: "Nueva nota de débito cliente",
      invoice: "Nueva factura de venta",
      option: "Nueva opción",
      product: "Nuevo ítem de venta",
      purchaseOrder: "Nueva orden de compra",
      remission: "Nueva remisión",
      remissionGuide: "Nueva guía de remisión",
      transfer: "Nueva transferencia entre bodegas",
      variant: "Nueva variante",
      supportDocument: "Nuevo documento soporte",
      warehouse: "Nueva bodega"
    },
    newPriceList: "Nueva Lista de precios",
    newTax: "Nuevo Impuesto",
    no: "No",
    noCost: "El costo de este ítem no está definido. <b>Precio de venta: $</b>",
    noContentText: "La búsqueda no obtuvo ningún resultado",
    noFirstItemYet: "¡Aún no has creado tu primer ítem!",
    noRowsToExport: "No se encontraron registros que exportar.",
    nonInventoryableItem: "Ítem no inventariable",
    none: "Ninguno",
    notFirstYet: "Aún no has creado tu primer",
    observations: "observaciones",
    open: "abierta",
    opResume: "Resultados de la operación",
    opResumeDescriptionp1: "Se realizó la operación a un total de ",
    opResumeDescriptionp2: " registros, y se obtuvieron los siguientes resultados",
    paginationTexts: {
      page: "Página",
      of: "de",
      showing: "Mostrando",
      resultsPerPage: "Resultados por página"
    },
    paid: "Pagado",
    pending: "Por Cobrar",
    PENDING: "Por emitir",
    pressEnterNewOption: "Presione ENTER para agregar opciones",
    price: "precio",
    priceList: "lista de precios",
    priceLists: "listas de precios",
    priceWithoutTax: "Precio sin impuesto",
    print: "Imprimir",
    product: "Producto",
    productKey: "Código del producto o servicio",
    productKeyEmptySlot: "Escribe el nombre o el código del producto si lo sabes",
    products: "Productos",
    productsAndServices: "Productos y servicios",
    purchaseOrder: "Orden de compra",
    purchaseOrders: "Órdenes de compra",
    purchaseOrderCancel: "cancelar",
    purchasesOrdersTableID: "Código",
    publishAlegrastore: "Publicar en Alegra Tienda",
    publishAlegrastoreHelperproduct: "Publica este producto en tu tienda",
    publishAlegrastoreHelperkit: "Publica este combo en tu tienda",
    publishAlegrastoreHelperservice: "Publica este servicio en tu tienda",
    publishAlegracatalogue: "Publicar en Catálogo Virtual",
    publishAlegracatalogueHelperproduct: "Publica este producto en tu catálogo",
    publishAlegracatalogueHelperkit: "Publica este combo en tu catálogo",
    publishAlegracatalogueHelperservice: "Publica este servicio en tu catálogo",
    quantity: "Cantidad",
    record: "registro",
    recipient: "Destinatario",
    reference: "referencia",
    referenceType: "Tipo de referencia",
    rejected: "Rechazada",
    rejectedByClient: "Rechazada por el cliente",
    remission: "Remisión",
    remissions: "Remisiones",
    theRemissionGuide: "la guía de remisión",
    remissionGuide: "Guía de remisión",
    remissionGuideVoided: "La guía de remisión fue anulada exitosamente.",
    inRemissionGuides: "en guías de remisión",
    remissionGuideTransformedToOpen: "La guía de remisión fue convertida a abierta exitosamente.",
    remissionGuideDeleted: "La guía de remisión fue eliminada exitosamente.",
    remissionGuides: "Guías de remisión",
    remove: "Eliminar",
    result: "Resultado",
    salePrice: "Precio de venta",
    salePriceHelp: "Indica el precio de venta antes de impuesto",
    salesInvoices: "Facturas de Ventas",
    salesInvoiceTableID: "Número",
    sale: "Venta",
    saleInvoice: "Factura de Venta",
    supportDocuments: "Documentos Soporte",
    supportDocument: "Documento Soporte",
    supportDocumentDeleted: "El documento soporte fue eliminado exitosamente.",
    invoice: "Factura de Venta",
    save: "Guardar",
    saveCreate: "Guardar y crear otro",
    search: "Buscar",
    searchProduct: "Buscar producto facturable",
    searchItemWithInventory: "Buscar ítem inventariable",
    seeDetail: "Mostrar detalle",
    seeMore: "Ver más",
    select: "Seleccionar",
    selectYour: "Selecciona tus",
    selected: "Seleccionados",
    selectItemType: "Selecciona un tipo",
    service: "servicio",
    setUpAccounts: "Configurar cuentas contables",
    setUpInventoryAccounts: "Configurar cuentas de inventario",
    setUpInventariablePurchaseAccounts: "Configurar cuentas de costo",
    showInStore: "Mostrar en tienda",
    showItemInStore: "Mostrar ítem en tienda",
    showItemInStoreHelp: "Con esta opción puedes controlar si los ítems de venta son visibles o permanecen ocultos en tu tienda en línea",
    showMore: "Mostrar más",
    showLess: "Mostrar menos",
    storage: "Bodega",
    storages: "Bodegas",
    stamped_and_accepted: "Emitida",
    stamped_and_rejected: "Rechazada",
    status: "Estado",
    statusSunat: "Estado de Sunat",
    success: "Éxito",
    successfulOperation: "Operación exitosa",
    supplier: "Proveedor",
    tariffHeading: "Partida arancelaria",
    tax: "Impuesto",
    taxes: {
      typeIVA: "IVA",
      typeIEPS: "IEPS",
      typeOTRO: "Otros impuestos",
      typeLOCAL: "Locales",
      typeEXENTO: "IVA Exento",
      typeIEPS_EXEMPT: "IEPS Exento"
    },
    noBreakdown: "Sin desglose",
    doesNotCauseTax: "No causa impuesto",
    taxType: "Tipo de impuesto",
    taxCreated: "El impuesto ha sido creado exitosamente",
    theFile: "el archivo",
    theInvoice: "la factura",
    toClose: "Cerrar",
    toFilter: "Filtrar",
    toPay: "Por pagar",
    total: "Total",
    totalCost: "Costo total",
    totalPrice: "Precio Total",
    trackInventory: "Item Inventariable",
    trackInventoryHelp: "Son ítems a los que les llevas control de cantidades y costos unitarios, por lo general son ítems tangibles",
    transfers: "Transferencias",
    transfer: "Transferencia",
    transformToOpen: "convertir a abierta",
    unit: "Unidad",
    unitCost: "Costo inicial",
    unitCostHelp: "Ingresa el valor de adquisición de tus productos de venta.",
    unitMeasurement: "Unidad de medida",
    unitMeasurementHelp: "Selecciona una referencia de medición para tu producto. Ejemplo: Unidad, Kilogramo, Litro.",
    unitMeasurementHelpOther: "Agrega una referencia de medición a tus ítems inventariables y con variantes. Ejemplo: unidad, kilogramo, litro.",
    updating: "Actualizando",
    uploadImage: "Subir imagen",
    usePriceList: "Utilizar lista de precios",
    usePriceListHelp: "Asigna diferentes precios de venta a tu producto o servicio.",
    value: "Valor",
    variantItems: "Ítems variantes",
    variant: "variante",
    variants: "variantes",
    variantsHelp: "Personaliza cada detalle de tus ítems de venta agregando características como talla, color o marca.<a target='_blank' href='https://ayuda.alegra.com/agrega-variantes-a-tus-productos-de-venta#paso2'>Ver más</a>",
    viewGallery: "Ver galería",
    visibleInstore: "Visible en tienda",
    visibleIncatalogue: "Visible en catálogo",
    void: "anular",
    wantToContinue: "¿Deseas continuar?",
    with: "con",
    withoutName: "sin nombre",
    yes: "Si"
  },
  itemCategoriesPage: {
    fillFormHelp: "Crea nuevas categorías para clasificar tus productos y ubicarlos fácilmente. <a target='_blank' href='https://ayudas.alegra.com/es/articles/3660541'>Ver más.</a>",
    itemCategory: "Categoría",
    itemCategoryCreated: "La categoría de item ha sido creada exitosamente",
    itemCategoryEdited: "La categoría de item ha sido editada exitosamente",
    itemCategoryDeleted: "La categoría de item ha sido borrada exitosamente",
    itemCategoryImg: "Imagen de la categoría",
    listTitle: "Categorías",
    listTitleHelp: "Utiliza las categorías para clasificar tus productos.<a target='_blank' href='https://ayudas.alegra.com/es/articles/3660541'>Ver más.</a>",
    new: {
      itemCategory: "Nueva categoría"
    },
    errors: {
      26001: "La categoría del item no puede ser borrada porque tiene asociaciones.",
      26002: "Ya existe una categoría de item con ese nombre",
      26003: "El id es requerido",
      26004: "La categoría de item no fue encontrada",
      26005: "El nombre es requerido",
      26006: "El valor del estado debe ser 'activo' o 'inactivo'",
      26007: "El campo 'name' debe ser un string con al menos un caracter.",
      26009: "El id debe ser entero",
      26010: "El campo 'description' debe ser un string.",
      26011: "El body debe ser un objeto.",
      26012: "El campo 'image' es requerido.",
      26013: "El campo 'fields' debe ser un string.",
      26014: "El campo 'start' debe ser un entero mayor o igual que 0.",
      26015: "El campo 'limit' debe ser un entero entre 0 y 30 inclusive.",
      26016: "El campo 'metadata' debe ser booleano.",
      26017: "El campo 'order_direction' debe ser igual a 'ASC' o 'DESC'.",
      26018: "El campo 'order_field' debe ser uno de estos valores: 'name'.",
      1702: "El campo image es requerido"
    },
    noFirstItemCategoryYet: "¡Aún no has creado tu primera categoría!"
  },
  customFieldsPage: {
    active: "Activo",
    associatedProducts: "Ítems asociados",
    barcode: "Código de barra",
    create: "crea",
    customField: "campo adicional",
    defaultValue: "Valor por defecto",
    errros: {
      1801: "El campo 'name' es obligatorio.",
      1802: "No se puede asociar el campo al recurso indicado.",
      1803: "El campo 'status' debe ser igual a 'active' o 'inactive'.",
      1806: "El campo 'type' es obligatorio.",
      1807: "El campo 'type' debe ser uno de estos valores: 'text', 'int', 'decimal', 'date', 'boolean', 'optionsList'.",
      1808: "El campo 'options' debe ser un array de elementos únicos y debe tener al menos un elemento.",
      1809: "El campo 'key' solo puede tomar los valores: 'barcode', 'importRequest'.",
      1810: "El campo 'options' es requerido cuando el tipo de campo es 'optionsList'.",
      1811: "El campo 'name' debe ser un string y no debe estar vacío.",
      1812: "El campo 'description' debe ser un string y no debe exceder los 250 caracteres.",
      1813: "El campo 'defaultValue' debe ser un string.",
      1814: "El campo 'settings' debe ser un objeto.",
      1815: "El campo 'isRequired' debe ser booleano.",
      1816: "El campo 'printOnInvoices' debe ser booleano.",
      1817: "El body debe ser un objeto.",
      1818: "El 'id' es obligatorio.",
      1819: "El 'id' debe ser un entero.",
      1820: "El campo personalizable no existe.",
      1821: "El campo 'start' debe ser un entero mayor o igual que 0.",
      1822: "El campo 'limit' debe ser un entero entre 0 y 30 inclusive.",
      1823: "El campo 'metadata' debe ser booleano.",
      1824: "El campo 'order_direction' debe ser igual a 'ASC' o 'DESC'.",
      1825: "El campo 'order_field' debe ser uno de estos valores: 'name'.",
      1826: "El campo 'fields' debe ser un string."
    },
    fieldType: "Tipo de campo",
    fillFormHelp: "Configura características particulares a tus productos creando nuevos campos adicionales",
    inactive: "Inactivo",
    inactiveHelp: "Este campo esta desactivado, para modificar esta información debes volver a activarlo",
    invalidValueForType: "El valor por defecto no es apropiado para el tipo de valor",
    landingDescription: "Crea campos adicionales para agregar información extra en tus items, como el código de barras.",
    listTitle: "Campos adicionales",
    listTitleHelp: "Crea y gestiona campos adicionales para agregar información extra en tus items. <a target='_blank' href='https://ayuda.alegra.com/configura-informaci%C3%B3n-adicional-a-tus-productos-para-l'>Ver más</a>.",
    modify: "Modificar",
    new: {
      customField: "Nuevo campo adicional",
      nameHelp: "Esta será la etiqueta que encontrarás en tus campos adicionales",
      typeHelp: "El tipo de campo, indicará que dato deseas registrar en tu campo adicional",
      defaultValueHelp: "Establece un valor por defecto para tu campo adicional",
      requiredHelp: "Indica si deseas que el campo adicional sea obligatorio",
      invoiceHelp: "Indica si deseas que el campo adicional se imprima en tus facturas junto al nombre de tus items",
      pressEnter: "Presione ENTER para agregar opciones",
      option: "Nueva opción"
    },
    noFirstCustomFieldYet: "¡Aún no has creado tu primer campo adicional!",
    options: "Opciones",
    printOnInvoices: "Imprimir en facturas",
    required: "Obligatorio",
    showInItemVariants: "Mostrar en items variantes",
    unlink: "Desvincular",
    alreadyExist: "Ya existe un campo adicional con el nombre ingresado."
  },
  pricesListsPage: {
    amountHelp: "Valor: Indica un precio específico para cada ítem",
    cannotDeletePriceList: "Para eliminar listas de precio, debes tener activado el permiso de 'Ver listado de todos' en la sección de contactos.",
    percentageHelp: "Porcentaje: Se calcula con base en el precio indicado en la lista general",
    editPricesList: "Editar lista de precios",
    errors: {
      loadError: "Hubo un problema al cargar la lista de precios"
    },
    listTitle: "Listas de precios",
    listTitleHelp: "Define precios especiales para tus productos de venta. <a target='_blank' href='https://ayuda.alegra.com/creaci%C3%B3n-de-listas-de-precio-en-alegra'>Ver más</a>",
    percentage: "porcentaje",
    amount: "valor",
    pricesList: "lista de precios",
    main: "principal",
    new: {
      pricesList: "Nueva lista de precios"
    },
    noFirstPricesListYet: "¡Aún no has creado tu primera lista de precios!",
    type: "tipo",
    true: "si",
    false: "no"
  },
  attributesPage: {
    fillFor: "Agrega información adicional y personaliza las características de tus ítems de venta. Aprende cómo, haz clic <a href='https://ayuda.alegra.com/es/crea-atributos-y-campos-adicionales-para-tus-productos-de-venta'>aquí.</a>"
  },
  variantAttributesPage: {
    active: "Activo",
    associatedProducts: "Ítems asociados",
    errors: {
      loadVariants: "Ha ocurrido un error al cargar las variantes"
    },
    fillFormHelp: "Agrega el nombre de la variante e indica las diferentes opciones que puede tener",
    inactive: "Inactivo",
    landingDescription: "Configura atributos variables que definen las características de tus productos, como color y talla.",
    listTitle: "Variantes",
    listTitleHelp: "Crea y gestiona las variables para identificar un producto que tiene características diferentes",
    new: {
      variantAttribute: "Nueva variante"
    },
    noFirstVariantAttributeYet: "¡Aún no has creado tu primera variante!",
    notEditableHelp: "La configuración general no puede ser editada en variantes que tengan items asociados, únicamente puedes agregar nuevas opciones.",
    option: "Opción",
    options: "Opciones",
    variantAttribute: "variante",
    alreadyExist: "Ya existe una variante con el nombre ingresado."
  },
  inventoryAdjustmentsPage: {
    adjustmentTotal: "Total ajustado",
    adjustmentType: "Tipo de ajuste",
    confirmOriginChange: "Al realizar esta acción deberás elegir de nuevo los productos asociados. ¿Deseas continuar?",
    costCenter: "Centro de costo",
    decrement: "Disminución",
    export: "Exportar ajuste de inventario",
    unitCostWarning: {
      title: "¡Evita modificar el costo promedio!",
      content: "Al editar este valor se registrará un ajuste por la diferencia que podría generar un error contable y fiscal.",
      confirmButton: "Continuar con la modificación"
    },
    exportAll: "exportar todo",
    fillFormHelp: "Ajusta las cantidades de tus items inventariables registrando Incrementos o Disminuciones como aumentos o pérdidas de mercancía. <a href='https://ayuda.alegra.com/ajustes-de-inventario' target='_blank' style='font-weight: bold;'>Ver más</a>",
    finalQuantity: "Cantidad final",
    from: "desde",
    to: "hasta",
    present: "presente",
    prefix: "Prefijo",
    today: "hoy",
    thisWeek: "esta semana",
    thisMonth: "este mes",
    thisYear: "este año",
    before: "anterior",
    yesterday: "ayer",
    lastWeek: "semana anterior",
    lastMonth: "mes anterior",
    lastYear: "año anterior",
    manual: "manual",
    dateHelp: "Fecha en que se realizó el ajuste de inventario",
    increment: "Incremento",
    inventoryAdjustment: "ajuste de inventario",
    listTitle: "Ajustes de inventario",
    listTitleHelp: "Controla las cantidades de tu inventario registrando Aumentos o Disminuciones. <a href='https://ayuda.alegra.com/ajustes-de-inventario' target='_blank' style='font-weight: bold;'>Ver más</a>",
    new: {
      inventoryAdjustment: "Nuevo ajuste de inventario"
    },
    errors: {
      quantity: "La cantidad debe ser mayor que cero",
      averageCost: "Error al cargar el costo inicial",
      loadNumberTemplates: "Error al cargar las numeraciones."
    },
    noFirstInventoryAdjustmentYet: "¡Aún no has creado tu primer ajuste de inventario!",
    number: "Número",
    numeration: "Numeración"
  },
  restrictedPage: {
    titleError: "No cuentas con permisos para acceder",
    bodyError: "Parece que no estás autorizado para realizar esta acción. Si deseas más información, comunícate con el administrador de la cuenta.",
    needPermission: "Necesitas permiso para continuar",
    limitedUser: "Tu usuario tiene un perfil limitado y no cuentas con permiso para ingresar a esta zona.",
    limitedUserAction: "Tu usuario tiene un perfil limitado y no cuentas con permiso para realizar esta acción.",
    contactAdmin: "Para acceder comunícate con el usuario administrador.",
    contactInfo: "Si tienes inquietudes escríbenos en ",
    goBack: "Regresar"
  },
  warehousesPage: {
    addTitleHelp: "Crea los puntos de almacenamiento y distribución de tus productos. <a href='https://ayuda.alegra.com/es/gestiona-tu-inventario-en-diferentes-bodegas-almacenes-dep%C3%B3sitos' target='_blank'>Saber más</a>",
    costCenter: "Centro de costo",
    district: "Distrito",
    districtProvince: "Distrito/Provincia",
    sunatCode: "Código SUNAT",
    sunatCodeHelp: "Es el código asignado por SUNAT cuando das de alta tu establecimiento. En caso de que corresponda al de tu domicilio fiscal debes poner '0000'.",
    errors: {
      sunatCode: "El Código del establecimiento debe contener 4 caracteres alfanuméricos"
    },
    listTitle: "Bodegas",
    linkHelp: "<a href='https://ayuda.alegra.com/es/gestiona-tu-inventario-en-diferentes-bodegas-almacenes-dep%C3%B3sitos'>Ver más</a>",
    listTitleHelp: "Crea nuevas bodegas para distribuir y gestionar tu inventario.",
    modify: "Modificar",
    new: {
      warehouse: "Nueva bodega"
    },
    noFirstWarehouseYet: "¡Aún no has creado tu primera bodega!",
    warehouse: "bodega",
    warehousesTransfer: "Transferencia de bodegas"
  },
  warehouseTransfersPage: {
    code: "Código",
    confirmOriginChange: "Al realizar esta acción deberás elegir de nuevo los productos asociados. ¿Deseas continuar?",
    date: "Fecha",
    destination: "Bodega destino",
    errors: {
      atLeastOne: "Debe seleccionar al menos un item"
    },
    listTitle: "Transferencias entre bodegas",
    listTitleHelp: "Si necesitas ayuda, haz <a href='https://ayudas.alegra.com/es/articles/1711667' target='_blank'>clic aquí.</a>",
    observations: "Observaciones",
    origin: "Bodega origen",
    new: {
      warehouseTransfer: "Nueva transferencia entre bodegas"
    },
    noFirstWarehouseTransferYet: "¡Aún no has creado tu primera transferencia entre bodegas!",
    quantityToTransfer: "Cantidad a transferir",
    searchProduct: "Buscar ítem",
    transferedQuantity: "Cantidad transferida",
    totalTransferred: "Total transferido",
    warehouseTransfer: "Transferencias entre bodegas"
  }
});

/***/ }),

/***/ 2887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3902);

/* harmony default export */ __webpack_exports__["default"] = (_common__WEBPACK_IMPORTED_MODULE_0__["default"]);

/***/ }),

/***/ 2872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    bill: "Factura de proveedor",
    bills: "Facturas de Compras",
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    estimate: "Presupuesto",
    estimates: "Presupuesto",
    estimatesTableID: "Número",
    exportItemsHint: "Extrae el listado completo de tus productos.",
    itemActivated: "Producto activado",
    itemDeactivated: "Producto desactivado",
    listTitle: "Productos de venta",
    inventoryableHelper: "Mantené activada esta opción para llevar el control de costos y cantidades",
    inventoryableTooltip: "Esta condición es irreversible, solo la podrás editar en productos 'no inventariables' que no hayas asociado en documentos o transacciones.",
    negativeSaleHelper: "Vendé sin stock disponible",
    publishAlegrastoreHelperproduct: "Publicá este producto en tu tienda",
    publishAlegrastoreHelperkit: "Publicá este combo en tu tienda",
    publishAlegrastoreHelperservice: "Publicá este servicio en tu tienda",
    publishAlegracatalogueHelperproduct: "Publicá este producto en tu catálogo",
    publishAlegracatalogueHelperkit: "Publicá este combo en tu catálogo",
    publishAlegracatalogueHelperservice: "Publicá este servicio en tu catálogo",
    itemBasicForm: "Formulario básico de productos",
    errors: {
      "1111Title": "El producto tiene movimientos asociados"
    },
    new: {
      estimate: "Nuevo presupuesto",
      product: "Nuevo producto de venta",
      remission: "Nuevo remito"
    },
    form: {
      mainSection: {
        customFieldsRequiredHelp: "Completá tus campos obligatorios antes de crear tu"
      },
      warehousesSection: {
        titleError: "Agrega la cantidad inicial en tu depósito",
        bodyError: "Podés hacerlo desde el detalle del inventario para tener el control de las unidades de tu producto.",
        initialQuantityHelp: "Agregá acá la cantidad inicial de tu producto"
      },
      kitSection: {
        titleError: "Agregá los productos que integran tu combo.",
        bodyError: "Podrás asignar la cantidad de cada uno para empezar a facturarlo y tener el control de las unidades disponibles e ingresos.",
        componentInfo: "Agregá acá uno de los productos de tu combo"
      },
      variantsSection: {
        variantInfo: "Indicá acá las cantidades en tus depósitos",
        radioButtonHelper: "Indicá si manejás productos con variantes como color, talla u otra cualidad.",
        bodyError: "Desde la sección variantes debés seleccionar por lo menos una opción e indicar la cantidad disponible en depósito de las que elijás.",
        titleError: "Configura la sección de variantes."
      }
    },
    of: "de",
    product: "Producto",
    products: "Productos",
    purchaseOrders: "Órdenes de compra",
    remissions: "Remitos",
    remission: "Remito",
    sale: "Venta",
    saleInvoice: "Factura de Venta",
    salesInvoices: "Facturas de Ventas",
    salesInvoiceTableID: "Número",
    storage: "Depósito",
    storages: "Depósitos",
    transfers: "Transferencia"
  },
  warehouseTransfersPage: {
    destination: "Depósito destino",
    errors: {
      atLeastOne: "Debe seleccionar al menos un producto"
    },
    listTitle: "Movimiento entre depósitos",
    listTitleHelp: "Si necesitás ayuda, hacé <a href='https://ayudas.alegra.com/es/articles/1711667' target='_blank'>clic acá.</a>",
    origin: "Depósito de origen",
    new: {
      warehouseTransfer: "Nuevo movimiento entre depósitos"
    },
    noFirstWarehouseTransferYet: "¡Todavía no creaste tu primer movimiento entre depósitos!",
    quantityToTransfer: "Cantidad a transferir",
    searchProduct: "Buscar producto",
    transferedQuantity: "Cantidad transferida"
  },
  attributesPage: {
    fillFormHelp: "Agregá información adicional y personalizá las características de tus productos de venta. Aprendé cómo, haz clic <a href='https://ayuda.alegra.com/es/crea-atributos-y-campos-adicionales-para-tus-productos-de-venta'>aquí.</a>"
  },
  pricesListsPage: {
    cannotDeletePriceList: "Para eliminar listas de precio, necesitás tener activado el permiso de 'Ver listado de todos' en la sección de contactos."
  },
  warehousesPage: {
    listTitle: "Depósitos",
    listTitleHelp: "Crea nuevos depósitos para distribuir y gestionar tu inventario.",
    new: {
      warehouse: "Nuevo depósito"
    },
    noFirstWarehouseYet: "¡Aún no has creado tu primer depósito!",
    warehouse: "depósito",
    warehousesTransfer: "Transferencia de depósitos"
  }
});

/***/ }),

/***/ 2692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    estimates: "Cotizaciones",
    estimate: "Cotización",
    estimatesTableID: "Número",
    bills: "Facturas de Compras",
    bill: "Factura de proveedor",
    salesInvoices: "Facturas de Ventas",
    saleInvoice: "Factura de Venta",
    salesInvoiceTableID: "Folio",
    remissions: "Remisiones",
    remission: "Remisión",
    of: "de",
    sale: "Venta",
    product: "Ítem",
    products: "Ítems",
    purchaseOrders: "Órdenes de compra",
    transfers: "Transferencia",
    unitMeasurementHelp: "Agrega una referencia de medición a tus ítems inventariables y con variantes. Ejemplo: unidad, kilogramo, litro.",
    storage: "Bodega",
    storages: "Bodegas"
  }
});

/***/ }),

/***/ 9927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    salesInvoices: "Facturas de Ventas",
    salesInvoiceTableID: "Número",
    bills: "Facturas de Compras",
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    editProduct: "Editar ítem de venta",
    errors: {
      tariffHeading: "La partida arancelaria debe tener máximo 10 dígitos"
    },
    estimates: "Cotizaciones",
    estimatesTableID: "Número",
    remissions: "Remisiones",
    of: "de",
    sale: "Venta",
    product: "Ítem",
    fillFormHelp: "Crea tus productos inventariables y/o servicios que ofreces para registrar en tus ventas. <a target='_blank' href='https://ayuda.alegra.com/es/crea-productos-de-inventario-y-servicios-no-inventariables-para-facturar-en-alegra-colombia'>Ver más</a>",
    products: "Ítems",
    purchaseOrders: "Órdenes de compra",
    transfers: "Transferencia",
    storage: "Bodega",
    storages: "Bodegas",
    estimate: "Cotización",
    bill: "Factura de proveedor",
    saleInvoice: "Factura de Venta",
    remission: "Remisión"
  }
});

/***/ }),

/***/ 1874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    estimates: "Cotizaciones",
    estimatesTableID: "Número",
    bills: "Facturas de Compras",
    salesInvoices: "Ventas",
    salesInvoiceTableID: "Folio",
    remissions: "Remisiones",
    errors: {
      referenceLength: "El tamaño máximo de este campo es de 20 caracteres"
    },
    of: "de",
    sale: "Venta",
    product: "Ítem",
    products: "Ítems",
    purchaseOrders: "Órdenes de compra",
    transfers: "Transferencia",
    storage: "Bodega",
    storages: "Bodegas",
    estimate: "Cotización",
    bill: "Factura de proveedor",
    saleInvoice: "Factura de Venta",
    remission: "Remisión"
  }
});

/***/ }),

/***/ 4681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    salesInvoices: "Facturas de Ventas",
    salesInvoiceTableID: "Folio",
    bill: "Factura de proveedor",
    bills: "Facturas de Compras",
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    exportItemsHint: "Extrae el listado completo de tus productos.",
    estimate: "Cotización",
    estimates: "Cotizaciones",
    estimatesTableID: "Número",
    referenceHelp: "Código de máximo 35 caracteres que te servirá para identificar tus productos o servicios.",
    errors: {
      nameLength: "Usa máximo 80 caracteres",
      referenceLength: "Máximo 35 caracteres"
    },
    form: {
      warehousesSection: {
        titleError: "Agrega la cantidad inicial en tu almacén.",
        bodyError: "Puedes hacerlo desde el detalle del inventario para tener el control de las unidades de tu producto.",
        initialQuantityHelp: "Agrega aquí la cantidad inicial de tu producto"
      },
      variantsSection: {
        variantInfo: "Indica aquí las cantidades en tus almacenes",
        bodyError: "Desde la sección variantes debes seleccionar por lo menos una opción e indicar la cantidad disponible en almacén de las que elijas.",
        titleError: "Configura la sección de variantes."
      }
    },
    fillFormHelp: "Crea tus productos inventariables y/o servicios que ofreces para registrar en tus ventas. <a target='_blank' href='https://ayuda.alegra.com/es/crea-productos-inventariables-y-servicios-para-agilizar-tu-facturaci%C3%B3n-alegra-republica-dominicana'>Ver más</a>",
    listTitleHelp: "Crea, edita y administra cada detalle de tus productos y servicios. <a target='_blank' href='https://ayuda.alegra.com/es/crea-productos-inventariables-y-servicios-para-agilizar-tu-facturaci%C3%B3n-alegra-republica-dominicana'>Ver más</a>",
    importItemsHint: "Crea hasta 1.000 nuevos productos de venta desde un archivo de Excel",
    itemActivated: "Producto activado",
    itemDeactivated: "Producto desactivado",
    itemType: "Tipo de producto",
    itemTypeService: "Tipo de servicio",
    itemsWithVariants: "Producto con variantes",
    inRemissions: "En conduces",
    inventoryableItem: "Producto inventariable",
    listTitle: "Productos y servicios",
    noFirstItemYet: "¡Aún no has creado tu primer producto/servicio!",
    remissions: "Conduces",
    of: "de",
    sale: "Venta",
    new: {
      documentDisabledHelp: "El producto/servicio está desactivado, si deseas crear documentos debes activarlo de nuevo",
      product: "Nuevo producto/servicio"
    },
    itemBasicForm: "Formulario básico de productos",
    purchaseOrders: "Órdenes de compra",
    remission: "Conduce",
    saleInvoice: "Factura de Venta",
    searchProduct: "Buscar un producto/servicio...",
    storage: "Almacén",
    storages: "Almacenes",
    trackInventory: "Producto Inventariable",
    trackNoInventory: "Producto no Inventariable",
    trackInventoryHelp: "Son productos a los que les llevas control de cantidades y costos unitarios, por lo general son productos tangibles",
    transfers: "Transferencia"
  },
  warehouseTransfersPage: {
    code: "Código",
    date: "Fecha",
    destination: "Almacén destino",
    errors: {
      atLeastOne: "Debe seleccionar al menos un producto"
    },
    listTitle: "Transferencias entre almacenes",
    listTitleHelp: "Si necesitas ayuda, haz <a href='https://ayudas.alegra.com/es/articles/1711667'>clic aquí.</a>",
    observations: "Observaciones",
    origin: "Almacén origen",
    new: {
      warehouseTransfer: "Nueva transferencia entre almacenes"
    },
    noFirstWarehouseTransferYet: "¡Aún no has creado tu primera transferencia entre almacenes!",
    searchProduct: "Buscar producto"
  },
  attributesPage: {
    fillFormHelp: "Agrega información adicional y personaliza las características de tus productos de venta. Aprende cómo, haz clic <a href='https://ayuda.alegra.com/es/crea-atributos-y-campos-adicionales-para-tus-productos-de-venta'>aquí.</a>"
  },
  warehousesPage: {
    listTitle: "Almacenes",
    listTitleHelp: "Crea nuevos almacenes para distribuir y gestionar tu inventario.",
    new: {
      warehouse: "Nuevo almacén"
    },
    noFirstWarehouseYet: "¡Aún no has creado tu primer almacén!",
    warehouse: "almacén",
    warehousesTransfer: "Transferencia de almacenes"
  }
});

/***/ }),

/***/ 7116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    bill: "Factura de proveedor",
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    estimate: "Cotización",
    estimates: "Cotizaciones",
    estimatesTableID: "Número",
    bills: "Facturas de Compras",
    salesInvoices: "Facturas de Ventas",
    salesInvoiceTableID: "Folio",
    remissions: "Albaranes",
    of: "de",
    sale: "Venta",
    product: "Ítem",
    products: "Ítems",
    purchaseOrders: "Órdenes de compra",
    remission: "Albarán",
    saleInvoice: "Factura de Venta",
    storage: "Bodega",
    storages: "Bodegas",
    transfers: "Transferencia",
    unitMeasurementHelp: "Agrega una referencia de medición a tus ítems inventariables y con variantes. Ejemplo: unidad, kilogramo, litro."
  }
});

/***/ }),

/***/ 9425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Agrega una referencia de medición a tus ítems inventariables y con variantes. Ejemplo: unidad, kilogramo, litro."
  }
});

/***/ }),

/***/ 2996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    accounting: {
      code: "Número de la cuenta"
    },
    attachItemImage: "Adjuntar imagen del producto",
    bill: "Factura de proveedor",
    billItem: "Facturar este producto",
    bills: "Facturas de compra",
    buyItem: "Comprar este producto",
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    distributeInWarehouses: "Distribuir en almacenes",
    exportItemsHint: "Extrae el listado completo de tus productos.",
    errors: {
      "1111Title": "El producto tiene movimientos asociados",
      selectedWarehouse: "Este almacén ya ha sido seleccionado"
    },
    estimates: "Cotizaciones",
    estimate: "Cotización",
    estimatesTableID: "Folio",
    form: {
      warehousesSection: {
        titleError: "Agrega la cantidad inicial en tu almacén.",
        bodyError: "Puedes hacerlo desde el detalle del inventario para tener el control de las unidades de tu producto.",
        initialQuantityHelp: "Agrega aquí la cantidad inicial de tu producto"
      },
      variantsSection: {
        variantInfo: "Indica aquí las cantidades en tus almacenes",
        bodyError: "Desde la sección variantes debes seleccionar por lo menos una opción e indicar la cantidad disponible en almacén de las que elijas.",
        titleError: "Configura la sección de variantes."
      }
    },
    fillFormHelp: "Crea tus productos inventariables y/o servicios que ofreces para registrar en tus ventas. <a target='_blank' href='https://ayuda.alegra.com/es/crea-tus-productos-y-servicios-para-facturar-cfdi-4.0-m%C3%A9xico'>Ver más</a>",
    listTitleHelp: "Crea, edita y administra cada detalle de tus ítems de venta. <a target='_blank' href='https://ayuda.alegra.com/es/crea-tus-productos-y-servicios-para-facturar-cfdi-4.0-m%C3%A9xico'>Ver más</a>",
    importItemsHint: "Crea hasta 1.000 nuevos productos desde un archivo de Excel",
    inventoryableItem: "Producto inventariable",
    itemActivated: "Producto activado",
    itemDeactivated: "Producto desactivado",
    itemsIncluded: "Productos incluidos",
    itemType: "Tipo de producto",
    itemBasicForm: "Formulario básico de productos",
    inAnotherWarehouse: "en otro almacén",
    nonInventoryableItem: "Producto no inventariable",
    kit: "Kit",
    listTitle: "Productos de venta",
    new: {
      documentDisabledHelp: "El producto está desactivado, si deseas crear documentos debes activarlo de nuevo",
      product: "Nuevo producto de venta",
      transfer: "Nueva transferencia entre almacenes",
      warehouse: "Nuevo almacén"
    },
    of: "de",
    product: "Producto",
    productKey: "Clave de producto",
    products: "Productos",
    purchaseOrders: "Órdenes de compra",
    remissions: "Remisiones",
    remission: "Remisión",
    sale: "Venta",
    saleInvoice: "Factura de Venta",
    salesInvoices: "Facturas de venta",
    salesInvoiceTableID: "Folio",
    SAT: "Para saber más sobre el agrupador",
    storage: "Almacén",
    storages: "Almacenes",
    trackInventory: "Producto Inventariable",
    trackInventoryHelp: "Son productos a los que les llevas control de cantidades y costos unitarios, por lo general son productos tangibles",
    transfers: "Transferencias",
    void: "cancelar"
  },
  customFieldsPage: {
    associatedProducts: "Productos asociados"
  },
  warehouseTransfersPage: {
    code: "Código",
    date: "Fecha",
    destination: "Almacén destino",
    errors: {
      atLeastOne: "Debe seleccionar al menos un producto"
    },
    listTitle: "Transferencias entre almacenes",
    listTitleHelp: "Si necesitas ayuda, haz <a href='https://ayudas.alegra.com/es/articles/1711667' target='_blank'>clic aquí.</a>",
    observations: "Observaciones",
    origin: "Almacén origen",
    new: {
      warehouseTransfer: "Nueva transferencia entre almacenes"
    },
    noFirstWarehouseTransferYet: "¡Aún no has creado tu primera transferencia entre almacenes!",
    searchProduct: "Buscar producto"
  },
  attributesPage: {
    fillFormHelp: "Agrega información adicional y personaliza las características de tus productos de venta. Aprende cómo, haz clic <a href='https://ayuda.alegra.com/es/crea-atributos-y-campos-adicionales-para-tus-productos-de-venta'>aquí.</a>"
  },
  warehousesPage: {
    listTitle: "Almacenes",
    listTitleHelp: "Crea nuevos almacenes para distribuir y gestionar tu inventario.",
    new: {
      warehouse: "Nuevo almacén"
    },
    noFirstWarehouseYet: "¡Aún no has creado tu primer almacén!",
    warehouse: "almacén",
    warehousesTransfer: "Transferencia de almacenes"
  }
});

/***/ }),

/***/ 1558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Agrega una referencia de medición a tus ítems inventariables y con variantes. Ejemplo: unidad, kilogramo, litro."
  }
});

/***/ }),

/***/ 9964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    bill: "Factura de proveedor",
    bills: "Facturas de Compras",
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    estimate: "Cotización",
    estimates: "Cotizaciones",
    estimatesTableID: "Número",
    kit: "Kit",
    of: "de",
    errors: {
      referenceLength: "Ten en cuenta que si vas a incluir este ítem en una factura electrónica, la referencia no debe superar 20 caracteres."
    },
    product: "Ítem",
    products: "Ítems",
    purchaseOrders: "Órdenes de compra",
    remission: "Reporte de entrega",
    remissions: "Reportes de entrega",
    sale: "Venta",
    saleInvoice: "Factura de Venta",
    salesInvoices: "Facturas de Ventas",
    salesInvoiceTableID: "Folio",
    storage: "Bodega",
    storages: "Bodegas",
    transfers: "Transferencia"
  }
});

/***/ }),

/***/ 3570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    bill: "Factura de proveedor",
    bills: "Facturas de Compras",
    creditNotes: "Notas de crédito",
    debitNotes: "Notas de débito",
    estimates: "Cotizaciones",
    estimate: "Cotización",
    estimatesTableID: "Correlativo",
    inRemissions: "En notas de venta",
    itemDetailsTables: {
      remissions: "Notas de venta"
    },
    referenceHelp: "Código de máximo 100 caracteres que te servirá para identificar tus productos o servicios.",
    new: {
      remission: "Nueva nota de venta"
    },
    errors: {
      referenceLength: "Máximo 100 caracteres"
    },
    form: {
      warehousesSection: {
        titleError: "Agrega la cantidad inicial en tu almacén.",
        bodyError: "Puedes hacerlo desde el detalle del inventario para tener el control de las unidades de tu producto.",
        initialQuantityHelp: "Agrega aquí la cantidad inicial de tu producto"
      },
      variantsSection: {
        variantInfo: "Indica aquí las cantidades en tus almacenes",
        bodyError: "Desde la sección variantes debes seleccionar por lo menos una opción e indicar la cantidad disponible en almacén de las que elijas.",
        titleError: "Configura la sección de variantes."
      }
    },
    of: "de",
    product: "Ítem",
    productKey: "Código producto SUNAT",
    products: "Ítems",
    purchaseOrders: "Órdenes de compra",
    remission: "Nota de venta",
    remissions: "Notas de venta",
    sale: "Venta",
    saleInvoice: "Factura de Venta",
    salesInvoices: "Ventas",
    salesInvoiceTableID: "Correlativo",
    storage: "Almacén",
    storages: "Almacenes",
    transfers: "Transferencia"
  },
  warehousesPage: {
    listTitle: "Almacenes",
    listTitleHelp: "Crea nuevos almacenes para distribuir y gestionar tu inventario.",
    new: {
      warehouse: "Nuevo almacén"
    },
    noFirstWarehouseYet: "¡Aún no has creado tu primer almacén!",
    warehouse: "almacén",
    warehousesTransfer: "Transferencia de almacenes"
  },
  warehouseTransfersPage: {
    destination: "Almacén destino",
    listTitle: "Transferencias entre almacenes",
    origin: "Almacén origen",
    new: {
      warehouseTransfer: "Nueva transferencia entre almacenes"
    },
    noFirstWarehouseTransferYet: "¡Aún no has creado tu primera transferencia entre almacenes!"
  }
});

/***/ }),

/***/ 6756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Agrega una referencia de medición a tus ítems inventariables y con variantes. Ejemplo: unidad, kilogramo, litro."
  }
});

/***/ }),

/***/ 4419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
  itemsPage: {
    unitMeasurementHelp: "Agrega una referencia de medición a tus ítems inventariables y con variantes. Ejemplo: unidad, kilogramo, litro."
  }
});

/***/ }),

/***/ 899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getDictonaryFromWidget: function() { return /* binding */ getDictonaryFromWidget; },
/* harmony export */   getLanguageFilesContents: function() { return /* binding */ getLanguageFilesContents; }
/* harmony export */ });
/* harmony import */ var _Users_karelito00_Documents_Work_Alegra_Items_app_alegra_items_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2274);
/* harmony import */ var _Users_karelito00_Documents_Work_Alegra_Items_app_alegra_items_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3240);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3600);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6770);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3114);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1624);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1000);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1117);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2047);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8534);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _alegradev_smile_ui_alegra__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3213);
/* harmony import */ var _alegradev_smile_ui_alegra__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_alegradev_smile_ui_alegra__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8517);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_es__WEBPACK_IMPORTED_MODULE_11__);













/**
 * Fetch the languages files and return it's content merged
 * @param {String} languageString User lenguage. Formats: 'es' | 'es_CO'.
 * @param {String} appVersion Alegra User versión (country).
 * @returns {Object} Language files content merged
 */
function getLanguageFilesContents(_x, _x2) {
  return _getLanguageFilesContents.apply(this, arguments);
}
function _getLanguageFilesContents() {
  _getLanguageFilesContents = (0,_Users_karelito00_Documents_Work_Alegra_Items_app_alegra_items_node_modules_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/(0,_Users_karelito00_Documents_Work_Alegra_Items_app_alegra_items_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().mark(function _callee(languageString, appVersion) {
    var lc, languageFile, languageCountryFile;
    return (0,_Users_karelito00_Documents_Work_Alegra_Items_app_alegra_items_node_modules_babel_runtime_helpers_esm_regeneratorRuntime_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // Parse languageString to get Language and Country
          // It could be in one of this formats: 'es' | 'es_CO'
          lc = parseLanguageString(languageString); // If country is not present on languageString, parse appVersion to get the country.
          if (!lc.country) {
            lc.country = _alegradev_smile_ui_alegra__WEBPACK_IMPORTED_MODULE_10__.countriesMapping[appVersion];
          }
          _context.prev = 2;
          _context.next = 5;
          return __webpack_require__(8476)("./".concat(lc.language));
        case 5:
          languageFile = _context.sent;
          languageFile = languageFile.default;
          _context.next = 15;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](2);
          _context.next = 13;
          return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9384));
        case 13:
          languageFile = _context.sent;
          return _context.abrupt("return", languageFile.default);
        case 15:
          _context.prev = 15;
          _context.next = 18;
          return __webpack_require__(3688)("./".concat(lc.language, "/locale/").concat(lc.language, "_").concat(lc.country, ".js"));
        case 18:
          languageCountryFile = _context.sent;
          languageCountryFile = languageCountryFile.default;
          _context.next = 25;
          break;
        case 22:
          _context.prev = 22;
          _context.t1 = _context["catch"](15);
          // languageCountryFile not found, set it as an empty object
          languageCountryFile = {};
        case 25:
          return _context.abrupt("return", (0,lodash_es__WEBPACK_IMPORTED_MODULE_11__.merge)(languageFile, languageCountryFile));
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 9], [15, 22]]);
  }));
  return _getLanguageFilesContents.apply(this, arguments);
}
function parseLanguageString(languageString) {
  if (languageString.includes("_")) {
    var res = languageString.split("_");
    return {
      language: res[0],
      country: res[1]
    };
  }
  return {
    language: languageString,
    country: null
  };
}
function getDictonaryFromWidget(widgetDictionary, languageString, appVersion) {
  var lc = parseLanguageString(languageString);

  // If country is not present on languageString, parse appVersion to get the country.
  if (!lc.country) {
    lc.country = _alegradev_smile_ui_alegra__WEBPACK_IMPORTED_MODULE_10__.countriesMapping[appVersion];
  }
  var languageFile;
  var languageCountryFile;
  try {
    languageFile = widgetDictionary[lc.language]["common"];
  } catch (e) {
    // Lang file not found, languageCountryFile woun't be found either...
    languageFile = {};
  }
  try {
    languageCountryFile = widgetDictionary[lc.language]["locale"]["".concat(lc.language, "_").concat(lc.country)];
  } catch (e) {
    // languageCountryFile not found, set it as an empty object
    languageCountryFile = {};
  }
  return (0,lodash_es__WEBPACK_IMPORTED_MODULE_11__.merge)(languageFile, languageCountryFile);
}

/***/ }),

/***/ 8476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./": 899,
	"./en": 9384,
	"./en/": 9384,
	"./en/common": 4050,
	"./en/common.js": 4050,
	"./en/index": 9384,
	"./en/index.js": 9384,
	"./en/locale/en_AR": 7865,
	"./en/locale/en_AR.js": 7865,
	"./en/locale/en_CL": 1367,
	"./en/locale/en_CL.js": 1367,
	"./en/locale/en_CO": 8009,
	"./en/locale/en_CO.js": 8009,
	"./en/locale/en_CR": 9924,
	"./en/locale/en_CR.js": 9924,
	"./en/locale/en_DO": 1978,
	"./en/locale/en_DO.js": 1978,
	"./en/locale/en_ES": 636,
	"./en/locale/en_ES.js": 636,
	"./en/locale/en_KE": 8813,
	"./en/locale/en_KE.js": 8813,
	"./en/locale/en_MX": 3130,
	"./en/locale/en_MX.js": 3130,
	"./en/locale/en_NG": 5721,
	"./en/locale/en_NG.js": 5721,
	"./en/locale/en_PA": 856,
	"./en/locale/en_PA.js": 856,
	"./en/locale/en_PE": 6341,
	"./en/locale/en_PE.js": 6341,
	"./en/locale/en_US": 2523,
	"./en/locale/en_US.js": 2523,
	"./en/locale/en_ZA": 4444,
	"./en/locale/en_ZA.js": 4444,
	"./es": 2887,
	"./es/": 2887,
	"./es/common": 3902,
	"./es/common.js": 3902,
	"./es/index": 2887,
	"./es/index.js": 2887,
	"./es/locale/es_AR": 2872,
	"./es/locale/es_AR.js": 2872,
	"./es/locale/es_CL": 2692,
	"./es/locale/es_CL.js": 2692,
	"./es/locale/es_CO": 9927,
	"./es/locale/es_CO.js": 9927,
	"./es/locale/es_CR": 1874,
	"./es/locale/es_CR.js": 1874,
	"./es/locale/es_DO": 4681,
	"./es/locale/es_DO.js": 4681,
	"./es/locale/es_ES": 7116,
	"./es/locale/es_ES.js": 7116,
	"./es/locale/es_KE": 9425,
	"./es/locale/es_KE.js": 9425,
	"./es/locale/es_MX": 2996,
	"./es/locale/es_MX.js": 2996,
	"./es/locale/es_NG": 1558,
	"./es/locale/es_NG.js": 1558,
	"./es/locale/es_PA": 9964,
	"./es/locale/es_PA.js": 9964,
	"./es/locale/es_PE": 3570,
	"./es/locale/es_PE.js": 3570,
	"./es/locale/es_US": 6756,
	"./es/locale/es_US.js": 6756,
	"./es/locale/es_ZA": 4419,
	"./es/locale/es_ZA.js": 4419,
	"./index": 899,
	"./index.js": 899
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8476;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 3688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./en/common.js": 4050,
	"./en/index.js": 9384,
	"./en/locale/en_AR.js": 7865,
	"./en/locale/en_CL.js": 1367,
	"./en/locale/en_CO.js": 8009,
	"./en/locale/en_CR.js": 9924,
	"./en/locale/en_DO.js": 1978,
	"./en/locale/en_ES.js": 636,
	"./en/locale/en_KE.js": 8813,
	"./en/locale/en_MX.js": 3130,
	"./en/locale/en_NG.js": 5721,
	"./en/locale/en_PA.js": 856,
	"./en/locale/en_PE.js": 6341,
	"./en/locale/en_US.js": 2523,
	"./en/locale/en_ZA.js": 4444,
	"./es/common.js": 3902,
	"./es/index.js": 2887,
	"./es/locale/es_AR.js": 2872,
	"./es/locale/es_CL.js": 2692,
	"./es/locale/es_CO.js": 9927,
	"./es/locale/es_CR.js": 1874,
	"./es/locale/es_DO.js": 4681,
	"./es/locale/es_ES.js": 7116,
	"./es/locale/es_KE.js": 9425,
	"./es/locale/es_MX.js": 2996,
	"./es/locale/es_NG.js": 1558,
	"./es/locale/es_PA.js": 9964,
	"./es/locale/es_PE.js": 3570,
	"./es/locale/es_US.js": 6756,
	"./es/locale/es_ZA.js": 4419,
	"./index.js": 899
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3688;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 1075:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./en/common.js": 4050,
	"./en/index.js": 9384,
	"./en/locale/en_AR.js": 7865,
	"./en/locale/en_CL.js": 1367,
	"./en/locale/en_CO.js": 8009,
	"./en/locale/en_CR.js": 9924,
	"./en/locale/en_DO.js": 1978,
	"./en/locale/en_ES.js": 636,
	"./en/locale/en_KE.js": 8813,
	"./en/locale/en_MX.js": 3130,
	"./en/locale/en_NG.js": 5721,
	"./en/locale/en_PA.js": 856,
	"./en/locale/en_PE.js": 6341,
	"./en/locale/en_US.js": 2523,
	"./en/locale/en_ZA.js": 4444,
	"./es/common.js": 3902,
	"./es/index.js": 2887,
	"./es/locale/es_AR.js": 2872,
	"./es/locale/es_CL.js": 2692,
	"./es/locale/es_CO.js": 9927,
	"./es/locale/es_CR.js": 1874,
	"./es/locale/es_DO.js": 4681,
	"./es/locale/es_ES.js": 7116,
	"./es/locale/es_KE.js": 9425,
	"./es/locale/es_MX.js": 2996,
	"./es/locale/es_NG.js": 1558,
	"./es/locale/es_PA.js": 9964,
	"./es/locale/es_PE.js": 3570,
	"./es/locale/es_US.js": 6756,
	"./es/locale/es_ZA.js": 4419,
	"./index.js": 899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1075;

/***/ }),

/***/ 926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./en/common.js": 4050,
	"./es/common.js": 3902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 926;

/***/ }),

/***/ 3213:
/***/ (function(module) {

"use strict";
module.exports = require("@alegradev/smile-ui-alegra");

/***/ }),

/***/ 2193:
/***/ (function(module) {

"use strict";
module.exports = require("@soda/get-current-script");

/***/ }),

/***/ 3114:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.array.concat.js");

/***/ }),

/***/ 3600:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.array.includes.js");

/***/ }),

/***/ 1624:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.array.iterator.js");

/***/ }),

/***/ 2118:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.array.push.js");

/***/ }),

/***/ 6257:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.array.slice.js");

/***/ }),

/***/ 4271:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.error.cause.js");

/***/ }),

/***/ 6941:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.function.name.js");

/***/ }),

/***/ 3064:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.object.get-prototype-of.js");

/***/ }),

/***/ 4846:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.object.proto.js");

/***/ }),

/***/ 4277:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.object.set-prototype-of.js");

/***/ }),

/***/ 1000:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.object.to-string.js");

/***/ }),

/***/ 1117:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.promise.js");

/***/ }),

/***/ 6770:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.string.includes.js");

/***/ }),

/***/ 2047:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.string.iterator.js");

/***/ }),

/***/ 1076:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.symbol.description.js");

/***/ }),

/***/ 5547:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.symbol.iterator.js");

/***/ }),

/***/ 444:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/es.symbol.js");

/***/ }),

/***/ 3275:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/web.dom-collections.for-each.js");

/***/ }),

/***/ 8534:
/***/ (function(module) {

"use strict";
module.exports = require("core-js/modules/web.dom-collections.iterator.js");

/***/ }),

/***/ 8517:
/***/ (function(module) {

"use strict";
module.exports = require("lodash-es");

/***/ }),

/***/ 3240:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1000);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1117);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

/***/ }),

/***/ 2274:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: function() { return /* binding */ _regeneratorRuntime; }
});

// EXTERNAL MODULE: external "core-js/modules/es.symbol.js"
var es_symbol_js_ = __webpack_require__(444);
// EXTERNAL MODULE: external "core-js/modules/es.symbol.description.js"
var es_symbol_description_js_ = __webpack_require__(1076);
// EXTERNAL MODULE: external "core-js/modules/es.object.to-string.js"
var es_object_to_string_js_ = __webpack_require__(1000);
// EXTERNAL MODULE: external "core-js/modules/es.symbol.iterator.js"
var es_symbol_iterator_js_ = __webpack_require__(5547);
// EXTERNAL MODULE: external "core-js/modules/es.array.iterator.js"
var es_array_iterator_js_ = __webpack_require__(1624);
// EXTERNAL MODULE: external "core-js/modules/es.string.iterator.js"
var es_string_iterator_js_ = __webpack_require__(2047);
// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.iterator.js"
var web_dom_collections_iterator_js_ = __webpack_require__(8534);
;// CONCATENATED MODULE: external "core-js/modules/es.symbol.async-iterator.js"
var es_symbol_async_iterator_js_namespaceObject = require("core-js/modules/es.symbol.async-iterator.js");
;// CONCATENATED MODULE: external "core-js/modules/es.symbol.to-string-tag.js"
var es_symbol_to_string_tag_js_namespaceObject = require("core-js/modules/es.symbol.to-string-tag.js");
;// CONCATENATED MODULE: external "core-js/modules/es.json.to-string-tag.js"
var es_json_to_string_tag_js_namespaceObject = require("core-js/modules/es.json.to-string-tag.js");
;// CONCATENATED MODULE: external "core-js/modules/es.math.to-string-tag.js"
var es_math_to_string_tag_js_namespaceObject = require("core-js/modules/es.math.to-string-tag.js");
// EXTERNAL MODULE: external "core-js/modules/es.object.get-prototype-of.js"
var es_object_get_prototype_of_js_ = __webpack_require__(3064);
// EXTERNAL MODULE: external "core-js/modules/es.error.cause.js"
var es_error_cause_js_ = __webpack_require__(4271);
// EXTERNAL MODULE: external "core-js/modules/es.array.push.js"
var es_array_push_js_ = __webpack_require__(2118);
// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.for-each.js"
var web_dom_collections_for_each_js_ = __webpack_require__(3275);
// EXTERNAL MODULE: external "core-js/modules/es.function.name.js"
var es_function_name_js_ = __webpack_require__(6941);
// EXTERNAL MODULE: external "core-js/modules/es.object.set-prototype-of.js"
var es_object_set_prototype_of_js_ = __webpack_require__(4277);
// EXTERNAL MODULE: external "core-js/modules/es.object.proto.js"
var es_object_proto_js_ = __webpack_require__(4846);
// EXTERNAL MODULE: external "core-js/modules/es.promise.js"
var es_promise_js_ = __webpack_require__(1117);
// EXTERNAL MODULE: external "core-js/modules/es.array.slice.js"
var es_array_slice_js_ = __webpack_require__(6257);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(3336);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js





















function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

/***/ }),

/***/ 3336:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ _typeof; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(444);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1076);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1000);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5547);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1624);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2047);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8534);







function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	!function() {
/******/ 		// The chunk loading function for additional chunks
/******/ 		// Since all referenced chunks are already included
/******/ 		// in this file, this function is empty here.
/******/ 		__webpack_require__.e = function() { return Promise.resolve(); };
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  $paths: function() { return /* reexport */ paths; },
  "default": function() { return /* binding */ entry_lib; },
  dictionaryForWidget: function() { return /* reexport */ dictionaryForWidget; },
  priceListWidget: function() { return /* reexport */ priceListForm; },
  pricesListsStore: function() { return /* reexport */ pricesLists; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(2193)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external "core-js/modules/es.error.cause.js"
var es_error_cause_js_ = __webpack_require__(4271);
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/widgets/priceListForm.vue?vue&type=template&id=7394b66e&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prices-list-form',{ref:"priceListForm",on:{"success":function($event){return _vm.$emit('success', $event)},"loading":function($event){return _vm.$emit('loading', $event)},"error":function($event){return _vm.$emit('error', $event)}}})}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/pricesList/PricesListForm.vue?vue&type=template&id=f301a65c
var PricesListFormvue_type_template_id_f301a65c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"body-content row start-xs"},[_c('div',{staticClass:"col-xs-6"},[_c('sm-input',{attrs:{"data-end2end":"price-list-name","error":_vm.$v.form.name.$error && _vm.$trans('itemsPage.errors.required'),"label":_vm.$transF('itemsPage.name'),"size":"small","required":"","block":""},on:{"input":function($event){return _vm.$v.form.name.$touch()}},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_c('sm-select',{attrs:{"data-end2end":"price-list-type","label":_vm.$transF('pricesListsPage.type'),"options":_vm.typeOptions,"disabled":_vm.pricesListToEdit !== undefined,"help":_vm.getTypeHelp(),"text-field":"name","value-field":"value","required":"","block":"","size":"small"},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}}),(_vm.form.type.value === 'percentage')?_c('sm-number-input',{staticClass:"m-t-xs",attrs:{"data-end2end":"price-list-percentage","min":0,"label":_vm.$transF('pricesListsPage.percentage'),"error":_vm.$v.form.percentage.$error && _vm.$trans('itemsPage.errors.required'),"size":"small","required":"","block":""},on:{"input":function($event){return _vm.$v.form.percentage.$touch()}},model:{value:(_vm.form.percentage),callback:function ($$v) {_vm.$set(_vm.form, "percentage", $$v)},expression:"form.percentage"}}):_vm._e()],1),_c('div',{staticClass:"col-xs-6"},[_c('sm-textarea',{attrs:{"data-end2end":"price-list-description","label":_vm.$transF('itemsPage.description'),"rows":"9","size":"small","block":""},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)])}
var PricesListFormvue_type_template_id_f301a65c_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js + 4 modules
var regeneratorRuntime = __webpack_require__(2274);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(3240);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// EXTERNAL MODULE: external "core-js/modules/es.symbol.js"
var es_symbol_js_ = __webpack_require__(444);
// EXTERNAL MODULE: external "core-js/modules/es.symbol.description.js"
var es_symbol_description_js_ = __webpack_require__(1076);
// EXTERNAL MODULE: external "core-js/modules/es.object.to-string.js"
var es_object_to_string_js_ = __webpack_require__(1000);
// EXTERNAL MODULE: external "core-js/modules/es.symbol.iterator.js"
var es_symbol_iterator_js_ = __webpack_require__(5547);
// EXTERNAL MODULE: external "core-js/modules/es.array.iterator.js"
var es_array_iterator_js_ = __webpack_require__(1624);
// EXTERNAL MODULE: external "core-js/modules/es.string.iterator.js"
var es_string_iterator_js_ = __webpack_require__(2047);
// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.iterator.js"
var web_dom_collections_iterator_js_ = __webpack_require__(8534);
;// CONCATENATED MODULE: external "core-js/modules/es.array.from.js"
var es_array_from_js_namespaceObject = require("core-js/modules/es.array.from.js");
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: external "core-js/modules/es.array.slice.js"
var es_array_slice_js_ = __webpack_require__(6257);
;// CONCATENATED MODULE: external "core-js/modules/es.regexp.to-string.js"
var es_regexp_to_string_js_namespaceObject = require("core-js/modules/es.regexp.to-string.js");
// EXTERNAL MODULE: external "core-js/modules/es.function.name.js"
var es_function_name_js_ = __webpack_require__(6941);
;// CONCATENATED MODULE: external "core-js/modules/es.regexp.exec.js"
var es_regexp_exec_js_namespaceObject = require("core-js/modules/es.regexp.exec.js");
;// CONCATENATED MODULE: external "core-js/modules/es.regexp.test.js"
var es_regexp_test_js_namespaceObject = require("core-js/modules/es.regexp.test.js");
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js









function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
;// CONCATENATED MODULE: external "core-js/modules/es.object.keys.js"
var es_object_keys_js_namespaceObject = require("core-js/modules/es.object.keys.js");
;// CONCATENATED MODULE: external "core-js/modules/es.array.filter.js"
var es_array_filter_js_namespaceObject = require("core-js/modules/es.array.filter.js");
;// CONCATENATED MODULE: external "core-js/modules/es.object.get-own-property-descriptor.js"
var es_object_get_own_property_descriptor_js_namespaceObject = require("core-js/modules/es.object.get-own-property-descriptor.js");
// EXTERNAL MODULE: external "core-js/modules/es.array.push.js"
var es_array_push_js_ = __webpack_require__(2118);
// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.for-each.js"
var web_dom_collections_for_each_js_ = __webpack_require__(3275);
;// CONCATENATED MODULE: external "core-js/modules/es.object.get-own-property-descriptors.js"
var es_object_get_own_property_descriptors_js_namespaceObject = require("core-js/modules/es.object.get-own-property-descriptors.js");
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(3336);
;// CONCATENATED MODULE: external "core-js/modules/es.symbol.to-primitive.js"
var es_symbol_to_primitive_js_namespaceObject = require("core-js/modules/es.symbol.to-primitive.js");
;// CONCATENATED MODULE: external "core-js/modules/es.date.to-primitive.js"
var es_date_to_primitive_js_namespaceObject = require("core-js/modules/es.date.to-primitive.js");
;// CONCATENATED MODULE: external "core-js/modules/es.number.constructor.js"
var es_number_constructor_js_namespaceObject = require("core-js/modules/es.number.constructor.js");
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js








function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
// EXTERNAL MODULE: external "core-js/modules/es.array.concat.js"
var es_array_concat_js_ = __webpack_require__(3114);
// EXTERNAL MODULE: external "core-js/modules/es.promise.js"
var es_promise_js_ = __webpack_require__(1117);
;// CONCATENATED MODULE: external "core-js/modules/es.promise.finally.js"
var es_promise_finally_js_namespaceObject = require("core-js/modules/es.promise.finally.js");
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function classCallCheck_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function createClass_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// EXTERNAL MODULE: external "@alegradev/smile-ui-alegra"
var smile_ui_alegra_ = __webpack_require__(3213);
;// CONCATENATED MODULE: ./src/utils/pricesListModel/pricesListModel.js







var PricesListModel = /*#__PURE__*/function () {
  function PricesListModel() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      info = _ref.info;
    classCallCheck_classCallCheck(this, PricesListModel);
    this.init();
    if (info) {
      this.fillFromModel(info);
    }
  }
  createClass_createClass(PricesListModel, [{
    key: "data",
    get: function get() {
      return this._data;
    }
  }, {
    key: "init",
    value: function init() {
      this._data = {
        name: "",
        type: {
          value: "amount",
          name: (0,smile_ui_alegra_.$transF)("pricesListsPage.amount")
        },
        percentage: "",
        //currency: null,
        description: ""
      };
    }
  }, {
    key: "fillFromApi",
    value: function fillFromApi(info) {
      this._data = _objectSpread2(_objectSpread2({}, this.data), _objectSpread2(_objectSpread2({}, info), {}, {
        type: {
          value: info.type,
          name: (0,smile_ui_alegra_.$transF)("pricesListsPage.".concat(info.type))
        }
      }));
    }
  }, {
    key: "getPricesListToSend",
    value: function getPricesListToSend() {
      var body = {
        name: this.data.name,
        type: this.data.type.value,
        description: this.data.description,
        //currency: this.data.type.value === "amount" ? this.data.currency.code : undefined,
        percentage: this.data.type.value === "percentage" ? this.data.percentage : undefined
      };
      return body;
    }
  }]);
  return PricesListModel;
}();
/* harmony default export */ var pricesListModel = (PricesListModel);
;// CONCATENATED MODULE: ./src/utils/pricesListModel/index.js

/* harmony default export */ var utils_pricesListModel = (function () {
  return new pricesListModel();
});
;// CONCATENATED MODULE: external "vuelidate/lib/validators"
var validators_namespaceObject = require("vuelidate/lib/validators");
;// CONCATENATED MODULE: external "vuex"
var external_vuex_namespaceObject = require("vuex");
var external_vuex_default = /*#__PURE__*/__webpack_require__.n(external_vuex_namespaceObject);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js









function createForOfIteratorHelper_createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
;// CONCATENATED MODULE: external "core-js/modules/es.string.replace.js"
var es_string_replace_js_namespaceObject = require("core-js/modules/es.string.replace.js");
;// CONCATENATED MODULE: external "core-js/modules/es.number.to-fixed.js"
var es_number_to_fixed_js_namespaceObject = require("core-js/modules/es.number.to-fixed.js");
;// CONCATENATED MODULE: external "core-js/modules/es.array.map.js"
var es_array_map_js_namespaceObject = require("core-js/modules/es.array.map.js");
// EXTERNAL MODULE: external "core-js/modules/es.array.includes.js"
var es_array_includes_js_ = __webpack_require__(3600);
;// CONCATENATED MODULE: external "core-js/modules/es.array.join.js"
var es_array_join_js_namespaceObject = require("core-js/modules/es.array.join.js");
;// CONCATENATED MODULE: external "core-js/modules/es.set.js"
var es_set_js_namespaceObject = require("core-js/modules/es.set.js");
;// CONCATENATED MODULE: external "moment"
var external_moment_namespaceObject = require("moment");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_namespaceObject);
;// CONCATENATED MODULE: ./src/utils/jsHelpers.js





















function formatNumber(num) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return num.toFixed(precision).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
var numberFormatterInstance = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
function getNumberFormatter(decimalPrecision) {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimalPrecision,
    maximumFractionDigits: decimalPrecision
  }).format;
}
function getTotalPrice(basePrice, taxes, version) {
  basePrice = parseFloat(basePrice);
  taxes = taxes.map(function (tax) {
    return _objectSpread(_objectSpread({}, tax), {}, {
      percentage: parseFloat(tax.percentage || 0) / 100
    });
  });
  return basePrice + taxes.reduce(function (taxesSum, tax) {
    if (tax.type === "IVA" && version === "mexico") {
      var ivaBasePrice = taxes.reduce(function (taxesIEPSSum, tax) {
        if (tax.type !== "IEPS") return taxesIEPSSum;
        return taxesIEPSSum + basePrice * tax.percentage;
      }, basePrice);
      return taxesSum + ivaBasePrice * tax.percentage;
    }
    return taxesSum + basePrice * tax.percentage;
  }, 0);
}
function getBasePrice(totalPrice, taxes, version) {
  taxes = taxes.map(function (tax) {
    return _objectSpread(_objectSpread({}, tax), {}, {
      percentage: parseFloat(tax.percentage || 0) / 100
    });
  });
  return totalPrice / taxes.reduce(function (taxesSum, tax) {
    if (tax.type === "IVA" && version === "mexico") {
      var iepsSum = taxes.reduce(function (taxesIEPSSum, tax) {
        if (tax.type !== "IEPS") return taxesIEPSSum;
        return tax.percentage;
      }, 0);
      return taxesSum + (iepsSum + 1) * tax.percentage;
    }
    return taxesSum + tax.percentage;
  }, 1);
}
function roundNumber(value, decimalPrecision) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    removeZeros: false,
    text: false,
    decimalSeparator: null
  };
  var valueNumber = parseFloat(value);
  if (isNaN(valueNumber)) {
    return options.text || options.decimalSeparator ? "" : null;
  }
  var numRounded = valueNumber.toFixed(decimalPrecision);
  if (options.removeZeros) numRounded = parseFloat(numRounded);
  if ([",", "."].includes(options.decimalSeparator)) {
    numRounded = formatPriceWithSeparator(numRounded, options.decimalSeparator);
  } else if (options.text) {
    numRounded = numRounded.toString();
  } else if (!options.removeZeros) {
    // if we want to return a number we have to parse to float
    numRounded = parseFloat(numRounded);
  }
  return numRounded;
}
function formatPriceWithSeparator(price, decimalSeparator) {
  var priceSplitted = price.toString().split(".");
  var hasDecimalPart = priceSplitted.length > 1;
  var intPart = priceSplitted[0];
  var isNegative = intPart.length > 0 && intPart[0] === "-";
  var intPartFormatted = "";
  intPart = intPart.split("").reverse().join("");
  var numLength = intPart.length - isNegative;
  for (var i = 0; i < numLength; i++) {
    if (i > 0 && i % 3 === 0) intPartFormatted += decimalSeparator === "." ? "," : ".";
    intPartFormatted += intPart[i];
  }
  intPartFormatted = intPartFormatted.split("").reverse().join("");
  var result = intPartFormatted;
  if (hasDecimalPart) {
    result += "".concat(decimalSeparator).concat(priceSplitted[1]);
  }
  if (isNegative) result = "-" + result;
  return result;
}
var priceFormatter = numberFormatterInstance.format;
// export const numberFormatter = numberFormatterInstance.format
// export { priceFormatter }

function getFieldFrom(fieldChain, obj) {
  if (!fieldChain.length) return obj;
  if (Object.prototype.hasOwnProperty.call(obj, fieldChain[0])) {
    return getFieldFrom(fieldChain.slice(1), obj[fieldChain[0]]);
  } else {
    return null;
  }
}
function setDifference(setA, setB) {
  var _difference = new Set(setA);
  var _iterator = _createForOfIteratorHelper(setB),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var elem = _step.value;
      _difference.delete(elem);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return _difference;
}
function camelToUpSnake(string) {
  return string.replace(/([A-Z])/g, function (m) {
    return "_" + m;
  }).toUpperCase();
}
function matchFormattedNumber(number) {
  return /^(\d{1,3}(,\d{3})*)?(\.\d+)?$/.test(number);
}
function getErrorsfor(field) {
  if (field.$error) {
    var errors = [];
    for (var validation in field.$params) {
      if (!field[validation]) errors.push($trans("itemsPage.errors.".concat(validation)));
    }
    return errors;
  }
  return false;
}

// Here, 'this' is the reference to the Vue instance in which this function
// is to be used
function formatPrice(fieldKey, field, ref) {
  var _this$$v, _this$$v$form$fieldKe;
  var dataHolder = field !== null && field !== void 0 ? field : this.form;
  // IN CASE OF PROBLEMS: https://stackoverflow.com/questions/28230012/intl-numberformatformat-maximum-integer-value
  (_this$$v = this.$v) === null || _this$$v === void 0 ? void 0 : (_this$$v$form$fieldKe = _this$$v.form[fieldKey]) === null || _this$$v$form$fieldKe === void 0 ? void 0 : _this$$v$form$fieldKe.$touch();
  if (!dataHolder[fieldKey]) return;
  var component = this.$refs[ref || fieldKey];
  if (Array.isArray(component)) component = component[0];
  var input = component.$el.querySelector("input");
  var position = input.selectionStart;
  var prevValue = dataHolder[fieldKey];

  // unformat
  var priceSplitted = dataHolder[fieldKey].split(".");
  var priceWithoutFormat = priceSplitted[0].replace(/,/g, "");
  var decimals = "";
  if (priceSplitted.length === 2 && (!this.decimalPrecision || Number(this.decimalPrecision) > 0)) {
    decimals = "." + priceSplitted.pop().slice(0, this.decimalPrecision);
  }

  //#region format
  var formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format;
  var formattedPrice = formatter(priceWithoutFormat);
  dataHolder[fieldKey] = formattedPrice.toString() === "NaN" ? prevValue : formattedPrice + decimals;
  //#endregion

  this.$nextTick(function () {
    var positionDiff = dataHolder[fieldKey].length - prevValue.length;
    if (input.selectionEnd !== position) {
      input.selectionEnd = Number(position) + positionDiff;
    }
  });
}
function logError(err, vueInstance, functionName) {
  console.error("Error on component ".concat(vueInstance.$options._componentTag, " inside ").concat(functionName, " function"), err);
}
function showError(err, vueInstance) {
  var _err$data, _err$data2, _err$data3;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var errorMessage = (0,smile_ui_alegra_.$trans)("".concat(options.section, ".errors.").concat(err === null || err === void 0 ? void 0 : (_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.code)) || (err === null || err === void 0 ? void 0 : (_err$data2 = err.data) === null || _err$data2 === void 0 ? void 0 : _err$data2.message);
  var errorTitle = (0,smile_ui_alegra_.$trans)("".concat(options.section, ".errors.").concat(err === null || err === void 0 ? void 0 : (_err$data3 = err.data) === null || _err$data3 === void 0 ? void 0 : _err$data3.code, "Title")) || "Error";
  if (!errorMessage) {
    vueInstance.$smAlertErr((0,smile_ui_alegra_.$trans)(options.pathMessage || "itemsPage.errorOperation"));
    return;
  }
  vueInstance.$smAlertErr(errorMessage, {
    title: errorTitle
  });
}
function openInNewTab(url) {
  //https://stackoverflow.com/a/11384018/14010404
  window.open(url, "_blank").focus();
}
function emitAnalyticEvent(company, user, event) {
  var companyInfo = {
    idCompany: company.id,
    uuid: company.uuid,
    email: user.email,
    idProduct: 1,
    planName: user.membership.planName,
    registryDate: moment(company.registryDate).format("YYYY-MM-DD"),
    eventTimestamp: moment.utc().format("YYYY-MM-DD hh:mm:ss"),
    appVersion: company.applicationVersion,
    isPaying: user.membership.isPaid,
    regime: company.regime,
    sector: company.sector,
    employeesNumber: company.employeesNumber
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event,
    company: companyInfo
  });
}
;// CONCATENATED MODULE: external "vue"
var external_vue_namespaceObject = require("vue");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_namespaceObject);
;// CONCATENATED MODULE: external "vuex-cache"
var external_vuex_cache_namespaceObject = require("vuex-cache");
var external_vuex_cache_default = /*#__PURE__*/__webpack_require__.n(external_vuex_cache_namespaceObject);
;// CONCATENATED MODULE: ./src/store/utils.js




var hasModulePlugin = function hasModulePlugin(store) {
  store.hasModule = function (pathArray) {
    var m = store._modules.root;
    return pathArray.every(function (p) {
      m = m._children[p];
      return m;
    });
  };
};
var registerModuleOncePlugin = function registerModuleOncePlugin(store) {
  store.registerModuleOnce = function registerModuleOnce(path, rawModule) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // Path can be an array or a string: ['my', 'nested', 'module'] or 'my/nested/module'
    var pathArray = path instanceof Array ? path : path.split("/");
    if (!store.hasModule(pathArray)) {
      store.registerModule(pathArray, _objectSpread2(_objectSpread2({}, rawModule), {}, {
        namespaced: true
      }), opts);
    }
    for (var moduleName in rawModule.modules) {
      if (!store.hasModule([].concat(_toConsumableArray(pathArray), [moduleName]))) {
        store.registerModule([].concat(_toConsumableArray(pathArray), [moduleName]), rawModule.modules[moduleName], opts);
      }
    }
  };
};
// EXTERNAL MODULE: external "core-js/modules/es.object.set-prototype-of.js"
var es_object_set_prototype_of_js_ = __webpack_require__(4277);
// EXTERNAL MODULE: external "core-js/modules/es.object.proto.js"
var es_object_proto_js_ = __webpack_require__(4846);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js


function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js


function inherits_inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: external "core-js/modules/es.reflect.construct.js"
var es_reflect_construct_js_namespaceObject = require("core-js/modules/es.reflect.construct.js");
;// CONCATENATED MODULE: external "core-js/modules/es.reflect.to-string-tag.js"
var es_reflect_to_string_tag_js_namespaceObject = require("core-js/modules/es.reflect.to-string-tag.js");
// EXTERNAL MODULE: external "core-js/modules/es.object.get-prototype-of.js"
var es_object_get_prototype_of_js_ = __webpack_require__(3064);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js



function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js



function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js



function _possibleConstructorReturn(self, call) {
  if (call && ((0,esm_typeof/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js






function createSuper_createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
;// CONCATENATED MODULE: ./src/api/apiSet.js





var ApiSet = /*#__PURE__*/function () {
  function ApiSet(url) {
    classCallCheck_classCallCheck(this, ApiSet);
    this.url = url;
  }
  createClass_createClass(ApiSet, [{
    key: "list",
    value: function list(query) {
      return smile_ui_alegra_.request.get(this.url, {
        params: query
      });
    }
  }, {
    key: "detail",
    value: function detail(id, query) {
      return smile_ui_alegra_.request.get("".concat(this.url, "/").concat(id), {
        params: query
      });
    }
  }, {
    key: "create",
    value: function create(body) {
      return smile_ui_alegra_.request.post(this.url, body);
    }
  }, {
    key: "edit",
    value: function edit(id, body) {
      return smile_ui_alegra_.request.put("".concat(this.url, "/").concat(id), body);
    }
  }, {
    key: "editStatus",
    value: function editStatus() {
      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var body = arguments.length > 1 ? arguments[1] : undefined;
      return smile_ui_alegra_.request.put("".concat(this.url, "/status"), body, {
        params: {
          id: ids.join(",")
        }
      });
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      return smile_ui_alegra_.request.delete("".concat(this.url, "/").concat(id));
    }
  }]);
  return ApiSet;
}();
/* harmony default export */ var apiSet = (ApiSet);
;// CONCATENATED MODULE: ./src/api/bills.js







var BillsApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(BillsApi, _ApiSet);
  var _super = createSuper_createSuper(BillsApi);
  function BillsApi() {
    classCallCheck_classCallCheck(this, BillsApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(BillsApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata,
          order_field: "date",
          order_direction: "DESC"
        }, query)
      });
    }
  }]);
  return BillsApi;
}(apiSet);
var billsApi = new BillsApi("v1/bills");
/* harmony default export */ var bills = (billsApi);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js








function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
;// CONCATENATED MODULE: external "core-js/modules/es.object.values.js"
var es_object_values_js_namespaceObject = require("core-js/modules/es.object.values.js");
;// CONCATENATED MODULE: external "core-js/modules/es.object.entries.js"
var es_object_entries_js_namespaceObject = require("core-js/modules/es.object.entries.js");
;// CONCATENATED MODULE: external "core-js/modules/es.array.find-index.js"
var es_array_find_index_js_namespaceObject = require("core-js/modules/es.array.find-index.js");
;// CONCATENATED MODULE: external "core-js/modules/es.json.stringify.js"
var es_json_stringify_js_namespaceObject = require("core-js/modules/es.json.stringify.js");
;// CONCATENATED MODULE: ./src/store/helpers/actionConfigs.js
/* harmony default export */ var actionConfigs = ({
  common: {
    list: {
      hasMetadata: true,
      append: true
    },
    create: {
      appendAlways: true
    },
    edit: {
      editing: true
    }
  }
});
;// CONCATENATED MODULE: ./src/store/helpers/index.js

























//TODO: pre-commit Function. To allow to manipulate data before it gets commited
/**
 * The action configuration object
 * @typedef {Object} ActionConfig
 * @property {Function} service - Service used to obtain data
 * @property {String}   attr - The attribute of the state which will contain the data (if any)
 * @property {String}   [mutation] - Mutation to used to set data when it is not the default for the attr
 * @property {boolean}  [spreadServiceArgs] - Whether action argument should be spreaded into the service
 * @property {boolean}  [append] - Whether data should be appended to existing data in a list format if requestBody.append === true
 * @property {boolean}  [appendAlways] - Whether data should be appended to existing data in a list format even though is not requested
 * @property {boolean}  [editing] - Whether it is an editing action. CANNOT be used along with append or appendAlways
 * @property {Function}  [editingRefreshService] - Service used to refresh an edited document. MUST be defined if requestBody.refresh
 * @property {boolean}  [hasMetadata] - Whether response will included a metadata field. If metadata is true, then mutation MUST NOT be defined
 * @property {String}   [cacheAPIRequestIn] - Name of an action, automatically created, to cache API resquest made through service
 * @property {boolean}  [cacheActionToDelete] - Name of an action to delete from cache after the request to API. If it is not in cache, it does nothing
 */

/**
 * The VuexModuleMaker config
 * @typedef {Object} Config
 * @property {Object} state
 * @property {Object.<string,function|string>} getters
 * @property {Object.<string,function|string>} mutations
 * @property {Object.<string,Function| ActionConfig>} actions
 * @property {Object} options
 */




var VuexModuleMaker = /*#__PURE__*/function () {
  /**
   * @param {Config} config
   */
  function VuexModuleMaker(_ref) {
    var _ref$state = _ref.state,
      state = _ref$state === void 0 ? {} : _ref$state,
      _ref$getters = _ref.getters,
      getters = _ref$getters === void 0 ? {} : _ref$getters,
      _ref$mutations = _ref.mutations,
      mutations = _ref$mutations === void 0 ? {} : _ref$mutations,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? {} : _ref$actions;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      namespaced: true
    };
    classCallCheck_classCallCheck(this, VuexModuleMaker);
    this._state = state;
    this._getters = [].concat(_toConsumableArray(Object.keys(state)), [getters]);
    this._actions = actions;
    this.options = options;

    // mutationsNeeded = setDifference(mutationsNeeded, defaultMutations)
    this._mutations = [].concat(_toConsumableArray(this._getDefaultMutations(state, actions)), [mutations]);
    this._cachedActions = {};
  }
  createClass_createClass(VuexModuleMaker, [{
    key: "getModule",
    value: function getModule() {
      return _objectSpread2({
        state: this._state,
        getters: this.buildGetters(),
        mutations: this.buildMutations(),
        actions: this.buildActions()
      }, this.options);
    }
  }, {
    key: "_getDefaultMutations",
    value: function _getDefaultMutations(state, actions) {
      var defaultMutations = new Set(Object.keys(state));
      //Add mutations as needed in actions
      var mutationsNeeded = new Set(Object.values(actions).filter(function (action) {
        return (0,esm_typeof/* default */.Z)(action) === "object" && !action.mutation;
      }).map(function (action) {
        return action.attr;
      }));
      var _iterator = createForOfIteratorHelper_createForOfIteratorHelper(mutationsNeeded),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutationFromAction = _step.value;
          defaultMutations.add(mutationFromAction);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return defaultMutations;
    }

    /**
     * Adds a getter. If getter names collide, the last added
     * will be the one used
     *
     * Note for developer: for now that precedence behaviour
     * is a result of overwritting a key's value on the getter
     * object been built, but this can be improve by using a Set
     * for the _getters property(Comming soon)
     *
     * @param {Object.<string,function|string>} getter
     */
  }, {
    key: "addGetter",
    value: function addGetter(getter) {
      this._getters.push(getter);
      return this;
    }

    /**
     * Adds a mutation. If mutation names collide, the last added
     * will be the one used
     *
     * Note for developer: for now that precedence behaviour
     * is a result of overwritting a key's value on the getter
     * object been built, but this can be improve by using a Set
     * for the _getters property(Comming soon)
     * @param {Object.<string,function|string>} mutation
     */
  }, {
    key: "addMutation",
    value: function addMutation(mutation) {
      this._mutations.push(mutation);
      return this;
    }
  }, {
    key: "addAction",
    value: function addAction(_ref2) {
      var actionName = _ref2.actionName,
        action = _ref2.action;
      if ((0,esm_typeof/* default */.Z)(action) === "object" && !action.mutation) {
        var defaultMutations = this._mutations.filter(function (mutation) {
          return typeof mutation === "string";
        });
        if (!defaultMutations.some(function (dM) {
          return dM === action.attr;
        })) {
          // if there is no mutations for this action's attr, set one
          this._mutations.push(action.attr);
        }
      }
      this._actions[actionName] = action;
      return this;
    }
  }, {
    key: "buildGetters",
    value: function buildGetters() {
      var getters = {};
      var fieldChain;
      var _iterator2 = createForOfIteratorHelper_createForOfIteratorHelper(this._getters),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var getter = _step2.value;
          if (typeof getter === "string") {
            // if getter is string then it is a dotted path to value to be returned from module state
            // Ex: state => state.user.name then getter === "user.name"
            fieldChain = getter.split(".");
            var binded = getFieldFrom.bind(null, fieldChain);
            getters[fieldChain[fieldChain.length - 1]] = binded;
          } else if ((0,esm_typeof/* default */.Z)(getter) === "object") {
            // if getter is object then each key (i.e. entry[0]) is the name of a getter
            for (var _i = 0, _Object$entries = Object.entries(getter); _i < _Object$entries.length; _i++) {
              var entry = _Object$entries[_i];
              if (typeof entry[1] === "string") {
                // if value (i.e. entry[1]) is string then it is a dotted path to value to be returned from module state
                fieldChain = getter.split(".");
                var _binded = getFieldFrom.bind(null, fieldChain);
                getters[entry[0]] = _binded;
              } else if (typeof entry[1] === "function") {
                // if value (i.e. entry[1]) is function then is a whole getter definition
                getters[entry[0]] = entry[1];
              }
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return getters;
    }
  }, {
    key: "buildMutations",
    value: function buildMutations() {
      var mutations = {};
      var _iterator3 = createForOfIteratorHelper_createForOfIteratorHelper(this._mutations),
        _step3;
      try {
        var _loop = function _loop() {
          var mutation = _step3.value;
          if (typeof mutation === "string") {
            // if mutation is string then it is the field to be set. A vuex mutation is created
            // using this string.
            // Ex: if mutation === "user" then a vuex mutation is created, name SET_USER
            // mutations["SET_" + mutation.toUpperCase()] = (state, payload) => (state[mutation] = payload)
            mutations["SET_" + camelToUpSnake(mutation)] = function (state, payload) {
              return state[mutation] = payload;
            };
          } else if ((0,esm_typeof/* default */.Z)(mutation) === "object") {
            var _loop2 = function _loop2() {
              var entry = _Object$entries2[_i2];
              if (typeof entry[1] === "string") {
                // if value (i.e. entry[1]) is string then it is the state's field to be set
                mutations[entry[0]] = function (state, payload) {
                  return state[entry[1]] = payload;
                };
              } else if (typeof entry[1] === "function") {
                // if value (i.e. entry[1]) is function then it is a whole mutation definition
                mutations[entry[0]] = entry[1];
              }
            };
            // if mutation is object then each key (i.e. entry[0]) is the name of a mutation
            for (var _i2 = 0, _Object$entries2 = Object.entries(mutation); _i2 < _Object$entries2.length; _i2++) {
              _loop2();
            }
          }
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return mutations;
    }
  }, {
    key: "buildActions",
    value: function buildActions() {
      var actions = {};
      // Every key of actions's object is going to be used as the name of the action
      for (var action in this._actions) {
        if (typeof this._actions[action] === "function") {
          // if the value is a function then it is a whole action definition
          actions[action] = this._actions[action];
        } else if ((0,esm_typeof/* default */.Z)(this._actions[action]) === "object") {
          // if the value is a object then it contains: a reference to the api service
          // that must be used, stored in field "service", a string with the name of the
          // field of state where the response will be saved stored in "attr".
          // As an optional field it could contain a "mutation" field, which should be the
          // name of a vuex mutation available in this module
          var actionConfig = this._actions[action];
          if (actionConfig.cacheAPIRequestIn) {
            actions[actionConfig.cacheAPIRequestIn] = this._createFetchAction(actionConfig);
            var _actionConfig$cacheAP = actionConfig.cacheAPIRequestIn.split("/"),
              _actionConfig$cacheAP2 = _slicedToArray(_actionConfig$cacheAP, 2),
              _action = _actionConfig$cacheAP2[1];
            actions["clear".concat(_action[0].toUpperCase() + _action.slice(1))] = this._createClearCacheAction(actionConfig.cacheAPIRequestIn);
          }
          actions[action] = this.buildAction(actionConfig);
        }
      }
      return actions;
    }
  }, {
    key: "buildAction",
    value: function buildAction(actionConfig) {
      var _this = this;
      // TODO: allow to define cache timeout through dispatch
      var action = function action(_ref3, requestBody) {
        var commit = _ref3.commit,
          state = _ref3.state,
          cache = _ref3.cache;
        var append = actionConfig.appendAlways || actionConfig.append && (requestBody === null || requestBody === void 0 ? void 0 : requestBody.append);
        var refresh = (requestBody === null || requestBody === void 0 ? void 0 : requestBody.refresh) && actionConfig.editingRefreshService;
        if (requestBody) {
          delete requestBody["append"];
        }
        return new Promise( /*#__PURE__*/function () {
          var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resolve, reject) {
            var data;
            return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  if (cache && actionConfig.cacheActionToDelete) {
                    _this._deleteCacheAction(cache, actionConfig.cacheActionToDelete);
                  }
                  if (!(cache && actionConfig.cacheAPIRequestIn)) {
                    _context.next = 8;
                    break;
                  }
                  _context.next = 5;
                  return _this._cacheAction(cache, actionConfig.cacheAPIRequestIn, requestBody);
                case 5:
                  _context.t0 = _context.sent;
                  _context.next = 11;
                  break;
                case 8:
                  _context.next = 10;
                  return _this._sendRequest(requestBody, actionConfig);
                case 10:
                  _context.t0 = _context.sent;
                case 11:
                  data = _context.t0;
                  if (actionConfig.hasMetadata) {
                    commit("SET_TOTAL_" + camelToUpSnake(actionConfig.attr), data.metadata.total);
                  }
                  if (!(actionConfig.attr || actionConfig.mutation)) {
                    _context.next = 20;
                    break;
                  }
                  _context.t1 = commit;
                  _context.t2 = actionConfig.mutation ? actionConfig.mutation : "SET_" + camelToUpSnake(actionConfig.attr);
                  _context.next = 18;
                  return _this._prepareDataToCommit(data, _objectSpread2(_objectSpread2({}, actionConfig), {}, {
                    append: append,
                    state: state,
                    refresh: refresh
                  }));
                case 18:
                  _context.t3 = _context.sent;
                  (0, _context.t1)(_context.t2, _context.t3);
                case 20:
                  resolve(data);
                  _context.next = 26;
                  break;
                case 23:
                  _context.prev = 23;
                  _context.t4 = _context["catch"](0);
                  reject(_context.t4);
                case 26:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 23]]);
          }));
          return function (_x, _x2) {
            return _ref4.apply(this, arguments);
          };
        }());
      };
      return actionConfig.cacheAPIRequestIn || actionConfig.cacheActionToDelete ? (0,external_vuex_cache_namespaceObject.cacheAction)(action) : action;
    }
  }, {
    key: "_prepareDataToCommit",
    value: function () {
      var _prepareDataToCommit2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(data, config) {
        var preparedData, documents, updatedDocumentIndex, response;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              preparedData = data;
              if (config.hasMetadata) {
                preparedData = data.data;
              }
              if (!config.append) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", Array.prototype.concat(config.state[config.attr], preparedData));
            case 6:
              if (!config.editing) {
                _context2.next = 16;
                break;
              }
              documents = config.state[config.attr];
              updatedDocumentIndex = documents.findIndex(function (document) {
                return document.id === preparedData.id;
              });
              if (!config.refresh) {
                _context2.next = 14;
                break;
              }
              _context2.next = 12;
              return config.editingRefreshService(preparedData.id, {
                fields: "editable,deletable"
              });
            case 12:
              response = _context2.sent;
              preparedData = response.data;
            case 14:
              documents[updatedDocumentIndex] = preparedData;
              return _context2.abrupt("return", documents);
            case 16:
              return _context2.abrupt("return", preparedData);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function _prepareDataToCommit(_x3, _x4) {
        return _prepareDataToCommit2.apply(this, arguments);
      }
      return _prepareDataToCommit;
    }()
  }, {
    key: "_sendRequest",
    value: function () {
      var _sendRequest2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(requestBody, config) {
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!config.spreadServiceArgs) {
                _context3.next = 6;
                break;
              }
              _context3.next = 3;
              return config.service.apply(config, _toConsumableArray(requestBody));
            case 3:
              return _context3.abrupt("return", _context3.sent.data);
            case 6:
              if (!config.editing) {
                _context3.next = 12;
                break;
              }
              _context3.next = 9;
              return config.service(requestBody.id, requestBody.body);
            case 9:
              return _context3.abrupt("return", _context3.sent.data);
            case 12:
              _context3.next = 14;
              return config.service(requestBody);
            case 14:
              return _context3.abrupt("return", _context3.sent.data);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function _sendRequest(_x5, _x6) {
        return _sendRequest2.apply(this, arguments);
      }
      return _sendRequest;
    }()
  }, {
    key: "_createFetchAction",
    value: function _createFetchAction(actionConfig) {
      var _this2 = this;
      return function (context, requestBody) {
        return new Promise( /*#__PURE__*/function () {
          var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee4(resolve, reject) {
            var data;
            return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  _context4.next = 3;
                  return _this2._sendRequest(requestBody, actionConfig);
                case 3:
                  data = _context4.sent;
                  resolve(data);
                  _context4.next = 10;
                  break;
                case 7:
                  _context4.prev = 7;
                  _context4.t0 = _context4["catch"](0);
                  reject(_context4.t0);
                case 10:
                case "end":
                  return _context4.stop();
              }
            }, _callee4, null, [[0, 7]]);
          }));
          return function (_x7, _x8) {
            return _ref5.apply(this, arguments);
          };
        }());
      };
    }
  }, {
    key: "_createClearCacheAction",
    value: function _createClearCacheAction(actionToDelete) {
      var _this3 = this;
      return (0,external_vuex_cache_namespaceObject.cacheAction)(function (context) {
        _this3._deleteCacheAction(context.cache, actionToDelete);
      });
    }
  }, {
    key: "_cacheAction",
    value: function _cacheAction(cache, actionToCache, requestBody) {
      var requestBodyString = requestBody ? JSON.stringify(requestBody) : "";
      if (this._cachedActions[actionToCache]) {
        this._cachedActions[actionToCache].add(requestBodyString);
      } else {
        this._cachedActions[actionToCache] = new Set([requestBodyString]);
      }
      return cache.dispatch(actionToCache, requestBody);
    }
  }, {
    key: "_deleteCacheAction",
    value: function _deleteCacheAction(cache, actionToDelete) {
      if (this._cachedActions[actionToDelete]) {
        var _iterator4 = createForOfIteratorHelper_createForOfIteratorHelper(this._cachedActions[actionToDelete]),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var requestBodyString = _step4.value;
            var requestBody = requestBodyString !== "" ? JSON.parse(requestBodyString) : undefined;
            if (cache.has(actionToDelete, requestBody)) {
              cache.delete(actionToDelete, requestBody);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        this._cachedActions[actionToDelete] = new Set();
      }
    }
  }]);
  return VuexModuleMaker;
}();

;// CONCATENATED MODULE: ./src/store/bills/index.js



var state = {
  bills: [],
  totalBills: 0
};
var vuexModule = new VuexModuleMaker({
  state: state,
  actions: {
    getBills: _objectSpread2({
      service: bills.list.bind(bills),
      attr: "bills"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_bills = (vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/supportDocuments.js







var SupportDocumentsApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(SupportDocumentsApi, _ApiSet);
  var _super = createSuper_createSuper(SupportDocumentsApi);
  function SupportDocumentsApi() {
    classCallCheck_classCallCheck(this, SupportDocumentsApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(SupportDocumentsApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata,
          order_field: "date",
          order_direction: "DESC",
          type: "supportDocument"
        }, query)
      });
    }
  }]);
  return SupportDocumentsApi;
}(apiSet);
var supportDocumentsApi = new SupportDocumentsApi("v1/bills");
/* harmony default export */ var supportDocuments = (supportDocumentsApi);
;// CONCATENATED MODULE: ./src/store/supportDocuments/index.js



var supportDocuments_state = {
  supportDocuments: [],
  totalSupportDocuments: 0
};
var supportDocuments_vuexModule = new VuexModuleMaker({
  state: supportDocuments_state,
  actions: {
    getSupportDocuments: _objectSpread2({
      service: supportDocuments.list.bind(supportDocuments),
      attr: "supportDocuments"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_supportDocuments = (supportDocuments_vuexModule.getModule());
// EXTERNAL MODULE: external "core-js/modules/es.string.includes.js"
var es_string_includes_js_ = __webpack_require__(6770);
;// CONCATENATED MODULE: external "js-cookie"
var external_js_cookie_namespaceObject = require("js-cookie");
;// CONCATENATED MODULE: ./enviroment.json
var enviroment_namespaceObject = JSON.parse('{"local":{"GTM_ID":"GTM-PV4NSN","HUBSPOT_ID":"7254930","BASE_API_URL":"https://gates.alegra.com/api/","BASE_API_SHOP_URL":"https://almost-shops-api.alegra.com/v1/","BASE_URL":"https://hopper.alegra.com/","BASE_API_CONFIG_URL":"https://almost-config.alegra.com/api/","COOKIE_TOKEN":"al-test-days-of-thunder","CHAT_COOKIE":"al-test-hubspot"},"testing":{"GTM_ID":"GTM-PV4NSN","HUBSPOT_ID":"7254930","BASE_API_URL":"https://gates.alegra.com/api/","BASE_API_SHOP_URL":"https://almost-shops-api.alegra.com/v1/","BASE_URL":"https://hopper.alegra.com/","BASE_API_CONFIG_URL":"https://almost-config.alegra.com/api/","COOKIE_TOKEN":"al-test-days-of-thunder","CHAT_COOKIE":"al-test-hubspot"},"sandbox":{"GTM_ID":"GTM-TPPVF5KP","HUBSPOT_ID":"6180490","BASE_API_URL":"https://sandbox-api.alegra.com/api/","BASE_URL":"https://sandbox-app.alegra.com/","BASE_API_CONFIG_URL":"https://sandbox-config.alegra.com/api/","COOKIE_TOKEN":"al-sand-days-of-thunder","CHAT_COOKIE":"al-sand-hubspot"},"production":{"GTM_ID":"GTM-KQG46G","HUBSPOT_ID":"6180490","BASE_API_URL":"https://api.alegra.com/api/","BASE_API_SHOP_URL":"https://shops-api.alegra.com/v1/","BASE_URL":"https://app.alegra.com/","BASE_API_CONFIG_URL":"https://config.alegra.com/api/","COOKIE_TOKEN":"al-days-of-thunder","CHAT_COOKIE":"al-hubspot"},"WIDGET_MODULE_NAME":"itemsWidget"}');
;// CONCATENATED MODULE: ./src/utils/appHelpers.js












// pseudo-random character function
var randomChars = function randomChars() {
  return (Math.random() + 1).toString(36).substring(2, 7);
};
var widgetModuleNameRandom = randomChars();
var appEnviroment = String("production").toLowerCase();
var baseApiUrl = enviroment_namespaceObject[appEnviroment]["BASE_API_URL"];
var baseUrl = enviroment_namespaceObject[appEnviroment]["BASE_URL"];
var baseApiConfigUrl = enviroment_namespaceObject[appEnviroment]["BASE_API_CONFIG_URL"];
var isWidget = "true" === "true";
var widgetModuleName = enviroment_namespaceObject.WIDGET_MODULE_NAME || widgetModuleNameRandom;

// Use the "en-US" format, as is the default formatfor displaying prices in Alegra.
var appHelpers_numberFormatterInstance = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

/**
 * Returns a tring with the number formated, with 2 digits
 * @param {Number} number to be formated
 */
var numberFormatter = function numberFormatter(number) {
  return appHelpers_numberFormatterInstance.format(number);
};

/**
 * Returns the value from enviroment.json or process.env, taking in account the appEnviroment of the user (local, testing or production), in this order:
 *  - Fisrt, try to get the ENV[appEnviroment][key]
 *  - Then if not found, try to get the ENV[key]
 *  - Lastly, if not found, try to get the process.env[key]
 * @param {String} key to look for
 * @param {String} env must be "local", "testing" or "production". Defaults to: `process.env.VUE_APP_ENVIROMENT`
 */
function getEnv(key) {
  var _ENV$env;
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : appEnviroment;
  if ((_ENV$env = ENV[env]) !== null && _ENV$env !== void 0 && _ENV$env[key]) {
    var _ENV$env2;
    return (_ENV$env2 = ENV[env]) === null || _ENV$env2 === void 0 ? void 0 : _ENV$env2[key];
  } else if (ENV !== null && ENV !== void 0 && ENV[key]) {
    return ENV === null || ENV === void 0 ? void 0 : ENV[key];
  } else if (({"VUE_APP_IS_WIDGET":"true","VUE_APP_AUTH_HEADER_TOKEN_DEV":"","VUE_APP_ENVIROMENT":"production","VUE_APP_SENTRY_KEY":"379c259781814748bb6c4623730fad68@o570744.ingest","VUE_APP_SENTRY_PROJECT":"5728525","NODE_ENV":"production","VUE_APP_TESTING_USER":"grace","VUE_APP_TESTING_PASS":"alegraTesters!","VUE_APP_USE_ANTIFLICKER":"NO","VUE_APP_ANTIFLICKER_MS":"4000","VUE_APP_PUSHER_KEY":"","VUE_APP_PUSHER_CHANNEL":"","BASE_URL":"/"})[key]) {
    return ({"VUE_APP_IS_WIDGET":"true","VUE_APP_AUTH_HEADER_TOKEN_DEV":"","VUE_APP_ENVIROMENT":"production","VUE_APP_SENTRY_KEY":"379c259781814748bb6c4623730fad68@o570744.ingest","VUE_APP_SENTRY_PROJECT":"5728525","NODE_ENV":"production","VUE_APP_TESTING_USER":"grace","VUE_APP_TESTING_PASS":"alegraTesters!","VUE_APP_USE_ANTIFLICKER":"NO","VUE_APP_ANTIFLICKER_MS":"4000","VUE_APP_PUSHER_KEY":"","VUE_APP_PUSHER_CHANNEL":"","BASE_URL":"/"})[key];
  }
  return null;
}

/**
 * Returns wheater the app can be mounted, dependeing if the cookie of Alegra session is present.
 */
function canBeMounted() {
  var cookieTokenKey = getEnv("COOKIE_TOKEN"); // ENV[appEnviroment][]

  if (appEnviroment === "production" && !Cookies.get(cookieTokenKey)) return false;
  return true;
}

/**
 * Take only specified keys of the object passed as argument
 * @param {Object} obj to take keys from
 * @param {Array<String>} keys Array of Strings that contains the keys to get from the object
 */
function pick(obj, keys) {
  return Object.keys(obj).filter(function (i) {
    return keys.includes(i);
  }).reduce(function (acc, key) {
    acc[key] = obj[key];
    return acc;
  }, {});
}

/**
 * Returns a JSON object with the content of the common and specific translations of this project
 * @param {Array<string>} paths If specified, pick only these paths from the lang files
 */
function convertDictionaryToObject() {
  var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var langKeys = ["en", "es"];
  var vk = ["AR", "CL", "CO", "CR", "DO", "ES", "KE", "MX", "NG", "PA", "PE", "US", "ZA"];
  return _objectSpread2({}, langKeys.reduce(function (accLang, lang) {
    var langCommon = __webpack_require__(926)("./".concat(lang, "/common.js")).default;
    if (paths && paths.length) {
      langCommon = pick(langCommon, paths);
    }
    return _objectSpread2(_objectSpread2({}, accLang), {}, _defineProperty({}, lang, {
      // get the common file
      common: langCommon,
      // iterate over the versions keys
      locale: _objectSpread2({}, vk.reduce(function (accVer, ver) {
        var langVer = __webpack_require__(1075)("./".concat(lang, "/locale/").concat(lang, "_").concat(ver, ".js")).default;
        if (paths && paths.length) {
          langVer = pick(langVer, paths);
        }
        return _objectSpread2(_objectSpread2({}, accVer), {}, _defineProperty({}, "".concat(lang, "_").concat(ver), langVer));
      }, {}))
    }));
  }, {}));
}

;// CONCATENATED MODULE: ./src/api/categories.js











var CategoriesApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(CategoriesApiSet, _ApiSet);
  var _super = createSuper_createSuper(CategoriesApiSet);
  function CategoriesApiSet() {
    var _this;
    classCallCheck_classCallCheck(this, CategoriesApiSet);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "configBaseUrl", "".concat(baseApiConfigUrl, "v1/grouping-codes"));
    return _this;
  }
  createClass_createClass(CategoriesApiSet, [{
    key: "listGroupingCodes",
    value: function listGroupingCodes(params) {
      return smile_ui_alegra_.request.get(this.configBaseUrl, {
        params: _objectSpread2({
          category_type: "income",
          limit: 100
        }, params)
      });
    }
  }, {
    key: "listSalesAndInventoryAccounts",
    value: function listSalesAndInventoryAccounts() {
      return smile_ui_alegra_.request.get("".concat(this.url, "/accounting/settings"), {
        params: {
          onlySettings: "no"
        }
      });
    }
  }, {
    key: "listInventoryAccounts",
    value: function listInventoryAccounts(query) {
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          categoryRule_key: "INVENTORY",
          fields: "children"
        }, query)
      });
    }
  }, {
    key: "listInventariablePurchaseAccounts",
    value: function listInventariablePurchaseAccounts(query) {
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          categoryRule_key: "INVENTARIABLE_PURCHASES"
        }, query)
      });
    }
  }]);
  return CategoriesApiSet;
}(apiSet);
var categoriesApiSet = new CategoriesApiSet("v1/categories");
/* harmony default export */ var categories = (categoriesApiSet);
;// CONCATENATED MODULE: ./src/store/categories/helpers.js




function DFSTraversalCategoryToSetParent(tree) {
  if (tree.children) {
    var _iterator = _createForOfIteratorHelper(tree.children),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        child.parent = tree;
        DFSTraversalCategoryToSetParent(child);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}
function flattenCategories(categories) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!categories) return [];
  var flatCategories = [];
  var _iterator2 = createForOfIteratorHelper_createForOfIteratorHelper(categories),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var category = _step2.value;
      flatCategories = [].concat(_toConsumableArray(flatCategories), [_objectSpread2(_objectSpread2({}, category), {}, {
        level: level
      })], _toConsumableArray(flattenCategories(category.children, level !== null ? level + 1 : level)));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return flatCategories;
}
;// CONCATENATED MODULE: ./src/store/categories/index.js








var categories_state = {
  categoriesPlain: [],
  categoriesTree: [],
  groupingCodes: [],
  inventoryAccounts: [],
  inventariablePurchaseAccounts: []
};
var categories_vuexModule = new VuexModuleMaker({
  state: categories_state,
  getters: {
    categoriesPlain: function categoriesPlain(state) {
      return flattenCategories(state.categoriesTree, 0);
    },
    inventoryAccountsPlain: function inventoryAccountsPlain(state) {
      return flattenCategories(state.inventoryAccounts, 0);
    },
    inventariablePurchaseAccountsPlain: function inventariablePurchaseAccountsPlain(state) {
      return flattenCategories(state.inventariablePurchaseAccounts, 0);
    }
  },
  actions: {
    createCategory: _objectSpread2({
      service: categories.create.bind(categories),
      attr: "category"
    }, actionConfigs.common.create),
    editCategory: {
      service: categories.edit.bind(categories),
      attr: "category",
      spreadServiceArgs: true
    },
    getGroupingCodes: {
      service: categories.listGroupingCodes.bind(categories),
      attr: "groupingCodes",
      cacheAPIRequestIn: "categories/fetchGroupingCodes"
    },
    getInventariablePurchaseAccounts: function getInventariablePurchaseAccounts(context, query) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resolve, reject) {
          var _yield$categoriesApiS, data;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return categories.listInventariablePurchaseAccounts(query);
              case 3:
                _yield$categoriesApiS = _context.sent;
                data = _yield$categoriesApiS.data;
                context.commit("SET_INVENTARIABLE_PURCHASE_ACCOUNTS", data);
                resolve(data);
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 9]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getSalesAndInventoryAccounts: function () {
      var _getSalesAndInventoryAccounts = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(context) {
        var _yield$categoriesApiS2, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return categories.listSalesAndInventoryAccounts();
            case 2:
              _yield$categoriesApiS2 = _context2.sent;
              data = _yield$categoriesApiS2.data;
              context.commit("SET_CATEGORIES_TREE", data.sales.sales);
              context.commit("SET_INVENTORY_ACCOUNTS", data.inventory.inventory);
              return _context2.abrupt("return", data);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getSalesAndInventoryAccounts(_x3) {
        return _getSalesAndInventoryAccounts.apply(this, arguments);
      }
      return getSalesAndInventoryAccounts;
    }()
  }
}, {
  namespaced: true
});
/* harmony default export */ var store_categories = (categories_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/costCenters.js







var CostCenterApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(CostCenterApi, _ApiSet);
  var _super = createSuper_createSuper(CostCenterApi);
  function CostCenterApi() {
    classCallCheck_classCallCheck(this, CostCenterApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(CostCenterApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata,
          order_field: "name",
          order_direction: "ASC"
        }, query)
      });
    }
  }]);
  return CostCenterApi;
}(apiSet);
var costCenterApi = new CostCenterApi("v1/cost-centers");
/* harmony default export */ var costCenters = (costCenterApi);
;// CONCATENATED MODULE: ./src/store/costCenters/index.js





var costCenters_state = {
  costCenters: [],
  totalCostCenters: 0
};
var costCenters_vuexModule = new VuexModuleMaker({
  state: costCenters_state,
  getters: {
    activeCostCenters: function activeCostCenters(state) {
      return state.costCenters.filter(function (cc) {
        return cc.status === "active";
      });
    }
  },
  actions: {
    getCostCenters: _objectSpread2({
      service: costCenters.list.bind(costCenters),
      attr: "costCenters",
      cacheAPIRequestIn: "costCenters/fetchCostCenters"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_costCenters = (costCenters_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/creditNotes.js







var CreditNotesApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(CreditNotesApi, _ApiSet);
  var _super = createSuper_createSuper(CreditNotesApi);
  function CreditNotesApi() {
    classCallCheck_classCallCheck(this, CreditNotesApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(CreditNotesApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata,
          order_field: "date",
          order_direction: "DESC"
        }, query)
      });
    }
  }]);
  return CreditNotesApi;
}(apiSet);
var creditNotesApi = new CreditNotesApi("v1/credit-notes");
/* harmony default export */ var creditNotes = (creditNotesApi);
;// CONCATENATED MODULE: ./src/store/creditNotes/index.js



var creditNotes_state = {
  creditNotes: [],
  totalCreditNotes: 0
};
var creditNotes_vuexModule = new VuexModuleMaker({
  state: creditNotes_state,
  actions: {
    getCreditNotes: _objectSpread2({
      service: creditNotes.list.bind(creditNotes),
      attr: "creditNotes"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_creditNotes = (creditNotes_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/debitNotes.js







var DebitNotesApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(DebitNotesApi, _ApiSet);
  var _super = createSuper_createSuper(DebitNotesApi);
  function DebitNotesApi() {
    classCallCheck_classCallCheck(this, DebitNotesApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(DebitNotesApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata,
          order_field: "date",
          order_direction: "DESC"
        }, query)
      });
    }
  }]);
  return DebitNotesApi;
}(apiSet);
var debitNotesApi = new DebitNotesApi("v1/debit-notes");
/* harmony default export */ var debitNotes = (debitNotesApi);
;// CONCATENATED MODULE: ./src/store/debitNotes/index.js



var debitNotes_state = {
  debitNotes: [],
  totalDebitNotes: 0
};
var debitNotes_vuexModule = new VuexModuleMaker({
  state: debitNotes_state,
  actions: {
    getDebitNotes: _objectSpread2({
      service: debitNotes.list.bind(debitNotes),
      attr: "debitNotes"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_debitNotes = (debitNotes_vuexModule.getModule());

// const getters = {
//   debitNotes: state => {
//     return state.debitNotes
//   },
//   totalDebitNotes: state => {
//     return state.totalDebitNotes
//   }
// }

// const mutations = {
//   setAttribute: (state, payload) => {
//     state[payload.attribute] = payload.value
//   },
//   appendAttribute: (state, payload) => {
//     state[payload.attribute].concat(payload)
//   }
// }

// const actions = {
//   getDebitNotes: (context, query = {}) => {
//     const append = query.append
//     delete query["append"]
//     return debitNotesApi.list(query).then(({ data }) => {
//       const debitNotes = [...data.data]
//       if (append) {
//         context.commit("setAttribute", {
//           attribute: "debitNotes",
//           value: [...context.state.debitNotes, ...debitNotes]
//         })
//       } else {
//         if (Array.isArray(data)) {
//           context.commit("setAttribute", { attribute: "debitNotes", value: [...data] })
//         } else {
//           context.commit("setAttribute", { attribute: "debitNotes", value: debitNotes })
//           context.commit("setAttribute", {
//             attribute: "totalDebitNotes",
//             value: data.metadata.total
//           })
//         }
//       }
//     })
//   }
// }

// export default {
//   namespaced: true,
//   state,
//   getters,
//   mutations,
//   actions
// }
;// CONCATENATED MODULE: ./src/api/customFields.js







var CustomFieldsApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(CustomFieldsApi, _ApiSet);
  var _super = createSuper_createSuper(CustomFieldsApi);
  function CustomFieldsApi() {
    classCallCheck_classCallCheck(this, CustomFieldsApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(CustomFieldsApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata
        }, query)
      });
    }
  }]);
  return CustomFieldsApi;
}(apiSet);
var customFieldsApi = new CustomFieldsApi("v1/custom-fields");
/* harmony default export */ var api_customFields = (customFieldsApi);
;// CONCATENATED MODULE: ./src/store/customFields/index.js













var customFields_state = {
  customFields: [],
  totalCustomFields: 0
};
var customFields_vuexModule = new VuexModuleMaker({
  state: customFields_state,
  getters: {
    activeCustomFields: function activeCustomFields(state) {
      return state.customFields.filter(function (cF) {
        return cF.status === "active";
      });
    },
    customFieldsForVariant: function customFieldsForVariant(state) {
      return state.customFields.filter(function (cF) {
        return cF.settings.showInItemVariants;
      });
    }
  },
  actions: {
    getCustomFields: _objectSpread2({
      service: api_customFields.list.bind(api_customFields),
      attr: "customFields"
    }, actionConfigs.common.list),
    createCustomField: _objectSpread2({
      service: api_customFields.create.bind(api_customFields),
      attr: "customFields"
    }, actionConfigs.common.create),
    editCustomField: _objectSpread2({
      service: api_customFields.edit.bind(api_customFields),
      attr: "customFields",
      editingRefreshService: api_customFields.detail.bind(api_customFields)
    }, actionConfigs.common.edit),
    deleteCustomField: {
      service: api_customFields.delete.bind(api_customFields)
    },
    editStatus: function editStatus(context, _ref) {
      var _ref$ids = _ref.ids,
        ids = _ref$ids === void 0 ? [] : _ref$ids,
        body = _ref.body,
        id = _ref.id;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resolve, reject) {
          var customFields, _yield$customFieldsAp, data, _iterator, _step, _loop;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                if (id) {
                  ids = [id];
                }
                customFields = context.getters.customFields;
                _context2.next = 5;
                return api_customFields.editStatus(ids, body);
              case 5:
                _yield$customFieldsAp = _context2.sent;
                data = _yield$customFieldsAp.data;
                _iterator = createForOfIteratorHelper_createForOfIteratorHelper(data.success);
                _context2.prev = 8;
                _loop = /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _loop() {
                  var customField, updateCustomFieldIndex;
                  return (0,regeneratorRuntime/* default */.Z)().wrap(function _loop$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        customField = _step.value;
                        updateCustomFieldIndex = customFields.findIndex(function (p) {
                          return p.id === customField.id;
                        });
                        customFields[updateCustomFieldIndex] = customField;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _loop);
                });
                _iterator.s();
              case 11:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 15;
                  break;
                }
                return _context2.delegateYield(_loop(), "t0", 13);
              case 13:
                _context2.next = 11;
                break;
              case 15:
                _context2.next = 20;
                break;
              case 17:
                _context2.prev = 17;
                _context2.t1 = _context2["catch"](8);
                _iterator.e(_context2.t1);
              case 20:
                _context2.prev = 20;
                _iterator.f();
                return _context2.finish(20);
              case 23:
                context.commit("SET_CUSTOM_FIELDS", customFields);
                resolve(data);
                _context2.next = 30;
                break;
              case 27:
                _context2.prev = 27;
                _context2.t2 = _context2["catch"](0);
                reject(_context2.t2);
              case 30:
              case "end":
                return _context2.stop();
            }
          }, _callee, null, [[0, 27], [8, 17, 20, 23]]);
        }));
        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }
});
/* harmony default export */ var customFields = (customFields_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/estimates.js







var EstimatesApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(EstimatesApi, _ApiSet);
  var _super = createSuper_createSuper(EstimatesApi);
  function EstimatesApi() {
    classCallCheck_classCallCheck(this, EstimatesApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(EstimatesApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata,
          order_field: "date",
          order_direction: "DESC"
        }, query)
      });
    }
  }]);
  return EstimatesApi;
}(apiSet);
var estimatesApi = new EstimatesApi("v1/estimates");
/* harmony default export */ var estimates = (estimatesApi);
;// CONCATENATED MODULE: ./src/store/estimates/index.js



var estimates_state = {
  estimates: [],
  totalEstimates: 0
};
var estimates_vuexModule = new VuexModuleMaker({
  state: estimates_state,
  actions: {
    getEstimates: _objectSpread2({
      service: estimates.list.bind(estimates),
      attr: "estimates"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_estimates = (estimates_vuexModule.getModule());

// const getters = {
//   estimates: state => {
//     return state.estimates
//   },
//   totalEstimates: state => {
//     return state.totalEstimates
//   }
// }

// const mutations = {
//   setAttribute: (state, payload) => {
//     state[payload.attribute] = payload.value
//   },
//   appendAttribute: (state, payload) => {
//     state[payload.attribute].concat(payload)
//   }
// }

// const actions = {
//   getEstimates: (context, query = {}) => {
//     const append = query.append
//     delete query["append"]
//     return estimatesApi.list(query).then(({ data }) => {
//       const estimates = [...data.data]
//       if (append) {
//         context.commit("setAttribute", {
//           attribute: "estimates",
//           value: [...context.state.estimates, ...estimates]
//         })
//       } else {
//         if (Array.isArray(data)) {
//           context.commit("setAttribute", { attribute: "estimates", value: [...data] })
//         } else {
//           context.commit("setAttribute", { attribute: "estimates", value: estimates })
//           context.commit("setAttribute", {
//             attribute: "totalEstimates",
//             value: data.metadata.total
//           })
//         }
//       }
//     })
//   }
// }

// export default {
//   namespaced: true,
//   state,
//   getters,
//   mutations,
//   actions
// }
;// CONCATENATED MODULE: external "axios"
var external_axios_namespaceObject = require("axios");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_namespaceObject);
;// CONCATENATED MODULE: ./src/api/items.js











var url = "v1/items";
var configBaseUrl = baseApiConfigUrl;
function items_getProducts(query) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  // return request.get('/items');
  return smile_ui_alegra_.request.get(url, {
    params: _objectSpread2({
      metadata: metadata
    }, query)
  });
}
function createProduct(body) {
  return request.post(url, body);
}
function deleteProduct(id) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
      var _yield$request$delete, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return request.delete("".concat(url, "/").concat(id));
          case 3:
            _yield$request$delete = _context.sent;
            data = _yield$request$delete.data;
            resolve(_objectSpread(_objectSpread({}, data), {}, {
              id: id
            }));
            // resolve({id, message: "asdfasf"})
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            reject(_objectSpread(_objectSpread({}, _context.t0.data), {}, {
              id: id
            }));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}
function items_deleteItemsByIds(ids) {
  return smile_ui_alegra_.request.delete("".concat(url, "/"), {
    params: {
      id: ids.join(",")
    }
  });
}
function items_editProduct(id, body) {
  var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
  var BASE_API_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_API_URL"];
  var newUrl = "".concat(BASE_API_URL).concat(url, "/").concat(id);
  var headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  if (smile_ui_alegra_.$enviroment === "production") {
    newUrl = "".concat(BASE_URL, "api/").concat(url, "/").concat(id);
  }
  return smile_ui_alegra_.request.put(newUrl, body, {
    timeout: 200000,
    headers: headers
  });
}
function attachment(id, body) {
  var favorite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return request.post("".concat(url, "/").concat(id, "/attachment?favorite=").concat(favorite), body, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
function updateFavoriteImage(idImage, body) {
  return request.put("".concat(url, "/attachment/").concat(idImage), body);
}
function deleteAttachment(id) {
  return request.delete("".concat(url, "/attachment/").concat(id));
}
function getProduct(id, query) {
  var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
  var BASE_API_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_API_URL"];
  var newUrl = "".concat(BASE_API_URL).concat(url, "/").concat(id);
  var headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  if (smile_ui_alegra_.$enviroment === "production") {
    newUrl = "".concat(BASE_URL, "api/").concat(url, "/").concat(id);
  }
  return smile_ui_alegra_.request.get(newUrl, {
    timeout: 200000,
    params: query,
    headers: headers
  });
}
function getProductKeys(country, _ref2) {
  var _ref2$name_contains = _ref2.name_contains,
    name_contains = _ref2$name_contains === void 0 ? null : _ref2$name_contains,
    _ref2$limit = _ref2.limit,
    limit = _ref2$limit === void 0 ? 100 : _ref2$limit,
    key = _ref2.key;
  var url = "".concat(configBaseUrl, "v1/products-keys");
  if (country === "costaRica") url += "?deprecated=false";
  return (0,smile_ui_alegra_.request)({
    url: url,
    method: "get",
    params: {
      application_version: country,
      limit: limit,
      name_contains: name_contains,
      key: key
    }
  });
}
function getIVACategories(_ref3) {
  var application_version = _ref3.application_version,
    _ref3$name_contains = _ref3.name_contains,
    name_contains = _ref3$name_contains === void 0 ? undefined : _ref3$name_contains,
    _ref3$key = _ref3.key,
    key = _ref3$key === void 0 ? undefined : _ref3$key;
  return (0,smile_ui_alegra_.request)({
    url: configBaseUrl + "v1/categories-no-iva-days",
    method: "get",
    params: {
      application_version: application_version,
      name_contains: name_contains,
      key: key
    }
  });
}
function getIVAGenres(_ref4) {
  var application_version = _ref4.application_version,
    _ref4$name_contains = _ref4.name_contains,
    name_contains = _ref4$name_contains === void 0 ? null : _ref4$name_contains,
    key = _ref4.key;
  return (0,smile_ui_alegra_.request)({
    url: configBaseUrl + "v1/genders-no-iva-days",
    method: "get",
    params: {
      application_version: application_version,
      name_contains: name_contains,
      key: key
    }
  });
}
function items_getReferenceTypes(country) {
  return (0,smile_ui_alegra_.request)({
    url: configBaseUrl + "v1/reference-types",
    method: "get",
    params: {
      application_version: country
    }
  });
}
function changeItemsStatus() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return smile_ui_alegra_.request.put("".concat(url, "/status"), {
    status: "".concat(active ? "" : "in", "active")
  }, {
    params: {
      id: ids.join(",")
    }
  });
}
function items_modifyShopVisibility(ids, body) {
  return smile_ui_alegra_.request.put("".concat(url, "/shop/visibility"), body, {
    params: {
      id: ids
    }
  });
}
function exportItems() {
  var fileType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "csv";
  var BASE_URL = ENVIRONMENT[$enviroment]["BASE_URL"];
  var config = {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
  };
  var uname = "grace";
  var pass = "alegraTesters!";
  if ($enviroment !== "production") {
    config["auth"] = {
      username: uname,
      password: pass
    };
  }
  return axios.post("".concat(BASE_URL, "labs/test11/exportable-type/items/format/json?file-type=").concat(fileType), {}, config);
}
function exportItemRecord(itemId) {
  var BASE_URL = ENVIRONMENT[$enviroment]["BASE_URL"];
  var config = {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
  };
  var uname = "grace";
  var pass = "alegraTesters!";
  if ($enviroment !== "production") {
    config["auth"] = {
      username: uname,
      password: pass
    };
  }
  return axios.post("".concat(BASE_URL, "labs/test11/exportable-type/inventory-history/idItem/").concat(itemId, "/format/json"), {}, config);
}
function items_editNoIvaDaysInfo(ids, body) {
  return smile_ui_alegra_.request.put("".concat(url, "/no-iva-days/"), body, {
    params: {
      id: ids
    }
  });
}

//TODO: Remove this when company_invoiceText gets add to /users/self
function items_getInvoiceText() {
  return new Promise( /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(resolve, reject) {
      var _yield$request$get, data;
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return smile_ui_alegra_.request.get("v1/company", {
              params: {
                fields: "invoiceText"
              }
            });
          case 3:
            _yield$request$get = _context2.sent;
            data = _yield$request$get.data;
            resolve(data.invoiceText);
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            reject(_context2.t0);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }());
}
;// CONCATENATED MODULE: ./src/store/items/index.js

















var items_state = {
  products: [],
  productKeys: [],
  referenceTypes: [],
  totalProducts: 0,
  invoiceText: ""
};
var getters = {
  products: function products(state) {
    return state.products;
  },
  productKeys: function productKeys(state) {
    return state.productKeys;
  },
  //TODO: Remove this when company_invoiceText gets add to /users/self
  invoiceText: function invoiceText(state) {
    return state.invoiceText;
  },
  categoriesNoIvaDays: function categoriesNoIvaDays(state) {
    return state.categoriesNoIvaDays;
  },
  currency: function currency(state, getters, rootState, rootGetters) {
    return rootGetters["session/company"] && rootGetters["session/company"].currency.code;
  },
  currencySymbol: function currencySymbol(state, getters, rootState, rootGetters) {
    return rootGetters["session/company"] && rootGetters["session/company"].currency.symbol;
  },
  decimalPrecision: function decimalPrecision(state, getters, rootState, rootGetters) {
    var _rootGetters$session;
    return (_rootGetters$session = rootGetters["session/company"]) === null || _rootGetters$session === void 0 ? void 0 : _rootGetters$session.decimalPrecision;
  },
  decimalPrecisionCalculation: function decimalPrecisionCalculation(state, getters, rootState, rootGetters) {
    var _rootGetters$session2, _rootGetters$session3;
    return (_rootGetters$session2 = (_rootGetters$session3 = rootGetters["session/company"]) === null || _rootGetters$session3 === void 0 ? void 0 : _rootGetters$session3.calculationScale) !== null && _rootGetters$session2 !== void 0 ? _rootGetters$session2 : getters.decimalPrecision;
  },
  decimalPrecisionQuantity: function decimalPrecisionQuantity(state, getters, rootState, rootGetters) {
    var _rootGetters$session4;
    return ((_rootGetters$session4 = rootGetters["session/company"]) === null || _rootGetters$session4 === void 0 ? void 0 : _rootGetters$session4.calculationScale) === 6 ? 4 : 2;
  },
  genresNoIvaDays: function genresNoIvaDays(state) {
    return state.genresNoIvaDays;
  },
  hasElectronicInvoicing: function hasElectronicInvoicing(state, getters, rootState, rootGetters) {
    return rootGetters["session/company"] && rootGetters["session/company"].settings.electronicInvoicing;
  },
  referenceTypes: function referenceTypes(state) {
    return state.referenceTypes;
  },
  totalProducts: function totalProducts(state) {
    return state.totalProducts;
  },
  regime: function regime(state, getters, rootState, rootGetters) {
    return rootGetters["session/company"] && rootGetters["session/company"].regime;
  },
  showNoIvaDays: function showNoIvaDays(state, getters, rootState, rootGetters) {
    var _rootGetters$session5;
    return rootGetters["session/company"] && ((_rootGetters$session5 = rootGetters["session/company"].interfaceSettings.items) === null || _rootGetters$session5 === void 0 ? void 0 : _rootGetters$session5.showNoIvaDays);
  },
  isActiveNoIvaDay: function isActiveNoIvaDay(state, getters, rootState, rootGetters) {
    return rootGetters["session/company"] && rootGetters["session/company"].isActiveNoIvaDay;
  }
};
var mutations = {
  // SHOULD DEPRECATE THIS MUTATION SO SPECIFIC MUTATIONS CAN BE SUBSCRIBED TO
  setAttribute: function setAttribute(state, payload) {
    state[payload.attribute] = payload.value;
  },
  SET_PRODUCTS: function SET_PRODUCTS(state, payload) {
    state.products = payload;
  },
  SET_PRODUCT_KEYS: function SET_PRODUCT_KEYS(state, payload) {
    state.productKeys = payload;
  },
  SET_REFERENCE_TYPES: function SET_REFERENCE_TYPES(state, payload) {
    state.referenceTypes = payload;
  },
  SET_INVOICE_TEXT: function SET_INVOICE_TEXT(state, payload) {
    state.invoiceText = payload;
  }
};
var actions = {
  getProducts: function getProducts(context) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise( /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resolve, reject) {
        var append, _yield$_getProducts, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              append = query.append;
              delete query["append"];
              _context.next = 5;
              return items_getProducts(query);
            case 5:
              _yield$_getProducts = _context.sent;
              data = _yield$_getProducts.data;
              if (append) {
                context.commit("SET_PRODUCTS", [].concat(_toConsumableArray(context.state.products), _toConsumableArray(data.data)));
              } else {
                context.commit("SET_PRODUCTS", data.data);
                context.commit("setAttribute", {
                  attribute: "totalProducts",
                  value: data.metadata.total
                });
              }
              resolve(data);
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              reject(_context.t0);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 11]]);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  getProductKeys: (0,external_vuex_cache_namespaceObject.cacheAction)(function (context, query) {
    return new Promise( /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(resolve, reject) {
        var version, data, keys;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // const { data } = await getProductKeys(context.rootGetters["app/appVersion"], query)
              version = context.rootGetters["app/appVersion"];
              _context2.next = 4;
              return context.cache.dispatch("fetchProductKeys", {
                version: version,
                query: query
              });
            case 4:
              data = _context2.sent;
              keys = data.map(function (item) {
                var productKey = _objectSpread2(_objectSpread2({}, item), {}, {
                  text: "".concat(item.key, " - ").concat(item.name),
                  value: item.key
                });
                if (version === "costaRica") {
                  if (item.key === "NO_CABYS") productKey.text = item.name;else productKey.text += " - IVA ".concat(item.tax, "%");
                }
                return productKey;
              });
              context.commit("SET_PRODUCT_KEYS", keys);
              resolve(keys);
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              reject(_context2.t0);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 10]]);
      }));
      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
  }),
  fetchProductKeys: function fetchProductKeys(context, _ref3) {
    var version = _ref3.version,
      query = _ref3.query;
    return new Promise( /*#__PURE__*/function () {
      var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(resolve, reject) {
        var _yield$getProductKeys, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return getProductKeys(version, query);
            case 3:
              _yield$getProductKeys = _context3.sent;
              data = _yield$getProductKeys.data;
              resolve(data);
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              reject(_context3.t0);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 8]]);
      }));
      return function (_x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }());
  },
  getReferenceTypes: function getReferenceTypes(context) {
    return new Promise( /*#__PURE__*/function () {
      var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee4(resolve, reject) {
        var _yield$_getReferenceT, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return items_getReferenceTypes(context.rootGetters["app/appVersion"]);
            case 3:
              _yield$_getReferenceT = _context4.sent;
              data = _yield$_getReferenceT.data;
              context.commit("SET_REFERENCE_TYPES", data);
              resolve(data);
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              reject(_context4.t0);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 9]]);
      }));
      return function (_x7, _x8) {
        return _ref5.apply(this, arguments);
      };
    }());
  },
  editProduct: function editProduct(context, _ref6) {
    var id = _ref6.id,
      body = _ref6.body,
      refresh = _ref6.refresh;
    return new Promise( /*#__PURE__*/function () {
      var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee5(resolve, reject) {
        var _yield$_editProduct, data, products, updatedProductIndex, response;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return items_editProduct(id, body);
            case 3:
              _yield$_editProduct = _context5.sent;
              data = _yield$_editProduct.data;
              products = context.getters.products;
              updatedProductIndex = products.findIndex(function (item) {
                return item.id === id;
              }); // FIXME: remove this request if API aproves fields for edit endpoint
              // it is been used in function toggleStatus inside ItemList
              if (!refresh) {
                _context5.next = 12;
                break;
              }
              _context5.next = 10;
              return getProduct(id, {
                fields: "editable,deletable"
              });
            case 10:
              response = _context5.sent;
              data = response.data;
            case 12:
              products[updatedProductIndex] = data;
              context.commit("SET_PRODUCTS", products);
              return _context5.abrupt("return", resolve(data));
            case 17:
              _context5.prev = 17;
              _context5.t0 = _context5["catch"](0);
              reject(_context5.t0);
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 17]]);
      }));
      return function (_x9, _x10) {
        return _ref7.apply(this, arguments);
      };
    }());
  },
  modifyShopVisibility: function modifyShopVisibility(context, _ref8) {
    var ids = _ref8.ids,
      body = _ref8.body;
    return new Promise( /*#__PURE__*/function () {
      var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee6(resolve, reject) {
        var _yield$_modifyShopVis, data, products, _iterator, _step, _loop;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return items_modifyShopVisibility(ids, body);
            case 3:
              _yield$_modifyShopVis = _context7.sent;
              data = _yield$_modifyShopVis.data;
              products = context.getters.products;
              _iterator = createForOfIteratorHelper_createForOfIteratorHelper(data.success);
              _context7.prev = 7;
              _loop = /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _loop() {
                var updated, index;
                return (0,regeneratorRuntime/* default */.Z)().wrap(function _loop$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      updated = _step.value;
                      index = products.findIndex(function (item) {
                        return item.id === updated.id;
                      });
                      if (products[index]) products[index].settingsOnShop.hide = body.hide;
                    case 3:
                    case "end":
                      return _context6.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 10:
              if ((_step = _iterator.n()).done) {
                _context7.next = 14;
                break;
              }
              return _context7.delegateYield(_loop(), "t0", 12);
            case 12:
              _context7.next = 10;
              break;
            case 14:
              _context7.next = 19;
              break;
            case 16:
              _context7.prev = 16;
              _context7.t1 = _context7["catch"](7);
              _iterator.e(_context7.t1);
            case 19:
              _context7.prev = 19;
              _iterator.f();
              return _context7.finish(19);
            case 22:
              context.commit("SET_PRODUCTS", products);
              resolve(data);
              _context7.next = 29;
              break;
            case 26:
              _context7.prev = 26;
              _context7.t2 = _context7["catch"](0);
              reject(_context7.t2);
            case 29:
            case "end":
              return _context7.stop();
          }
        }, _callee6, null, [[0, 26], [7, 16, 19, 22]]);
      }));
      return function (_x11, _x12) {
        return _ref9.apply(this, arguments);
      };
    }());
  },
  editNoIvaDaysInfo: function editNoIvaDaysInfo(context, _ref10) {
    var ids = _ref10.ids,
      body = _ref10.body;
    return new Promise( /*#__PURE__*/function () {
      var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee7(resolve, reject) {
        var _yield$_editNoIvaDays, data, products, _iterator2, _step2, _loop2;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee7$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return items_editNoIvaDaysInfo(ids.join(","), body);
            case 3:
              _yield$_editNoIvaDays = _context9.sent;
              data = _yield$_editNoIvaDays.data;
              products = context.getters.products;
              _iterator2 = createForOfIteratorHelper_createForOfIteratorHelper(data.success);
              _context9.prev = 7;
              _loop2 = /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _loop2() {
                var updated, index;
                return (0,regeneratorRuntime/* default */.Z)().wrap(function _loop2$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      updated = _step2.value;
                      index = products.findIndex(function (item) {
                        return item.id === updated.id;
                      });
                      if (body.hasNoIvaDays !== null && body.hasNoIvaDays !== undefined) {
                        products[index].hasNoIvaDays = body.hasNoIvaDays;
                      }
                      if (body.noIvaDaysCategory !== null && body.noIvaDaysCategory !== undefined) {
                        products[index].noIvaDaysCategory = body.noIvaDaysCategory;
                      }
                      if (body.noIvaDaysGenre !== null && body.noIvaDaysGenre !== undefined) {
                        products[index].noIvaDaysGenre = body.noIvaDaysGenre;
                      }
                    case 5:
                    case "end":
                      return _context8.stop();
                  }
                }, _loop2);
              });
              _iterator2.s();
            case 10:
              if ((_step2 = _iterator2.n()).done) {
                _context9.next = 14;
                break;
              }
              return _context9.delegateYield(_loop2(), "t0", 12);
            case 12:
              _context9.next = 10;
              break;
            case 14:
              _context9.next = 19;
              break;
            case 16:
              _context9.prev = 16;
              _context9.t1 = _context9["catch"](7);
              _iterator2.e(_context9.t1);
            case 19:
              _context9.prev = 19;
              _iterator2.f();
              return _context9.finish(19);
            case 22:
              context.commit("SET_PRODUCTS", products);
              resolve(data);
              _context9.next = 29;
              break;
            case 26:
              _context9.prev = 26;
              _context9.t2 = _context9["catch"](0);
              reject(_context9.t2);
            case 29:
            case "end":
              return _context9.stop();
          }
        }, _callee7, null, [[0, 26], [7, 16, 19, 22]]);
      }));
      return function (_x13, _x14) {
        return _ref11.apply(this, arguments);
      };
    }());
  },
  editStatus: function editStatus(context, _ref12) {
    var _ref12$ids = _ref12.ids,
      ids = _ref12$ids === void 0 ? [] : _ref12$ids,
      _ref12$active = _ref12.active,
      active = _ref12$active === void 0 ? true : _ref12$active,
      id = _ref12.id;
    return new Promise( /*#__PURE__*/function () {
      var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee8(resolve, reject) {
        var products, _yield$changeItemsSta, data, _iterator3, _step3, _loop3;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee8$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              if (id) {
                ids = [id];
              }
              products = context.getters.products;
              _context11.next = 5;
              return changeItemsStatus(ids, active);
            case 5:
              _yield$changeItemsSta = _context11.sent;
              data = _yield$changeItemsSta.data;
              _iterator3 = createForOfIteratorHelper_createForOfIteratorHelper(data.success);
              _context11.prev = 8;
              _loop3 = /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _loop3() {
                var item, updateItemIndex;
                return (0,regeneratorRuntime/* default */.Z)().wrap(function _loop3$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      item = _step3.value;
                      updateItemIndex = products.findIndex(function (p) {
                        return p.id === item.id;
                      });
                      if (products[updateItemIndex]) products[updateItemIndex].status = item.status;
                    case 3:
                    case "end":
                      return _context10.stop();
                  }
                }, _loop3);
              });
              _iterator3.s();
            case 11:
              if ((_step3 = _iterator3.n()).done) {
                _context11.next = 15;
                break;
              }
              return _context11.delegateYield(_loop3(), "t0", 13);
            case 13:
              _context11.next = 11;
              break;
            case 15:
              _context11.next = 20;
              break;
            case 17:
              _context11.prev = 17;
              _context11.t1 = _context11["catch"](8);
              _iterator3.e(_context11.t1);
            case 20:
              _context11.prev = 20;
              _iterator3.f();
              return _context11.finish(20);
            case 23:
              resolve(data);
              _context11.next = 29;
              break;
            case 26:
              _context11.prev = 26;
              _context11.t2 = _context11["catch"](0);
              reject(_context11.t2);
            case 29:
            case "end":
              return _context11.stop();
          }
        }, _callee8, null, [[0, 26], [8, 17, 20, 23]]);
      }));
      return function (_x15, _x16) {
        return _ref13.apply(this, arguments);
      };
    }());
  },
  deleteItemsByIds: function deleteItemsByIds(context) {
    var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return new Promise( /*#__PURE__*/function () {
      var _ref14 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee9(resolve, reject) {
        var _yield$_deleteItemsBy, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee9$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return items_deleteItemsByIds(ids);
            case 3:
              _yield$_deleteItemsBy = _context12.sent;
              data = _yield$_deleteItemsBy.data;
              resolve(data);
              _context12.next = 11;
              break;
            case 8:
              _context12.prev = 8;
              _context12.t0 = _context12["catch"](0);
              reject(_context12.t0);
            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee9, null, [[0, 8]]);
      }));
      return function (_x17, _x18) {
        return _ref14.apply(this, arguments);
      };
    }());
  },
  getInvoiceText: function getInvoiceText(_ref15) {
    var commit = _ref15.commit;
    return new Promise( /*#__PURE__*/function () {
      var _ref16 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee10(resolve, reject) {
        var invoiceText;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee10$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return items_getInvoiceText();
            case 3:
              invoiceText = _context13.sent;
              commit("SET_INVOICE_TEXT", invoiceText);
              resolve(invoiceText);
              _context13.next = 11;
              break;
            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13["catch"](0);
              reject(_context13.t0);
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee10, null, [[0, 8]]);
      }));
      return function (_x19, _x20) {
        return _ref16.apply(this, arguments);
      };
    }());
  }
};
/* harmony default export */ var items = ({
  namespaced: true,
  state: items_state,
  getters: getters,
  mutations: mutations,
  actions: actions
});
;// CONCATENATED MODULE: ./src/api/itemVariants.js







var VariantAttributeApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(VariantAttributeApiSet, _ApiSet);
  var _super = createSuper_createSuper(VariantAttributeApiSet);
  function VariantAttributeApiSet() {
    classCallCheck_classCallCheck(this, VariantAttributeApiSet);
    return _super.apply(this, arguments);
  }
  createClass_createClass(VariantAttributeApiSet, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata
        }, query)
      });
    }
  }]);
  return VariantAttributeApiSet;
}(apiSet);
var variantAttributesApiSet = new VariantAttributeApiSet("v1/variant-attributes");
/* harmony default export */ var itemVariants = (variantAttributesApiSet);
;// CONCATENATED MODULE: ./src/store/variantAttributes/index.js



var variantAttributes_state = {
  // TODO: real name of this is variant-attribute. I'm gonna leave it like this
  // just for now 'cause it's used in a lot of places, but I will rename it later
  // to keep consistence between API and front
  // itemVariants: [],
  variantAttributes: [],
  totalVariantAttributes: 0
};
var variantAttributes_vuexModule = new VuexModuleMaker({
  state: variantAttributes_state,
  actions: {
    getVariantAttributes: _objectSpread2({
      service: itemVariants.list.bind(itemVariants),
      attr: "variantAttributes",
      cacheAPIRequestIn: "variantAttributes/fetchVariantAttributes"
    }, actionConfigs.common.list),
    createVariantAttribute: _objectSpread2({
      service: itemVariants.create.bind(itemVariants),
      attr: "variantAttributes",
      cacheActionToDelete: "variantAttributes/fetchVariantAttributes"
    }, actionConfigs.common.create),
    editVariantAttribute: _objectSpread2({
      service: itemVariants.edit.bind(itemVariants),
      attr: "variantAttributes",
      cacheActionToDelete: "variantAttributes/fetchVariantAttributes",
      editingRefreshService: itemVariants.detail.bind(itemVariants)
    }, actionConfigs.common.edit),
    deleteVariantAttribute: {
      service: itemVariants.delete.bind(itemVariants),
      cacheActionToDelete: "variantAttributes/fetchVariantAttributes"
    }
  }
});
/* harmony default export */ var variantAttributes = (variantAttributes_vuexModule.getModule());

// const actions = {
//   createItemVariant: (context, body) => {
//     return new Promise(async (resolve, reject) => {
//       try {
//         const { data } = await variantAttributesApiSet.create(body)
//         const index = context.getters.itemVariants.findIndex(
//           variant => variant.name.toLowerCase() > data.name.toLowerCase()
//         )
//         let newItemVariants = [...context.getters.itemVariants]
//         if (index < 0) newItemVariants.push(data)
//         else newItemVariants.splice(index, 0, data)
//         context.commit(mutation_types.SET_ITEM_VARIANTS, newItemVariants)
//         resolve(data)
//       } catch (error) {
//         reject(error)
//       }
//     })
//   },
// }
;// CONCATENATED MODULE: ./src/api/remissions.js







var RemissionsApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(RemissionsApi, _ApiSet);
  var _super = createSuper_createSuper(RemissionsApi);
  function RemissionsApi() {
    classCallCheck_classCallCheck(this, RemissionsApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(RemissionsApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata,
          order_field: "date",
          order_direction: "DESC"
        }, query)
      });
    }
  }]);
  return RemissionsApi;
}(apiSet);
var remissionsApi = new RemissionsApi("v1/remissions");
/* harmony default export */ var remissions = (remissionsApi);
;// CONCATENATED MODULE: ./src/store/remissions/index.js



var remissions_state = {
  remissions: [],
  totalRemissions: 0
};
var remissions_vuexModule = new VuexModuleMaker({
  state: remissions_state,
  actions: {
    getRemissions: _objectSpread2({
      service: remissions.list.bind(remissions),
      attr: "remissions"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_remissions = (remissions_vuexModule.getModule());

// const getters = {
//   remissions: state => {
//     return state.remissions
//   },
//   totalRemissions: state => {
//     return state.totalRemissions
//   }
// }

// const mutations = {
//   setAttribute: (state, payload) => {
//     state[payload.attribute] = payload.value
//   },
//   appendAttribute: (state, payload) => {
//     state[payload.attribute].concat(payload)
//   }
// }

// const actions = {
//   getRemissions: (context, query = {}) => {
//     const append = query.append
//     delete query["append"]
//     return remissionsService.getRemissions(query).then(({ data }) => {
//       const remissions = [...data.data]
//       if (append) {
//         context.commit("setAttribute", {
//           attribute: "remissions",
//           value: [...context.state.remissions, ...remissions]
//         })
//       } else {
//         if (Array.isArray(data)) {
//           context.commit("setAttribute", { attribute: "remissions", value: [...data] })
//         } else {
//           context.commit("setAttribute", { attribute: "remissions", value: remissions })
//           context.commit("setAttribute", {
//             attribute: "totalRemissions",
//             value: data.metadata.total
//           })
//         }
//       }
//     })
//   }
// }

// export default {
//   namespaced: true,
//   state,
//   getters,
//   mutations,
//   actions
// }
;// CONCATENATED MODULE: ./src/api/remissionGuides.js








var RemissionGuidesApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(RemissionGuidesApi, _ApiSet);
  var _super = createSuper_createSuper(RemissionGuidesApi);
  function RemissionGuidesApi() {
    classCallCheck_classCallCheck(this, RemissionGuidesApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(RemissionGuidesApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata,
          order_field: "date",
          order_direction: "DESC"
        }, query)
      });
    }
  }, {
    key: "open",
    value: function open(id) {
      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return smile_ui_alegra_.request.post("".concat(this.url, "/").concat(id, "/open"), body);
    }
  }, {
    key: "void",
    value: function _void(id) {
      var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return smile_ui_alegra_.request.post("".concat(this.url, "/").concat(id, "/void"), body);
    }
  }]);
  return RemissionGuidesApi;
}(apiSet);
var remissionGuidesApi = new RemissionGuidesApi("v1/transportation-receipts");
/* harmony default export */ var remissionGuides = (remissionGuidesApi);
;// CONCATENATED MODULE: ./src/store/remissionGuides/index.js



var remissionGuides_state = {
  remissionGuides: [],
  totalRemissionGuides: 0
};
var remissionGuides_vuexModule = new VuexModuleMaker({
  state: remissionGuides_state,
  actions: {
    getRemissionGuides: _objectSpread2({
      service: remissionGuides.list.bind(remissionGuides),
      attr: "remissionGuides"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_remissionGuides = (remissionGuides_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/salesInvoices.js













var InvoicesApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(InvoicesApiSet, _ApiSet);
  var _super = createSuper_createSuper(InvoicesApiSet);
  function InvoicesApiSet() {
    var _this;
    classCallCheck_classCallCheck(this, InvoicesApiSet);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "configUrl", "".concat(baseApiConfigUrl, "v1/void-causes"));
    return _this;
  }
  createClass_createClass(InvoicesApiSet, [{
    key: "list",
    value: function list(query) {
      var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
      var BASE_API_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_API_URL"];
      var newUrl = "".concat(BASE_API_URL).concat(this.url);
      var headers = {
        Accept: "application/json",
        "Content-Type": "application/json"
      };
      if (smile_ui_alegra_.$enviroment === "production") {
        newUrl = "".concat(BASE_URL, "api/").concat(this.url);
      }
      return smile_ui_alegra_.request.get(newUrl, {
        timeout: 200000,
        params: _objectSpread2({
          metadata: true,
          order_field: "date",
          order_direction: "DESC"
        }, query),
        headers: headers
      });
    }
  }, {
    key: "listVoidCauses",
    value: function listVoidCauses(query) {
      var application_version = src_store.getters["app/appVersion"];
      return smile_ui_alegra_.request.get(this.configUrl, {
        params: _objectSpread2({
          application_version: application_version
        }, query)
      });
    }
  }, {
    key: "open",
    value: function open(id) {
      return smile_ui_alegra_.request.post("".concat(this.url, "/").concat(id, "/open"));
    }
  }, {
    key: "void",
    value: function _void(id, body) {
      return smile_ui_alegra_.request.post("".concat(this.url, "/").concat(id, "/void"), _objectSpread2({}, body));
    }
  }]);
  return InvoicesApiSet;
}(apiSet);
var invoicesApiSet = new InvoicesApiSet("v1/invoices");
/* harmony default export */ var salesInvoices = (invoicesApiSet);
;// CONCATENATED MODULE: ./src/store/salesInvoices/index.js



var salesInvoices_state = {
  invoices: [],
  totalInvoices: 0,
  voidCauses: []
};
var salesInvoices_vuexModule = new VuexModuleMaker({
  state: salesInvoices_state,
  getters: {
    exportInvoiceSettingsActive: function exportInvoiceSettingsActive(state, getters, rootState, rootGetters) {
      return rootGetters["session/company"] && rootGetters["session/company"].settings.canCreateExportInvoice;
    }
  },
  actions: {
    getInvoices: _objectSpread2({
      service: salesInvoices.list.bind(salesInvoices),
      attr: "invoices"
    }, actionConfigs.common.list),
    getVoidCauses: {
      service: salesInvoices.listVoidCauses.bind(salesInvoices),
      attr: "voidCauses",
      append: true
    }
  }
});
/* harmony default export */ var store_salesInvoices = (salesInvoices_vuexModule.getModule());

// const getters = {
//   exportInvoiceSettingsActive: (state, getters, rootState, rootGetters) => {
//     return (
//       rootGetters["session/company"] &&
//       (rootGetters["session/company"].settings.canCreateExportInvoice ||
//         rootGetters["session/company"].settings.canCreateAiuInvoice)
//     )
//   },
//   invoices: state => {
//     return state.invoices
//   },
//   totalInvoices: state => {
//     return state.totalInvoices
//   },
//   voidCauses: state => state.voidCauses
// }

// const mutations = {
//   setAttribute: (state, payload) => {
//     state[payload.attribute] = payload.value
//   },
//   appendAttribute: (state, payload) => {
//     state[payload.attribute].concat(payload.value)
//   },
//   SET_INVOICES: (state, payload) => {
//     state.invoices = payload
//   },
//   SET_TOTAL_INVOICES: (state, payload) => {
//     state.totalInvoices = payload
//   },
//   SET_VOID_CAUSES: (state, payload) => {
//     state.voidCauses = payload
//   }
// }

// const actions = {
//   getInvoices: (context, query = {}) => {
//     return new Promise(async (resolve, reject) => {
//       try {
//         const append = query.append
//         delete query["append"]
//         const { data } = await salesInvoicesService.list(query)
//         if (Array.isArray(data)) {
//           context.commit("SET_INVOICES", data)
//           resolve(data)
//         } else {
//           const invoices = [...data.data]
//           if (append) {
//             context.commit("SET_INVOICES", [...context.state.invoices, ...invoices])
//             resolve([...context.state.invoices, ...invoices])
//           } else {
//             context.commit("SET_INVOICES", invoices)
//             context.commit("SET_TOTAL_INVOICES", data.metadata.total)
//             resolve(invoices)
//           }
//         }
//       } catch (error) {
//         reject(error)
//       }
//     })
//   },
//   getVoidCauses: (context, query) => {
//     return new Promise(async (resolve, reject) => {
//       try {
//         const { data } = await salesInvoicesService.listVoidCauses(query)
//         context.commit("SET_VOID_CAUSES", data)
//         resolve(data)
//       } catch (error) {
//         reject(error)
//       }
//     })
//   }
// }

// export default {
//   namespaced: true,
//   state,
//   getters,
//   mutations,
//   actions
// }
;// CONCATENATED MODULE: ./src/api/taxes.js

// import { request } from "@alegradev/smile-ui-alegra"
// import store from "../store"

var taxApi = new apiSet("v1/taxes");

// const configUrl = "https://config.alegra.com/api/v1/tax-types"

// export function getTaxTypes() {
//   const application_version = store.getters["app/appVersion"]
//   return request.get(configUrl, {
//     params: {
//       application_version
//     }
//   })
// }

/* harmony default export */ var api_taxes = (taxApi);
;// CONCATENATED MODULE: ./src/store/taxes/index.js











// import * as mutation_types from "./mutation_types"

var taxes_state = {
  taxes: []
};
var taxes_vuexModule = new VuexModuleMaker({
  state: taxes_state,
  getters: {
    multitax: function multitax(state, getters, rootState, rootGetters) {
      var company = rootGetters["session/company"];
      var $isVersion = rootGetters["app/$isVersion"];
      // https://alegraweb.atlassian.net/browse/INV-16
      return !$isVersion("peru") && company.multitax;
    }
  },
  actions: {
    getTaxes: function getTaxes(context) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resolve, reject) {
          var _yield$taxApiSet$list, data, taxes;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return api_taxes.list();
              case 3:
                _yield$taxApiSet$list = _context.sent;
                data = _yield$taxApiSet$list.data;
                taxes = data.map(function (tax) {
                  return _objectSpread2(_objectSpread2({}, tax), {}, {
                    text: "".concat(tax.name, " - (").concat(tax.percentage, "%)")
                  });
                }).filter(function (tax) {
                  return tax.status === "active";
                });
                context.commit("SET_TAXES", taxes);
                resolve(taxes);
                _context.next = 13;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);
              case 13:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 10]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    createTax: function createTax(context, body) {
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(resolve, reject) {
          var _yield$taxApiSet$crea, data, newTax, newTaxes;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return api_taxes.create(body);
              case 3:
                _yield$taxApiSet$crea = _context2.sent;
                data = _yield$taxApiSet$crea.data;
                newTax = _objectSpread2(_objectSpread2({}, data), {}, {
                  text: "".concat(data.name, " - (").concat(data.percentage, "%)"),
                  value: data.id
                });
                newTaxes = [].concat(_toConsumableArray(context.getters.taxes), [newTax]);
                context.commit("SET_TAXES", newTaxes);
                resolve(newTax);
                _context2.next = 14;
                break;
              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);
                reject(_context2.t0);
              case 14:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 11]]);
        }));
        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }
});
/* harmony default export */ var taxes = (taxes_vuexModule.getModule());

// const getters = {
//   multitax: (state, getters, rootState, rootGetters) => {
//     const company = rootGetters["session/company"]
//     const $isVersion = rootGetters["app/$isVersion"]
//     // https://alegraweb.atlassian.net/browse/INV-16
//     return !$isVersion("mexico", "peru") && company.multitax
//   },
//   taxes: state => {
//     return state.taxes
//   }
// }

// const mutations = {
//   [mutation_types.SET_TAXES]: (state, payload) => {
//     state.taxes = payload
//   }
// }

// const actions = {
//   getTaxes: context => {
//     taxApiSet.list().then(resp => {
//       const data = resp.data
//         .map(tax => ({
//           ...tax,
//           text: `${tax.name} - (${parseInt(tax.percentage)}%)`
//         }))
//         .filter(tax => tax.status === "active")
//       context.commit(mutation_types.SET_TAXES, data)
//     })
//   },
//   createTax: (context, body) => {
//     return new Promise(async (resolve, reject) => {
//       try {
//         const { data } = await taxApiSet.create(body)
//         const newTax = {
//           ...data,
//           text: `${data.name} - (${parseInt(data.percentage)}%)`,
//           value: data.id
//         }

//         let newTaxes = [...context.getters.taxes, newTax]
//         context.commit(mutation_types.SET_TAXES, newTaxes)
//         resolve(newTax)
//       } catch (error) {
//         reject(error)
//       }
//     })
//   }
// }

// export default {
//   namespaced: true,
//   state,
//   getters,
//   mutations,
//   actions
// }
;// CONCATENATED MODULE: ./src/api/units.js



var units_configBaseUrl = "".concat(baseApiConfigUrl, "v2/units/");
function getUnitsFromApi(version, filters) {
  return (0,smile_ui_alegra_.request)({
    url: units_configBaseUrl,
    method: "get",
    params: _objectSpread2({
      deprecated: version === "colombia" ? false : undefined,
      application_version: version
    }, filters)
  });
}
;// CONCATENATED MODULE: ./src/store/units/helpers.js


var VERSIONS_WITH_UNITS_BY_GROUP = ["colombia", "argentina", "chile", "costaRica", "spain", "kenya", "nigeria", "panama", "peru", "southAfrica", "usa"];
function groupUnits(units, $isVersion) {
  var byGroup = {};
  if ($isVersion(VERSIONS_WITH_UNITS_BY_GROUP)) {
    var _iterator = createForOfIteratorHelper_createForOfIteratorHelper(units),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var unit = _step.value;
        addUnitToGroup(unit, byGroup);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return byGroup;
}
function addUnitToGroup(unit, groups) {
  if (groups[unit.unitType]) groups[unit.unitType].push(unit);else groups[unit.unitType] = [unit];
}
;// CONCATENATED MODULE: ./src/store/units/index.js










var units_state = function state() {
  return {
    units: [],
    unitsForService: [],
    unitsByGroup: {}
  };
};
var units_vuexModule = new VuexModuleMaker({
  state: units_state(),
  actions: {
    fetchUnits: function fetchUnits(context, requestParams) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resolve, reject) {
          var appVersion, userLenguage, _yield$getUnitsFromAp, data;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                appVersion = context.rootGetters["app/appVersion"];
                userLenguage = context.rootGetters["app/userLenguage"].split("_")[0];
                if (appVersion === "mexico" && !requestParams.query && requestParams.most_used === undefined) {
                  requestParams.most_used = true;
                }
                _context.next = 6;
                return getUnitsFromApi(appVersion, _objectSpread2(_objectSpread2({}, requestParams), {}, {
                  lang: userLenguage
                }));
              case 6:
                _yield$getUnitsFromAp = _context.sent;
                data = _yield$getUnitsFromAp.data;
                resolve(data);
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);
              case 14:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 11]]);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getUnitsFromApi: (0,external_vuex_cache_namespaceObject.cacheAction)(function (context, requestParams) {
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(resolve, reject) {
          var data, unitsForService, unitsForProducts, unitsByGroup;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return context.cache.dispatch("fetchUnits", requestParams);
              case 3:
                data = _context2.sent;
                if (requestParams.item_type && requestParams.item_type === "service") {
                  // this is need because API is not filtering by item_type when query is sent as a param in the request
                  unitsForService = data.filter(function (unit) {
                    return unit.itemType === "service";
                  });
                  context.commit("SET_UNITS_FOR_SERVICE", unitsForService);
                } else if (requestParams.item_type) {
                  // this is need because API is not filtering by item_type when query is sent as a param in the request
                  unitsForProducts = data.filter(function (unit) {
                    return unit.itemType === "product";
                  });
                  context.commit("SET_UNITS", unitsForProducts);
                } else context.commit("SET_UNITS", data);
                unitsByGroup = groupUnits(data, context.rootGetters["app/$isVersion"]);
                context.commit("SET_UNITS_BY_GROUP", unitsByGroup);
                return _context2.abrupt("return", resolve(data));
              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                reject(_context2.t0);
              case 13:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 10]]);
        }));
        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    })
  }
});
/* harmony default export */ var units = (units_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/warehouses.js










var WareHousesApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(WareHousesApiSet, _ApiSet);
  var _super = createSuper_createSuper(WareHousesApiSet);
  function WareHousesApiSet() {
    var _this;
    classCallCheck_classCallCheck(this, WareHousesApiSet);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "transferUrl", "v1/warehouse-transfers");
    return _this;
  }
  createClass_createClass(WareHousesApiSet, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata
        }, query)
      });
    }
  }, {
    key: "listTransfers",
    value: function listTransfers(query) {
      return smile_ui_alegra_.request.get(this.transferUrl, {
        params: query
      });
    }
  }]);
  return WareHousesApiSet;
}(apiSet);
var warehousesApi = new WareHousesApiSet("v1/warehouses");
/* harmony default export */ var warehouses = (warehousesApi);
;// CONCATENATED MODULE: ./src/store/warehouses/index.js





var warehouses_state = {
  warehouses: [],
  totalWarehouses: 0,
  warehouseTransfers: []
};
var warehouses_vuexModule = new VuexModuleMaker({
  state: warehouses_state,
  getters: {
    activeWarehouses: function activeWarehouses(state) {
      return state.warehouses.filter(function (w) {
        return w.status === "active";
      });
    },
    totalWarehouses: function totalWarehouses(state) {
      return state.totalWarehouses;
    }
  },
  actions: {
    getWarehouses: _objectSpread2({
      service: warehouses.list.bind(warehouses),
      attr: "warehouses",
      cacheAPIRequestIn: "warehouses/fetchWarehouses"
    }, actionConfigs.common.list),
    createWarehouse: _objectSpread2({
      service: warehouses.create.bind(warehouses),
      attr: "warehouses",
      cacheActionToDelete: "warehouses/fetchWarehouses"
    }, actionConfigs.common.create),
    editWarehouse: _objectSpread2({
      service: warehouses.edit.bind(warehouses),
      attr: "warehouses",
      editingRefreshService: warehouses.detail.bind(warehouses)
    }, actionConfigs.common.edit),
    deleteWarehouse: {
      service: warehouses.delete.bind(warehouses),
      cacheActionToDelete: "warehouses/fetchWarehouses"
    },
    getWarehouseTransfers: {
      service: warehouses.listTransfers.bind(warehouses),
      attr: "warehouseTransfers",
      cacheAPIRequestIn: "warehouses/fetchWarehouseTransfers",
      append: true
    }
  }
});
/* harmony default export */ var store_warehouses = (warehouses_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/purchaseOrders.js








var PurchaseOrderApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(PurchaseOrderApi, _ApiSet);
  var _super = createSuper_createSuper(PurchaseOrderApi);
  function PurchaseOrderApi() {
    classCallCheck_classCallCheck(this, PurchaseOrderApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(PurchaseOrderApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata
        }, query)
      });
    }
  }, {
    key: "void",
    value: function _void(id) {
      return smile_ui_alegra_.request.post("".concat(this.url, "/").concat(id, "/void"));
    }
  }]);
  return PurchaseOrderApi;
}(apiSet);
var purchaseOrdersApi = new PurchaseOrderApi("v1/purchase-orders");
/* harmony default export */ var purchaseOrders = (purchaseOrdersApi);
;// CONCATENATED MODULE: ./src/store/purchaseOrders/index.js



var purchaseOrders_state = {
  purchaseOrders: [],
  totalPurchaseOrders: 0
};
var purchaseOrders_vuexModule = new VuexModuleMaker({
  state: purchaseOrders_state,
  actions: {
    getPurchaseOrders: _objectSpread2({
      service: purchaseOrders.list.bind(purchaseOrders),
      attr: "purchaseOrders"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_purchaseOrders = (purchaseOrders_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/pricesList.js







var PricesListApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(PricesListApiSet, _ApiSet);
  var _super = createSuper_createSuper(PricesListApiSet);
  function PricesListApiSet() {
    classCallCheck_classCallCheck(this, PricesListApiSet);
    return _super.apply(this, arguments);
  }
  createClass_createClass(PricesListApiSet, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata
        }, query)
      });
    }
  }]);
  return PricesListApiSet;
}(apiSet);
var pricesListApiSet = new PricesListApiSet("v1/price-lists");
/* harmony default export */ var pricesList = (pricesListApiSet);
;// CONCATENATED MODULE: ./src/store/pricesLists/index.js



var pricesLists_state = {
  pricesLists: [],
  totalPricesLists: 0
};
var pricesLists_vuexModule = new VuexModuleMaker({
  state: pricesLists_state,
  actions: {
    createPricesList: _objectSpread2({
      service: pricesList.create.bind(pricesList),
      attr: "pricesLists"
    }, actionConfigs.common.create),
    getPricesLists: _objectSpread2({
      service: pricesList.list.bind(pricesList),
      attr: "pricesLists"
    }, actionConfigs.common.list),
    editPricesList: _objectSpread2({
      service: pricesList.edit.bind(pricesList),
      attr: "pricesLists"
    }, actionConfigs.common.edit),
    deletePricesList: {
      service: pricesList.delete.bind(pricesList)
    }
  }
});
/* harmony default export */ var pricesLists = (pricesLists_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/itemCategories.js







var ItemCategoriesApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(ItemCategoriesApiSet, _ApiSet);
  var _super = createSuper_createSuper(ItemCategoriesApiSet);
  function ItemCategoriesApiSet() {
    classCallCheck_classCallCheck(this, ItemCategoriesApiSet);
    return _super.apply(this, arguments);
  }
  createClass_createClass(ItemCategoriesApiSet, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata
        }, query)
      });
    }
  }, {
    key: "attachment",
    value: function attachment(id, body) {
      return smile_ui_alegra_.request.post(this.url + "/".concat(id, "/attachment"), body, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    }
  }]);
  return ItemCategoriesApiSet;
}(apiSet);
var itemCategoriesApiSet = new ItemCategoriesApiSet("v1/item-categories");
/* harmony default export */ var api_itemCategories = (itemCategoriesApiSet);
;// CONCATENATED MODULE: ./src/store/itemCategories/mutation_types.js
var SET_ITEM_CATEGORIES = "SET_ITEM_CATEGORIES";
;// CONCATENATED MODULE: ./src/store/itemCategories/itemCategoriesStoreHelpers.js




function attachImage(_x, _x2) {
  return _attachImage.apply(this, arguments);
}
function _attachImage() {
  _attachImage = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(id, image) {
    var _yield$itemCategories, data;
    return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!image) {
            _context.next = 13;
            break;
          }
          _context.prev = 1;
          _context.next = 4;
          return api_itemCategories.attachment(id, image);
        case 4:
          _yield$itemCategories = _context.sent;
          data = _yield$itemCategories.data;
          return _context.abrupt("return", data);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          logError(_context.t0, this, "attachImage");
          showError(_context.t0, this);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, this, [[1, 9]]);
  }));
  return _attachImage.apply(this, arguments);
}
;// CONCATENATED MODULE: ./src/store/itemCategories/index.js














var itemCategories_state = {
  itemCategories: [],
  totalItemCategories: 0
};
var itemCategories_vuexModule = new VuexModuleMaker({
  state: itemCategories_state,
  getters: {
    activeItemCategories: function activeItemCategories(state) {
      return state.itemCategories.filter(function (iC) {
        return iC.status === "active";
      });
    }
  },
  actions: {
    createItemCategory: function createItemCategory(context, _ref) {
      var body = _ref.body,
        image = _ref.image;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(resolve, reject) {
          var _yield$itemCategories, data, itemCategory, itemCategories, imageResponse;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return api_itemCategories.create(body);
              case 3:
                _yield$itemCategories = _context.sent;
                data = _yield$itemCategories.data;
                itemCategory = _objectSpread2(_objectSpread2({}, data), {}, {
                  text: data.name,
                  value: data.id
                });
                itemCategories = [].concat(_toConsumableArray(context.getters.itemCategories), [itemCategory]);
                context.commit(SET_ITEM_CATEGORIES, itemCategories);
                _context.next = 10;
                return attachImage(data.id, image);
              case 10:
                imageResponse = _context.sent;
                if (!imageResponse) imageResponse = itemCategory.image;
                resolve(_objectSpread2(_objectSpread2({}, itemCategory), {}, {
                  image: imageResponse,
                  editable: true
                }));
                _context.next = 18;
                break;
              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);
              case 18:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 15]]);
        }));
        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    getItemCategories: _objectSpread2({
      service: api_itemCategories.list.bind(api_itemCategories),
      attr: "itemCategories"
    }, actionConfigs.common.list),
    deleteItemCategory: {
      service: api_itemCategories.delete.bind(api_itemCategories)
    },
    editItemCategory: function editItemCategory(context, _ref3) {
      var id = _ref3.id,
        body = _ref3.body,
        refresh = _ref3.refresh,
        image = _ref3.image;
      return new Promise( /*#__PURE__*/function () {
        var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(resolve, reject) {
          var _yield$itemCategories2, data, itemCategories, updatedIndex, response, imageResponse;
          return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return api_itemCategories.edit(id, body);
              case 3:
                _yield$itemCategories2 = _context2.sent;
                data = _yield$itemCategories2.data;
                itemCategories = context.getters.itemCategories;
                updatedIndex = itemCategories.findIndex(function (item) {
                  return item.id === id;
                });
                if (!refresh) {
                  _context2.next = 12;
                  break;
                }
                _context2.next = 10;
                return api_itemCategories.detail(id, {
                  fields: "editable,deletable"
                });
              case 10:
                response = _context2.sent;
                data = response.data;
              case 12:
                itemCategories[updatedIndex] = data;
                context.commit(SET_ITEM_CATEGORIES, itemCategories);
                _context2.next = 16;
                return attachImage(data.id, image);
              case 16:
                imageResponse = _context2.sent;
                if (!imageResponse) imageResponse = data.image;
                return _context2.abrupt("return", resolve(_objectSpread2(_objectSpread2({}, data), {}, {
                  image: imageResponse,
                  editable: true
                })));
              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](0);
                reject(_context2.t0);
              case 24:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 21]]);
        }));
        return function (_x3, _x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }
});
/* harmony default export */ var itemCategories = (itemCategories_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/rejectionConcepts.js



var rejectionConcepts_configBaseUrl = baseApiConfigUrl;
function getRejectionConcepts() {
  var application_version = src_store.getters["app/appVersion"];
  // return request.get('/items');
  return smile_ui_alegra_.request.get(rejectionConcepts_configBaseUrl + "v1/rejection-concepts", {
    params: {
      application_version: application_version
    }
  });
}
;// CONCATENATED MODULE: ./src/store/rejectionConcepts/index.js


var rejectionConcepts_state = function state() {
  return {
    rejectionConcepts: []
  };
};
var rejectionConcepts_vuexModule = new VuexModuleMaker({
  state: rejectionConcepts_state(),
  actions: {
    getRejectionConcepts: {
      service: getRejectionConcepts,
      attr: "rejectionConcepts"
    }
  }
});
/* harmony default export */ var rejectionConcepts = (rejectionConcepts_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/store/featureFlags/index.js


var _showTogglers = ["local", "testing", "development"].includes("production");
var featureFlags_state = {};
var featureFlags_getters = {
  showTestABProductTypeDOM: function showTestABProductTypeDOM(state, getters, rootState, rootGetters) {
    return false;
    // eslint-disable-next-line no-unreachable
    return rootGetters["session/user"] && rootGetters["session/user"].membership.planKeyword === "demo" && rootGetters["app/$isVersion"]("republicaDominicana") && Number(rootGetters["session/user"].id) % 2 === 1;
  },
  showTogglers: function showTogglers() {
    return _showTogglers;
  }
};
var featureFlags_mutations = {
  SET_SHOW_TEST_AB_PRODUCT_TYPE_DOM: function SET_SHOW_TEST_AB_PRODUCT_TYPE_DOM(state, payload) {
    state.showTestABProductTypeDOM = payload;
  }
};
/* harmony default export */ var featureFlags = ({
  namespaced: true,
  state: featureFlags_state,
  getters: featureFlags_getters,
  mutations: featureFlags_mutations
});
;// CONCATENATED MODULE: ./src/store/legalSettings/index.js


var legalSettings_state = {
  // productKeys: [],
  categoriesNoIvaDays: [],
  genresNoIvaDays: []
};
var legalSettings_vuexModule = new VuexModuleMaker({
  state: legalSettings_state,
  actions: {
    getIVACategories: {
      service: getIVACategories,
      attr: "categoriesNoIvaDays",
      cacheAPIRequestIn: "legalSettings/fetchIVACategories"
    },
    getIVAGenres: {
      service: getIVAGenres,
      attr: "genresNoIvaDays",
      cacheAPIRequestIn: "legalSettings/fetchIVAGenres"
    }
  }
});
/* harmony default export */ var legalSettings = (legalSettings_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/inventoryAdjustments.js










var InventoryAdjustmentsApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(InventoryAdjustmentsApi, _ApiSet);
  var _super = createSuper_createSuper(InventoryAdjustmentsApi);
  function InventoryAdjustmentsApi() {
    classCallCheck_classCallCheck(this, InventoryAdjustmentsApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(InventoryAdjustmentsApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata
        }, query)
      });
    }
  }, {
    key: "edit",
    value: function edit(id, body) {
      var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
      var newUrl = "".concat(BASE_URL, "api/").concat(this.url, "/").concat(id);
      var headers = {
        Accept: "application/json",
        "Content-Type": "application/json"
      };
      return smile_ui_alegra_.request.put(newUrl, body, {
        timeout: 600000,
        headers: headers
      });
    }
  }, {
    key: "create",
    value: function create(body) {
      var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
      var newUrl = "".concat(BASE_URL, "api/").concat(this.url);
      var headers = {
        Accept: "application/json",
        "Content-Type": "application/json"
      };
      return smile_ui_alegra_.request.post(newUrl, body, {
        timeout: 600000,
        headers: headers
      });
    }
  }, {
    key: "detail",
    value: function detail(id, query) {
      var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
      var BASE_API_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_API_URL"];
      var newUrl = "".concat(BASE_API_URL).concat(this.url, "/").concat(id);
      var headers = {
        Accept: "application/json",
        "Content-Type": "application/json"
      };
      if (smile_ui_alegra_.$enviroment === "production") {
        newUrl = "".concat(BASE_URL, "api/").concat(this.url, "/").concat(id);
      }
      return smile_ui_alegra_.request.get(newUrl, {
        timeout: 600000,
        params: query,
        headers: headers
      });
    }
  }, {
    key: "exportInventoryAdjustment",
    value: function exportInventoryAdjustment(fromDate, toDate) {
      var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
      var config = {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      };
      var user = "grace";
      var pass = "alegraTesters!";
      if (smile_ui_alegra_.$enviroment !== "production") {
        config["auth"] = {
          username: user,
          password: pass
        };
      }
      var url = "".concat(BASE_URL, "labs/test11/exportable-type/inventory-adjustments/format/json");
      if (fromDate && toDate) url += "/from-date/".concat(fromDate, "/to-date/").concat(toDate);
      return external_axios_default().post(url, {}, config);
    }
  }]);
  return InventoryAdjustmentsApi;
}(apiSet);
var inventoryAdjustmentsApi = new InventoryAdjustmentsApi("v1/inventory-adjustments");
/* harmony default export */ var inventoryAdjustments = (inventoryAdjustmentsApi);
;// CONCATENATED MODULE: ./src/store/inventoryAdjustments/index.js



var inventoryAdjustments_state = {
  inventoryAdjustments: [],
  totalInventoryAdjustments: 0
};
var inventoryAdjustments_vuexModule = new VuexModuleMaker({
  state: inventoryAdjustments_state,
  actions: {
    getInventoryAdjustments: _objectSpread2({
      service: inventoryAdjustments.list.bind(inventoryAdjustments),
      attr: "inventoryAdjustments",
      cacheAPIRequestIn: "inventoryAdjustments/fetchInventoryAdjustments"
    }, actionConfigs.common.list),
    createInventoryAdjustment: _objectSpread2({
      service: inventoryAdjustments.create.bind(inventoryAdjustments),
      attr: "inventoryAdjustments",
      cacheActionToDelete: "inventoryAdjustments/fetchInventoryAdjustments"
    }, actionConfigs.common.create),
    editInventoryAdjustment: _objectSpread2({
      service: inventoryAdjustments.edit.bind(inventoryAdjustments),
      attr: "inventoryAdjustments",
      cacheActionToDelete: "inventoryAdjustments/fetchInventoryAdjustments",
      editingRefreshService: inventoryAdjustments.detail.bind(inventoryAdjustments)
    }, actionConfigs.common.edit),
    deleteInventoryAdjustment: {
      service: inventoryAdjustments.delete.bind(inventoryAdjustments),
      cacheActionToDelete: "inventoryAdjustments/fetchInventoryAdjustments"
    }
  }
});
/* harmony default export */ var store_inventoryAdjustments = (inventoryAdjustments_vuexModule.getModule());
// EXTERNAL MODULE: external "lodash-es"
var external_lodash_es_ = __webpack_require__(8517);
;// CONCATENATED MODULE: ./src/store/permissions/index.js


var MAP_ROUTENAME_TO_PERMISSION = {
  "stock-item": "items.index",
  "stock-item-add": "items.add",
  "stock-item-edit": "items.edit",
  "stock-item-detail": "items.view",
  "stock-inventory-adjustment": "inventory-adjustments.index",
  "stock-inventory-adjustment-add": "inventory-adjustments.add",
  "stock-inventory-adjustment-edit": "inventory-adjustments.edit",
  "stock-inventory-adjustment-detail": "inventory-adjustments.view",
  "stock-prices-lists": "price-lists.index",
  "stock-prices-lists-add": "price-lists.add",
  "stock-prices-lists-edit": "price-lists.edit",
  "stock-prices-lists-details": "price-lists.view",
  "stock-warehouses": "warehouses.index",
  "stock-warehouse-add": "warehouses.add",
  "stock-warehouse-edit": "warehouses.edit",
  "stock-warehouse-detail": "warehouses.view",
  "stock-warehouse-transfer": "warehouses.index-transfer",
  "stock-warehouse-transfer-add": "warehouses.add-transfer",
  "stock-warehouse-transfer-edit": "warehouses.edit-transfer",
  "stock-warehouse-transfer-detail": "warehouses.view-transfer",
  "stock-variant-attribute": "variant-attributes.index",
  "stock-variant-attribute-add": "variant-attributes.add",
  "stock-variant-attribute-edit": "variant-attributes.edit",
  "stock-variant-attribute-detail": "variant-attributes.view",
  "stock-custom-field": "custom-fields.index",
  "stock-custom-field-add": "custom-fields.add",
  "stock-custom-field-edit": "custom-fields.edit",
  "stock-custom-field-detail": "custom-fields.view",
  "stock-item-category": "categories.index",
  "stock-item-category-add": "categories.add",
  "stock-item-category-edit": "categories.edit",
  "stock-item-category-detail": "categories.view"
};
var permissions_vuexModule = new VuexModuleMaker({
  getters: {
    canExport: function canExport(state, getters) {
      return getters.permissions.exportable.items === "allow";
    },
    canViewCosts: function canViewCosts(state, getters) {
      return getters.permissions.company["user-view-costs"] === "allow";
    },
    permissions: function permissions(state, getters, rootState, rootGetters) {
      return rootGetters["session/user"].permissions;
    },
    $hasPermission: function $hasPermission(state, getters) {
      return function (routeName) {
        try {
          // Plan consulta
          //const planName = rootGetters["session/user"].membership.planName
          //if (
          //  planName === "Plan Consulta" &&
          //  (routeName.includes("add") || routeName.includes("edit"))
          //)
          //  return false

          // Check scopes
          var permissions = getters.permissions;
          if (routeName === "stock-item-edit" && !getters.canViewCosts) return false;
          return (0,external_lodash_es_.get)(permissions, MAP_ROUTENAME_TO_PERMISSION[routeName], "allow") === "allow";
        } catch (_unused) {
          return true;
        }
      };
    }
  }
});
/* harmony default export */ var permissions = (permissions_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/incomeDebitNotes.js







var IncomeDebitNoteApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(IncomeDebitNoteApiSet, _ApiSet);
  var _super = createSuper_createSuper(IncomeDebitNoteApiSet);
  function IncomeDebitNoteApiSet() {
    classCallCheck_classCallCheck(this, IncomeDebitNoteApiSet);
    return _super.apply(this, arguments);
  }
  createClass_createClass(IncomeDebitNoteApiSet, [{
    key: "list",
    value: function list(query) {
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: true,
          order_field: "date",
          order_direction: "DESC"
        }, query)
      });
    }
  }]);
  return IncomeDebitNoteApiSet;
}(apiSet);
var incomeDebitNoteApiSet = new IncomeDebitNoteApiSet("v1/income-debit-notes");
/* harmony default export */ var incomeDebitNotes = (incomeDebitNoteApiSet);
;// CONCATENATED MODULE: ./src/store/incomeDebitNotes/index.js



var incomeDebitNotes_state = {
  incomeDebitNotes: [],
  totalIncomeDebitNotes: 0
};
var incomeDebitNotes_vuexModule = new VuexModuleMaker({
  state: incomeDebitNotes_state,
  actions: {
    getIncomeDebitNotes: _objectSpread2({
      service: incomeDebitNotes.list.bind(incomeDebitNotes),
      attr: "incomeDebitNotes"
    }, actionConfigs.common.list)
  }
}, {
  namespaced: true
});
/* harmony default export */ var store_incomeDebitNotes = (incomeDebitNotes_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/warehouseTransfers.js











var WareHouseTransfersApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(WareHouseTransfersApiSet, _ApiSet);
  var _super = createSuper_createSuper(WareHouseTransfersApiSet);
  function WareHouseTransfersApiSet() {
    var _this;
    classCallCheck_classCallCheck(this, WareHouseTransfersApiSet);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "transferUrl", "v1/warehouse-transfers");
    return _this;
  }
  createClass_createClass(WareHouseTransfersApiSet, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          metadata: metadata
        }, query)
      });
    }
  }, {
    key: "edit",
    value: function edit(id, body) {
      var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
      var newUrl = "".concat(BASE_URL, "api/").concat(this.url, "/").concat(id);
      var headers = {
        Accept: "application/json",
        "Content-Type": "application/json"
      };
      return smile_ui_alegra_.request.put(newUrl, body, {
        timeout: 600000,
        headers: headers
      });
    }
  }, {
    key: "create",
    value: function create(body) {
      var BASE_URL = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_URL"];
      var newUrl = "".concat(BASE_URL, "api/").concat(this.url);
      var headers = {
        Accept: "application/json",
        "Content-Type": "application/json"
      };
      return smile_ui_alegra_.request.post(newUrl, body, {
        timeout: 600000,
        headers: headers
      });
    }
  }]);
  return WareHouseTransfersApiSet;
}(apiSet);
var warehouseTransfersApi = new WareHouseTransfersApiSet("v1/warehouse-transfers");
/* harmony default export */ var warehouseTransfers = (warehouseTransfersApi);
;// CONCATENATED MODULE: ./src/store/warehouseTransfers/index.js



var warehouseTransfers_state = {
  warehouseTransfers: [],
  totalWarehouseTransfers: 0
};
var warehouseTransfers_vuexModule = new VuexModuleMaker({
  state: warehouseTransfers_state,
  actions: {
    getWarehouseTransfers: _objectSpread2({
      service: warehouseTransfers.list.bind(warehouseTransfers),
      attr: "warehouseTransfers"
    }, actionConfigs.common.list),
    createWarehouseTransfer: _objectSpread2({
      service: warehouseTransfers.create.bind(warehouseTransfers),
      attr: "warehouseTransfers"
    }, actionConfigs.common.create),
    editWarehouseTransfer: _objectSpread2({
      service: warehouseTransfers.edit.bind(warehouseTransfers),
      attr: "warehouseTransfers",
      editingRefreshService: warehouseTransfers.detail.bind(warehouseTransfers)
    }, actionConfigs.common.edit),
    deleteWarehouseTransfer: {
      service: warehouseTransfers.delete.bind(warehouseTransfers)
    }
  }
});
/* harmony default export */ var store_warehouseTransfers = (warehouseTransfers_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/adjustmentNotes.js







var AdjustmentNotesApi = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(AdjustmentNotesApi, _ApiSet);
  var _super = createSuper_createSuper(AdjustmentNotesApi);
  function AdjustmentNotesApi() {
    classCallCheck_classCallCheck(this, AdjustmentNotesApi);
    return _super.apply(this, arguments);
  }
  createClass_createClass(AdjustmentNotesApi, [{
    key: "list",
    value: function list(query) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return smile_ui_alegra_.request.get(this.url, {
        params: _objectSpread2({
          type: "adjustmentNote",
          metadata: metadata,
          order_field: "date",
          order_direction: "DESC"
        }, query)
      });
    }
  }]);
  return AdjustmentNotesApi;
}(apiSet);
var adjustmentNotesApi = new AdjustmentNotesApi("v1/debit-notes");
/* harmony default export */ var adjustmentNotes = (adjustmentNotesApi);
;// CONCATENATED MODULE: ./src/store/adjustmentNotes/index.js



var adjustmentNotes_state = {
  adjustmentNotes: [],
  totalAdjustmentNotes: 0
};
var adjustmentNotes_vuexModule = new VuexModuleMaker({
  state: adjustmentNotes_state,
  actions: {
    getAdjustmentNotes: _objectSpread2({
      service: adjustmentNotes.list.bind(adjustmentNotes),
      attr: "adjustmentNotes"
    }, actionConfigs.common.list)
  }
});
/* harmony default export */ var store_adjustmentNotes = (adjustmentNotes_vuexModule.getModule());
;// CONCATENATED MODULE: ./src/api/districts.js


var districts_getDistricts = function getDistricts(version, query) {
  var configBaseUrl = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_API_CONFIG_URL"];
  return (0,smile_ui_alegra_.request)({
    url: configBaseUrl + "v1/districts?application_version=".concat(version),
    params: query
  });
};

;// CONCATENATED MODULE: ./src/store/districts/index.js



/* harmony default export */ var districts = ({
  state: {
    districts: []
  },
  mutations: {
    setDistricts: function setDistricts(state, payload) {
      state.districts = payload;
    }
  },
  getters: {
    districts: function districts(state) {
      return state.districts;
    }
  },
  actions: {
    getDistricts: function () {
      var _getDistricts2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(context, _ref) {
        var version, query, _yield$_getDistricts, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              version = _ref.version, query = _ref.query;
              _context.next = 3;
              return districts_getDistricts(version, query);
            case 3:
              _yield$_getDistricts = _context.sent;
              data = _yield$_getDistricts.data;
              context.commit("setDistricts", data);
              return _context.abrupt("return", data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getDistricts(_x, _x2) {
        return _getDistricts2.apply(this, arguments);
      }
      return getDistricts;
    }()
  },
  namespaced: true
});
;// CONCATENATED MODULE: ./src/api/exportInvoice.js


var getTariffFraction = function getTariffFraction(version, query) {
  return (0,smile_ui_alegra_.request)({
    url: baseApiConfigUrl + "v1/tariff-fraction?application_version=".concat(version),
    params: query
  });
};
var exportInvoice_getForeignTradeUnits = function getForeignTradeUnits(version, query) {
  return (0,smile_ui_alegra_.request)({
    url: baseApiConfigUrl + "v1/foreign-trade-units?application_version=".concat(version),
    params: query
  });
};

;// CONCATENATED MODULE: ./src/store/exportInvoice/index.js








/* harmony default export */ var exportInvoice = ({
  state: {
    tariffFractions: [],
    foreignTradeUnits: []
  },
  mutations: {
    setTariffFractions: function setTariffFractions(state, payload) {
      state.tariffFractions = payload;
    },
    setForeignTradeUnits: function setForeignTradeUnits(state, payload) {
      state.foreignTradeUnits = payload;
    }
  },
  getters: {
    tariffFractions: function tariffFractions(state) {
      return state.tariffFractions;
    },
    foreignTradeUnits: function foreignTradeUnits(state) {
      return state.foreignTradeUnits;
    },
    showExportInvoiceMex: function showExportInvoiceMex(state, getters, rootState, rootGetters) {
      var _rootGetters$session;
      var REGIMES = ["BUSINESS_ACTIVITIES_REGIME", "FISCAL_INCORPORATION_REGIME", "REGIME_OF_THE_TECHNOLOGICAL_PLATFORMS_INCOME_ACTIVITIES", "GENERAL_REGIME_OF_MORAL_PEOPLE_LAW", "REGIME_OF_MORAL_PEOPLE_NOT_PROFIT", "REGIME_OF_COOPERATIVE_PRODUCTION_SOCIETIES", "PRIMARY_SECTOR_REGIME", "REGIME_OF_THE_COORDINATED", "REGIME_OF_TRUST", "SOCIETIES_OPTIONAL_REGIME"];
      var regimes = (_rootGetters$session = rootGetters["session/company"].regimes) !== null && _rootGetters$session !== void 0 ? _rootGetters$session : [];
      return regimes.some(function (regime) {
        return REGIMES.includes(regime);
      });
    }
  },
  actions: {
    getTariffFractions: function () {
      var _getTariffFractions = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(context, _ref) {
        var version, query, _yield$getTariffFract, data, results;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              version = _ref.version, query = _ref.query;
              _context.next = 3;
              return getTariffFraction(version, query);
            case 3:
              _yield$getTariffFract = _context.sent;
              data = _yield$getTariffFract.data;
              results = data.map(function (tariffFraction) {
                return _objectSpread2({
                  text: "".concat(tariffFraction.key, " - ").concat(tariffFraction.value)
                }, tariffFraction);
              });
              context.commit("setTariffFractions", results);
              return _context.abrupt("return", data);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getTariffFractions(_x, _x2) {
        return _getTariffFractions.apply(this, arguments);
      }
      return getTariffFractions;
    }(),
    getForeignTradeUnits: function () {
      var _getForeignTradeUnits2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(context, _ref2) {
        var version, query, _yield$_getForeignTra, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              version = _ref2.version, query = _ref2.query;
              _context2.next = 3;
              return exportInvoice_getForeignTradeUnits(version, query);
            case 3:
              _yield$_getForeignTra = _context2.sent;
              data = _yield$_getForeignTra.data;
              context.commit("setForeignTradeUnits", data);
              return _context2.abrupt("return", data);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getForeignTradeUnits(_x3, _x4) {
        return _getForeignTradeUnits2.apply(this, arguments);
      }
      return getForeignTradeUnits;
    }()
  },
  namespaced: true
});
;// CONCATENATED MODULE: ./src/api/shop.js



var shop_getShop = function getShop(idCompany) {
  var configBaseUrl = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_API_SHOP_URL"];
  return (0,smile_ui_alegra_.request)({
    url: "".concat(configBaseUrl, "stores/type?idCompany=").concat(idCompany)
  });
};
var shop_setVisibilityInShop = function setVisibilityInShop(idShop, idItem, hide) {
  var configBaseUrl = enviroment_namespaceObject[smile_ui_alegra_.$enviroment]["BASE_API_SHOP_URL"];
  return (0,smile_ui_alegra_.request)({
    method: "PATCH",
    url: "".concat(configBaseUrl, "stores/").concat(idShop, "/items-config/").concat(idItem),
    data: {
      hide: hide
    }
  });
};

;// CONCATENATED MODULE: ./src/store/shop/index.js









/* harmony default export */ var shop = ({
  state: {
    type: "none",
    status: "inactive",
    id: null
  },
  mutations: {
    setShop: function setShop(state, payload) {
      state.type = payload.type;
      state.status = payload.status;
      state.id = payload.id;
    }
  },
  getters: {
    shop: function shop(state) {
      return state;
    }
  },
  actions: {
    getShop: function () {
      var _getShop2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee(context) {
        var idCompany, _yield$_getShop, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              idCompany = context.rootGetters["session/company"].id;
              _context.next = 3;
              return shop_getShop(idCompany);
            case 3:
              _yield$_getShop = _context.sent;
              data = _yield$_getShop.data;
              context.commit("setShop", data);
              return _context.abrupt("return", data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getShop(_x) {
        return _getShop2.apply(this, arguments);
      }
      return getShop;
    }(),
    setVisibilityInShop: function () {
      var _setVisibilityInShop2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2(context, _ref) {
        var idItem, hide, idShop;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              idItem = _ref.idItem, hide = _ref.hide;
              idShop = context.getters["shop"].id;
              _context2.next = 4;
              return shop_setVisibilityInShop(idShop, idItem, hide);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function setVisibilityInShop(_x2, _x3) {
        return _setVisibilityInShop2.apply(this, arguments);
      }
      return setVisibilityInShop;
    }(),
    setVisibilityInShopIds: function () {
      var _setVisibilityInShopIds = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee3(context, _ref2) {
        var ids, hide, idShop, MAX_REQUESTS, promises, id;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ids = _ref2.ids, hide = _ref2.hide;
              idShop = context.getters["shop"].id;
              MAX_REQUESTS = 5;
            case 3:
              if (!(ids.length > 0)) {
                _context3.next = 10;
                break;
              }
              promises = [];
              while (promises.length < MAX_REQUESTS && ids.length > 0) {
                id = ids.pop();
                promises.push(shop_setVisibilityInShop(idShop, id, hide));
              }
              _context3.next = 8;
              return Promise.all(promises);
            case 8:
              _context3.next = 3;
              break;
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function setVisibilityInShopIds(_x4, _x5) {
        return _setVisibilityInShopIds.apply(this, arguments);
      }
      return setVisibilityInShopIds;
    }()
  },
  namespaced: true
});
;// CONCATENATED MODULE: ./src/store/paths.js


var getPath = function getPath(path) {
  if (isWidget) {
    return "".concat(widgetModuleName, "/").concat(path);
  }
  return path;
};
var paths_$paths = {
  items: {
    state: {
      products: getPath("items/products "),
      productKeys: getPath("items/productKeys"),
      totalProducts: getPath("items/totalProducts")
    },
    getters: {
      products: getPath("items/products"),
      productKeys: getPath("items/productKeys"),
      totalProducts: getPath("items/totalProducts"),
      currency: getPath("items/currency"),
      currencySymbol: getPath("items/currencySymbol"),
      decimalPrecision: getPath("items/decimalPrecision"),
      decimalPrecisionCalculation: getPath("items/decimalPrecisionCalculation"),
      decimalPrecisionQuantity: getPath("items/decimalPrecisionQuantity"),
      hasElectronicInvoicing: getPath("items/hasElectronicInvoicing"),
      referenceTypes: getPath("items/referenceTypes"),
      regime: getPath("items/regime"),
      showNoIvaDays: getPath("items/showNoIvaDays"),
      isActiveNoIvaDay: getPath("items/isActiveNoIvaDay"),
      invoiceText: getPath("items/invoiceText")
    },
    actions: {
      getProducts: getPath("items/getProducts"),
      getProductKeys: getPath("items/getProductKeys"),
      getReferenceTypes: getPath("items/getReferenceTypes"),
      editProduct: getPath("items/editProduct"),
      editNoIvaDaysInfo: getPath("items/editNoIvaDaysInfo"),
      modifyShopVisibility: getPath("items/modifyShopVisibility"),
      editStatus: getPath("items/editStatus"),
      deleteItemsByIds: getPath("items/deleteItemsByIds"),
      bulkActivate: getPath("items/bulkActivate"),
      bulkDeactivate: getPath("items/bulkDeactivate"),
      getInvoiceText: getPath("items/getInvoiceText")
    }
  },
  adjustmentNotes: {
    getters: {
      adjustmentNotes: getPath("adjustmentNotes/adjustmentNotes"),
      totalAdjustmentNotes: getPath("adjustmentNotes/totalAdjustmentNotes")
    },
    actions: {
      getAdjustmentNotes: getPath("adjustmentNotes/getAdjustmentNotes")
    }
  },
  bills: {
    state: {
      bills: getPath("bills/bills"),
      totalBills: getPath("bills/totalBills")
    },
    getters: {
      bills: getPath("bills/bills"),
      totalBills: getPath("bills/totalBills")
    },
    actions: {
      getBills: getPath("bills/getBills")
    }
  },
  supportDocuments: {
    state: {
      supportDocuments: getPath("supportDocuments/supportDocuments"),
      totalSupportDocuments: getPath("supportDocuments/totalSupportDocuments")
    },
    getters: {
      supportDocuments: getPath("supportDocuments/supportDocuments"),
      totalSupportDocuments: getPath("supportDocuments/totalSupportDocuments")
    },
    actions: {
      getSupportDocuments: getPath("supportDocuments/getSupportDocuments")
    }
  },
  categories: {
    state: {
      categoriesPlain: getPath("categories/categoriesPlain"),
      categoriesTree: getPath("categories/categoriesTree"),
      groupingCodes: getPath("categories/groupingCodes"),
      inventoryAccounts: getPath("categories/inventoryAccounts"),
      inventariablePurchaseAccounts: getPath("categories/inventariablePurchaseAccounts")
    },
    getters: {
      categoriesPlain: getPath("categories/categoriesPlain"),
      // categoriesPlainWithLevel: getPath("categories/categoriesPlainWithLevel"),
      categoriesTree: getPath("categories/categoriesTree"),
      groupingCodes: getPath("categories/groupingCodes"),
      inventoryAccounts: getPath("categories/inventoryAccounts"),
      inventoryAccountsPlain: getPath("categories/inventoryAccountsPlain"),
      inventariablePurchaseAccounts: getPath("categories/inventariablePurchaseAccounts"),
      inventariablePurchaseAccountsPlain: getPath("categories/inventariablePurchaseAccountsPlain")
    },
    actions: {
      getCategories: getPath("categories/getCategories"),
      getGroupingCodes: getPath("categories/getGroupingCodes"),
      getInventoryAccounts: getPath("categories/getInventoryAccounts"),
      getInventariablePurchaseAccounts: getPath("categories/getInventariablePurchaseAccounts"),
      getSalesAndInventoryAccounts: getPath("categories/getSalesAndInventoryAccounts"),
      createCategory: getPath("categories/createCategory"),
      editCategory: getPath("categories/editCategory")
    }
  },
  costCenters: {
    state: {
      costCenters: getPath("costCenters/costCenters"),
      totalCostCenters: getPath("costCenters/totalCostCenters")
    },
    getters: {
      activeCostCenters: getPath("costCenters/activeCostCenters"),
      costCenters: getPath("costCenters/costCenters"),
      totalCostCenters: getPath("costCenters/totalCostCenters")
    },
    actions: {
      getCostCenters: getPath("costCenters/getCostCenters")
    }
  },
  creditNotes: {
    state: {
      creditNotes: getPath("creditNotes/creditNotes"),
      totalCreditNotes: getPath("creditNotes/totalCreditNotes")
    },
    getters: {
      creditNotes: getPath("creditNotes/creditNotes"),
      totalCreditNotes: getPath("creditNotes/totalCreditNotes")
    },
    actions: {
      getCreditNotes: getPath("creditNotes/getCreditNotes")
    }
  },
  customFields: {
    state: {
      customFields: getPath("customFields/customFields")
    },
    getters: {
      customFields: getPath("customFields/customFields"),
      customFieldsForVariant: getPath("customFields/customFieldsForVariant"),
      activeCustomFields: getPath("customFields/activeCustomFields")
    },
    mutations: {
      setCustomFields: getPath("customFields/SET_CUSTOM_FIELDS")
    },
    actions: {
      getCustomFields: getPath("customFields/getCustomFields"),
      createCustomField: getPath("customFields/createCustomField"),
      deleteCustomField: getPath("customFields/deleteCustomField"),
      editCustomField: getPath("customFields/editCustomField"),
      editStatus: getPath("customFields/editStatus")
    }
  },
  debitNotes: {
    state: {
      debitNotes: getPath("debitNotes/debitNotes"),
      totalDebitNotes: getPath("debitNotes/totalDebitNotes")
    },
    getters: {
      debitNotes: getPath("debitNotes/debitNotes"),
      totalDebitNotes: getPath("debitNotes/totalDebitNotes")
    },
    actions: {
      getDebitNotes: getPath("debitNotes/getDebitNotes")
    }
  },
  districts: {
    state: {
      districts: getPath("districts/districts")
    },
    getters: {
      districts: getPath("districts/districts")
    },
    actions: {
      getDistricts: getPath("districts/getDistricts")
    }
  },
  estimates: {
    state: {
      estimates: getPath("estimates/estimates"),
      totalEstimates: getPath("estimates/totalEstimates")
    },
    getters: {
      estimates: getPath("estimates/estimates"),
      totalEstimates: getPath("estimates/totalEstimates")
    },
    actions: {
      getEstimates: getPath("estimates/getEstimates")
    }
  },
  featureFlags: {
    state: {
      showTestABProductTypeDOM: getPath("featureFlags/showTestABProductTypeDOM")
    },
    getters: {
      showTestABProductTypeDOM: getPath("featureFlags/showTestABProductTypeDOM"),
      showTogglers: getPath("featureFlags/showTogglers")
    },
    mutations: {
      SET_SHOW_TEST_AB_PRODUCT_TYPE_DOM: getPath("featureFlags/SET_SHOW_TEST_AB_PRODUCT_TYPE_DOM")
    }
  },
  incomeDebitNotes: {
    state: {
      incomeDebitNotes: getPath("incomeDebitNotes/incomeDebitNotes"),
      totalIncomeDebitNotes: getPath("incomeDebitNotes/totalIncomeDebitNotes")
    },
    getters: {
      incomeDebitNotes: getPath("incomeDebitNotes/incomeDebitNotes"),
      totalIncomeDebitNotes: getPath("incomeDebitNotes/totalIncomeDebitNotes")
    },
    actions: {
      getIncomeDebitNotes: getPath("incomeDebitNotes/getIncomeDebitNotes")
    }
  },
  itemCategories: {
    state: {
      itemCategories: getPath("itemCategories/itemCategories"),
      totalItemCategories: getPath("itemCategories/totalItemCategories")
    },
    getters: {
      activeItemCategories: getPath("itemCategories/activeItemCategories"),
      itemCategories: getPath("itemCategories/itemCategories")
    },
    actions: {
      createItemCategory: getPath("itemCategories/createItemCategory"),
      deleteItemCategory: getPath("itemCategories/deleteItemCategory"),
      editItemCategory: getPath("itemCategories/editItemCategory"),
      getItemCategories: getPath("itemCategories/getItemCategories")
    }
  },
  inventoryAdjustments: {
    state: {
      inventoryAdjustments: getPath("inventoryAdjustments/inventoryAdjustments"),
      totalInventoryAdjustments: getPath("inventoryAdjustments/totalInventoryAdjustments")
    },
    getters: {
      inventoryAdjustments: getPath("inventoryAdjustments/inventoryAdjustments"),
      totalInventoryAdjustments: getPath("inventoryAdjustments/totalInventoryAdjustments")
    },
    actions: {
      getInventoryAdjustments: getPath("inventoryAdjustments/getInventoryAdjustments"),
      createInventoryAdjustment: getPath("inventoryAdjustments/createInventoryAdjustment"),
      deleteInventoryAdjustment: getPath("inventoryAdjustments/deleteInventoryAdjustment"),
      editInventoryAdjustment: getPath("inventoryAdjustments/editInventoryAdjustment")
    }
  },
  legalSettings: {
    state: {
      categoriesNoIvaDays: getPath("legalSettings/categoriesNoIvaDays"),
      genresNoIvaDays: getPath("legalSettings/genresNoIvaDays")
    },
    getters: {
      categoriesNoIvaDays: getPath("legalSettings/categoriesNoIvaDays"),
      genresNoIvaDays: getPath("legalSettings/genresNoIvaDays")
    },
    actions: {
      getIVACategories: getPath("legalSettings/getIVACategories"),
      getIVAGenres: getPath("legalSettings/getIVAGenres")
    }
  },
  permissions: {
    getters: {
      canExport: getPath("permissions/canExport"),
      canViewCosts: getPath("permissions/canViewCosts"),
      permissions: getPath("permissions/permissions"),
      $hasPermission: getPath("permissions/$hasPermission")
    }
  },
  purchaseOrders: {
    state: {
      purchaseOrders: getPath("purchaseOrders/purchaseOrders"),
      totalPurchaseOrders: getPath("purchaseOrders/totalPurchaseOrders")
    },
    getters: {
      purchaseOrders: getPath("purchaseOrders/purchaseOrders"),
      totalPurchaseOrders: getPath("purchaseOrders/totalPurchaseOrders")
    },
    actions: {
      getPurchaseOrders: getPath("purchaseOrders/getPurchaseOrders")
    }
  },
  rejectionConcepts: {
    state: {
      rejectionConcepts: getPath("rejectionConcepts/rejectionConcepts")
    },
    getters: {
      rejectionConcepts: getPath("rejectionConcepts/rejectionConcepts")
    },
    actions: {
      getRejectionConcepts: getPath("rejectionConcepts/getRejectionConcepts")
    }
  },
  remissions: {
    state: {
      remissions: getPath("remissions/remissions"),
      totalRemissions: getPath("remissions/totalRemissions")
    },
    getters: {
      remissions: getPath("remissions/remissions"),
      totalRemissions: getPath("remissions/totalRemissions")
    },
    actions: {
      getRemissions: getPath("remissions/getRemissions")
    }
  },
  remissionGuides: {
    getters: {
      remissionGuides: getPath("remissionGuides/remissionGuides"),
      totalRemissionGuides: getPath("remissionGuides/totalRemissionGuides")
    },
    actions: {
      getRemissionGuides: getPath("remissionGuides/getRemissionGuides")
    }
  },
  salesInvoices: {
    state: {
      invoices: getPath("salesInvoices/invoices"),
      totalInvoices: getPath("salesInvoices/totalInvoices"),
      voidCauses: getPath("salesInvoices/voidCauses")
    },
    getters: {
      exportInvoiceSettingsActive: getPath("salesInvoices/exportInvoiceSettingsActive"),
      invoices: getPath("salesInvoices/invoices"),
      totalInvoices: getPath("salesInvoices/totalInvoices"),
      voidCauses: getPath("salesInvoices/voidCauses")
    },
    actions: {
      getInvoices: getPath("salesInvoices/getInvoices"),
      getVoidCauses: getPath("salesInvoices/getVoidCauses")
    }
  },
  taxes: {
    state: {
      taxes: getPath("taxes/taxes")
    },
    getters: {
      multitax: getPath("taxes/multitax"),
      taxes: getPath("taxes/taxes")
    },
    actions: {
      getTaxes: getPath("taxes/getTaxes"),
      createTax: getPath("taxes/createTax")
    }
  },
  exportInvoice: {
    state: {
      tariffFractions: getPath("exportInvoice/tariffFractions"),
      foreignTradeUnits: getPath("exportInvoice/foreignTradeUnits")
    },
    getters: {
      tariffFractions: getPath("exportInvoice/tariffFractions"),
      foreignTradeUnits: getPath("exportInvoice/foreignTradeUnits"),
      showExportInvoiceMex: getPath("exportInvoice/showExportInvoiceMex")
    },
    actions: {
      getTariffFractions: getPath("exportInvoice/getTariffFractions"),
      getForeignTradeUnits: getPath("exportInvoice/getForeignTradeUnits")
    }
  },
  units: {
    state: {
      units: getPath("units/units"),
      unitsByGroup: getPath("units/unitsByGroup")
    },
    getters: {
      units: getPath("units/units"),
      unitsByGroup: getPath("units/unitsByGroup"),
      unitsForService: getPath("units/unitsForService")
    },
    actions: {
      fetchUnits: getPath("units/fetchUnits"),
      getUnitsFromApi: getPath("units/getUnitsFromApi")
    }
  },
  variantAttributes: {
    state: {
      variantAttributes: getPath("variantAttributes/variantAttributes"),
      totalVariantAttributes: getPath("variantAttributes/totalVariantAttributes")
    },
    getters: {
      variantAttributes: getPath("variantAttributes/variantAttributes"),
      totalVariantAttributes: getPath("variantAttributes/totalVariantAttributes")
    },
    actions: {
      getVariantAttributes: getPath("variantAttributes/getVariantAttributes"),
      createVariantAttribute: getPath("variantAttributes/createVariantAttribute"),
      editVariantAttribute: getPath("variantAttributes/editVariantAttribute"),
      deleteVariantAttribute: getPath("variantAttributes/deleteVariantAttribute")
    }
  },
  warehouses: {
    state: {
      warehouses: getPath("warehouses/warehouses"),
      warehouseTransfers: getPath("warehouses/warehouseTransfers")
    },
    getters: {
      activeWarehouses: getPath("warehouses/activeWarehouses"),
      warehouses: getPath("warehouses/warehouses"),
      warehouseTransfers: getPath("warehouses/warehouseTransfers"),
      totalWarehouses: getPath("warehouses/totalWarehouses")
    },
    actions: {
      getWarehouses: getPath("warehouses/getWarehouses"),
      createWarehouse: getPath("warehouses/createWarehouse"),
      editWarehouse: getPath("warehouses/editWarehouse"),
      deleteWarehouse: getPath("warehouses/deleteWarehouse"),
      getWarehouseTransfers: getPath("warehouses/getWarehouseTransfers")
    }
  },
  pricesLists: {
    state: {
      pricesLists: getPath("pricesLists/pricesLists"),
      totalPricesLists: getPath("pricesLists/totalPricesLists")
    },
    getters: {
      pricesLists: getPath("pricesLists/pricesLists"),
      totalPricesLists: getPath("pricesLists/totalPricesLists")
    },
    actions: {
      createPricesList: getPath("pricesLists/createPricesList"),
      getPricesLists: getPath("pricesLists/getPricesLists"),
      editPricesList: getPath("pricesLists/editPricesList"),
      deletePricesList: getPath("pricesLists/deletePricesList")
    }
  },
  warehouseTransfers: {
    state: {
      warehouseTransfers: getPath("warehouseTransfers/warehouseTransfers"),
      totalWarehouseTransfers: getPath("warehouseTransfers/totalWarehouseTransfers")
    },
    getters: {
      warehouseTransfers: getPath("warehouseTransfers/warehouseTransfers"),
      totalWarehouseTransfers: getPath("warehouseTransfers/totalWarehouseTransfers")
    },
    actions: {
      createWarehouseTransfer: getPath("warehouseTransfers/createWarehouseTransfer"),
      deleteWarehouseTransfer: getPath("warehouseTransfers/deleteWarehouseTransfer"),
      editWarehouseTransfer: getPath("warehouseTransfers/editWarehouseTransfer"),
      getWarehouseTransfers: getPath("warehouseTransfers/getWarehouseTransfers")
    }
  },
  shop: {
    state: {
      shop: getPath("shop/shop")
    },
    getters: {
      shop: getPath("shop/shop")
    },
    actions: {
      getShop: getPath("shop/getShop"),
      setVisibilityInShop: getPath("shop/setVisibilityInShop"),
      setVisibilityInShopIds: getPath("shop/setVisibilityInShopIds")
    }
  }
};
/* harmony default export */ var paths = (paths_$paths);
;// CONCATENATED MODULE: ./src/store/index.js





































external_vue_default().use((external_vuex_default()));
var ONE_SECOND = 1000;
var ONE_MINUT = 60 * ONE_SECOND;
var THREE_MINUTS = 3 * ONE_MINUT;
var store = new (external_vuex_default()).Store({
  // state: {},
  // mutations: {},
  // actions: {},
  plugins: [hasModulePlugin, registerModuleOncePlugin, external_vuex_cache_default()({
    timeout: THREE_MINUTS
  })],
  modules: {
    bills: store_bills,
    categories: store_categories,
    costCenters: store_costCenters,
    creditNotes: store_creditNotes,
    customFields: customFields,
    debitNotes: store_debitNotes,
    estimates: store_estimates,
    exportInvoice: exportInvoice,
    featureFlags: featureFlags,
    incomeDebitNotes: store_incomeDebitNotes,
    items: items,
    itemCategories: itemCategories,
    inventoryAdjustments: store_inventoryAdjustments,
    variantAttributes: variantAttributes,
    legalSettings: legalSettings,
    permissions: permissions,
    purchaseOrders: store_purchaseOrders,
    pricesLists: pricesLists,
    salesInvoices: store_salesInvoices,
    rejectionConcepts: rejectionConcepts,
    remissions: store_remissions,
    remissionGuides: store_remissionGuides,
    taxes: taxes,
    units: units,
    supportDocuments: store_supportDocuments,
    warehouses: store_warehouses,
    warehouseTransfers: store_warehouseTransfers,
    adjustmentNotes: store_adjustmentNotes,
    districts: districts,
    shop: shop
  }
});
/* harmony default export */ var src_store = (store);
var userLoaded = function userLoaded() {
  return new Promise(function (resolve) {
    var unwatch = store.watch(function (state) {
      return state.session.user;
    }, function (user) {
      Vue.nextTick(function () {
        if (user && user.id) {
          resolve({
            user: user,
            unwatch: unwatch
          });
        }
      });
    }, {
      immediate: true
    });
  });
};

/* If add view is accessed directly, then company is not set yet. But it is
necessary to get units from local file */

//TODO: now that store is passed directly, there is no need for this function
// to be here (inside store/index.js) Maybe it could be inside store/units/helpers.js
var getUnits = function getUnits(_ref) {
  var searchTerm = _ref.searchTerm,
    item_type = _ref.item_type,
    $store = _ref.$store;
  if ($store.getters["session/company"]) {
    return $store.dispatch($paths.units.actions.getUnitsFromApi, {
      query: searchTerm,
      item_type: item_type
    });
  } else {
    return new Promise(function (resolve, reject) {
      try {
        $store.subscribe(function (mutation) {
          if (mutation.type === "session/SET_USER_DATA") {
            resolve($store.dispatch($paths.units.actions.getUnitsFromApi, {
              query: searchTerm,
              item_type: item_type
            }));
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  }
};

;// CONCATENATED MODULE: ./src/api/currencies.js






var CurrenciesApiSet = /*#__PURE__*/function (_ApiSet) {
  inherits_inherits(CurrenciesApiSet, _ApiSet);
  var _super = createSuper_createSuper(CurrenciesApiSet);
  function CurrenciesApiSet() {
    classCallCheck_classCallCheck(this, CurrenciesApiSet);
    return _super.apply(this, arguments);
  }
  createClass_createClass(CurrenciesApiSet, [{
    key: "list",
    value: function list() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        start: 0,
        limit: 30
      };
      return smile_ui_alegra_.request.get(this.url, {
        params: params
      });
    }
  }]);
  return CurrenciesApiSet;
}(apiSet);
/* harmony default export */ var currencies = (new CurrenciesApiSet("v1/currencies"));
;// CONCATENATED MODULE: external "vuelidate"
var external_vuelidate_namespaceObject = require("vuelidate");
;// CONCATENATED MODULE: ./src/events/AnalyticEvent.js





var AnalyticEvent_AnalyticEvent = /*#__PURE__*/function () {
  function AnalyticEvent() {
    classCallCheck_classCallCheck(this, AnalyticEvent);
  }
  createClass_createClass(AnalyticEvent, null, [{
    key: "prepareCompanyProperties",
    value: function prepareCompanyProperties(company, user) {
      return {
        idCompany: company.id,
        uuid: company.uuid,
        email: user.email,
        appVersion: company.applicationVersion,
        isPaying: user.membership.isPaid,
        regime: company.regime,
        sector: company.sector,
        employeesNumber: company.employeesNumber,
        planName: user.membership.planName,
        parity: company.id % 2 ? "odd" : "event"
      };
    }
  }, {
    key: "prepareEventProperties",
    value: function prepareEventProperties(eventProperties) {
      return _objectSpread2(_objectSpread2({}, eventProperties), {}, {
        idProduct: 1,
        productKey: "alegra-web",
        eventTimestamp: external_moment_default().utc().format("YYYY-MM-DD hh:mm:ss")
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(event);
    }
  }]);
  return AnalyticEvent;
}();

;// CONCATENATED MODULE: ./src/events/VariantAnalyticEvent.js





var VariantAnalyticEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_AnalyticEvent) {
  _inherits(VariantAnalyticEvent, _AnalyticEvent);
  var _super = _createSuper(VariantAnalyticEvent);
  function VariantAnalyticEvent() {
    _classCallCheck(this, VariantAnalyticEvent);
    return _super.apply(this, arguments);
  }
  _createClass(VariantAnalyticEvent, null, [{
    key: "emitVariantCreated",
    value: function emitVariantCreated(company, user, event) {
      var eventProperties = {
        optionsCount: event.options.length,
        idLocal: event.id
      };
      this.emit({
        eventProperties: this.prepareEventProperties(eventProperties),
        companyProperties: this.prepareCompanyProperties(company, user),
        event: "ac-variant-attribute-created"
      });
    }
  }]);
  return VariantAnalyticEvent;
}(AnalyticEvent)));

;// CONCATENATED MODULE: ./src/events/CustomFieldAnalyticEvent.js





var CustomFieldAnalyticEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_AnalyticEvent) {
  _inherits(CustomFieldAnalyticEvent, _AnalyticEvent);
  var _super = _createSuper(CustomFieldAnalyticEvent);
  function CustomFieldAnalyticEvent() {
    _classCallCheck(this, CustomFieldAnalyticEvent);
    return _super.apply(this, arguments);
  }
  _createClass(CustomFieldAnalyticEvent, null, [{
    key: "emitCustomFieldCreated",
    value: function emitCustomFieldCreated(company, user, customField) {
      var eventProperties = {
        type: customField.type,
        required: customField.settings.isRequired,
        printOnInvoices: customField.settings.printOnInvoices,
        idLocal: customField.id
      };
      this.emit({
        eventProperties: this.prepareEventProperties(eventProperties),
        companyProperties: this.prepareCompanyProperties(company, user),
        event: "ac-item-custom-field-created"
      });
    }
  }]);
  return CustomFieldAnalyticEvent;
}(AnalyticEvent)));

;// CONCATENATED MODULE: ./src/events/ItemCategoryAnalyticEvent.js





var ItemCategoryAnalyticEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_AnalyticEvent) {
  _inherits(ItemCategoryAnalyticEvent, _AnalyticEvent);
  var _super = _createSuper(ItemCategoryAnalyticEvent);
  function ItemCategoryAnalyticEvent() {
    _classCallCheck(this, ItemCategoryAnalyticEvent);
    return _super.apply(this, arguments);
  }
  _createClass(ItemCategoryAnalyticEvent, null, [{
    key: "emitItemCateogoryCreated",
    value: function emitItemCateogoryCreated(company, user, event) {
      var eventProperties = {
        error: event.error,
        idLocal: event.id
      };
      this.emit({
        eventProperties: this.prepareEventProperties(eventProperties),
        companyProperties: this.prepareCompanyProperties(company, user),
        event: "ac-item-category-created"
      });
    }
  }]);
  return ItemCategoryAnalyticEvent;
}(AnalyticEvent)));

;// CONCATENATED MODULE: ./src/events/WarehouseTransferAnalyticEvent.js





var WarehouseTransferAnalyticEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_AnalyticEvent) {
  _inherits(WarehouseTransferAnalyticEvent, _AnalyticEvent);
  var _super = _createSuper(WarehouseTransferAnalyticEvent);
  function WarehouseTransferAnalyticEvent() {
    _classCallCheck(this, WarehouseTransferAnalyticEvent);
    return _super.apply(this, arguments);
  }
  _createClass(WarehouseTransferAnalyticEvent, null, [{
    key: "emitWarehouseTransferCreated",
    value: function emitWarehouseTransferCreated(company, user, event) {
      var _event$items;
      var eventProperties = {
        error: event.error,
        idLocal: event.id,
        itemsCount: (_event$items = event.items) === null || _event$items === void 0 ? void 0 : _event$items.length
      };
      this.emit({
        eventProperties: this.prepareEventProperties(eventProperties),
        companyProperties: this.prepareCompanyProperties(company, user),
        event: "ac-warehouse-transferred-created"
      });
    }
  }]);
  return WarehouseTransferAnalyticEvent;
}(AnalyticEvent)));

;// CONCATENATED MODULE: ./src/events/WarehouseAnalyticEvent.js





var WarehouseAnalyticEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_AnalyticEvent) {
  _inherits(WarehouseAnalyticEvent, _AnalyticEvent);
  var _super = _createSuper(WarehouseAnalyticEvent);
  function WarehouseAnalyticEvent() {
    _classCallCheck(this, WarehouseAnalyticEvent);
    return _super.apply(this, arguments);
  }
  _createClass(WarehouseAnalyticEvent, null, [{
    key: "emitWarehouseCreated",
    value: function emitWarehouseCreated(company, user, event) {
      var eventProperties = {
        error: event.error,
        idLocal: event.id
      };
      this.emit({
        eventProperties: this.prepareEventProperties(eventProperties),
        companyProperties: this.prepareCompanyProperties(company, user),
        event: "ac-warehouse-created"
      });
    }
  }]);
  return WarehouseAnalyticEvent;
}(AnalyticEvent)));

;// CONCATENATED MODULE: ./src/events/PriceListAnalyticEvent.js





var PriceListAnalyticEvent = /*#__PURE__*/function (_AnalyticEvent) {
  inherits_inherits(PriceListAnalyticEvent, _AnalyticEvent);
  var _super = createSuper_createSuper(PriceListAnalyticEvent);
  function PriceListAnalyticEvent() {
    classCallCheck_classCallCheck(this, PriceListAnalyticEvent);
    return _super.apply(this, arguments);
  }
  createClass_createClass(PriceListAnalyticEvent, null, [{
    key: "emitPriceListCreated",
    value: function emitPriceListCreated(company, user, event) {
      var eventProperties = {
        error: event.error,
        idLocal: event.id,
        type: event.type
      };
      this.emit({
        eventProperties: this.prepareEventProperties(eventProperties),
        companyProperties: this.prepareCompanyProperties(company, user),
        event: "ac-price-list-created"
      });
    }
  }]);
  return PriceListAnalyticEvent;
}(AnalyticEvent_AnalyticEvent);

;// CONCATENATED MODULE: ./src/events/InventoryAdjustmentAnalyticEvent.js









var InventoryAdjustmentAnalyticEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_AnalyticEvent) {
  _inherits(InventoryAdjustmentAnalyticEvent, _AnalyticEvent);
  var _super = _createSuper(InventoryAdjustmentAnalyticEvent);
  function InventoryAdjustmentAnalyticEvent() {
    _classCallCheck(this, InventoryAdjustmentAnalyticEvent);
    return _super.apply(this, arguments);
  }
  _createClass(InventoryAdjustmentAnalyticEvent, null, [{
    key: "emitInventoryAdjustmentCreated",
    value: function emitInventoryAdjustmentCreated(company, user, event) {
      var eventProperties = {
        error: event.error,
        idLocal: event.id
      };
      if (event.items) {
        var incrementCount = 0,
          decrementCount = 0,
          finalQuantityZeroCount = 0,
          costEditedCount = 0;
        event.items.forEach(function (item) {
          incrementCount += Number(item.type.value === "in");
          decrementCount += Number(item.type.value === "out");
          finalQuantityZeroCount += Number(item.finalQuantity === "0");
          costEditedCount += Number(Math.abs(item.unitCost - item.oldUnitCost) >= 1e-6);
        });
        eventProperties = _objectSpread(_objectSpread({}, eventProperties), {}, {
          incrementCount: incrementCount,
          decrementCount: decrementCount,
          finalQuantityZeroCount: finalQuantityZeroCount,
          costEditedCount: costEditedCount,
          itemsCount: event.items.length
        });
      }
      this.emit({
        eventProperties: this.prepareEventProperties(eventProperties),
        companyProperties: this.prepareCompanyProperties(company, user),
        event: "ac-inventory-adjustment-created"
      });
    }
  }]);
  return InventoryAdjustmentAnalyticEvent;
}(AnalyticEvent)));

;// CONCATENATED MODULE: ./src/events/ItemAnalyticEvent.js






var ItemAnalyticEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_AnalyticEvent) {
  _inherits(ItemAnalyticEvent, _AnalyticEvent);
  var _super = _createSuper(ItemAnalyticEvent);
  function ItemAnalyticEvent() {
    _classCallCheck(this, ItemAnalyticEvent);
    return _super.apply(this, arguments);
  }
  _createClass(ItemAnalyticEvent, null, [{
    key: "emitItemCreated",
    value: function emitItemCreated(company, user, event) {
      var _event$inventory, _event$itemCategory;
      var eventProperties = {
        error: event.error,
        idLocal: event.id,
        formType: event.formType,
        inventoriable: ((_event$inventory = event.inventory) === null || _event$inventory === void 0 ? void 0 : _event$inventory.warehouses) !== undefined,
        itemType: event.type
      };
      if ((_event$itemCategory = event.itemCategory) !== null && _event$itemCategory !== void 0 && _event$itemCategory.name) {
        eventProperties.itemCategory = event.itemCategory.name;
      }
      if (Array.isArray(event.itemVariants)) {
        eventProperties.itemsVariantsCount = event.itemVariants.length;
      }
      if (Array.isArray(event.variantAttributes)) {
        eventProperties.variantAttributesCount = event.variantAttributes.length;
      }
      if (Array.isArray(event.price)) {
        eventProperties.pricesListsCount = event.price.length;
      }
      if (eventProperties.inventoriable && Array.isArray(event.inventory.warehouses)) {
        eventProperties.warehousesCount = event.inventory.warehouses.length;
      }
      if (Array.isArray(event.customFields)) {
        eventProperties.customFieldsCount = event.customFields.length;
      }
      this.emit({
        eventProperties: this.prepareEventProperties(eventProperties),
        companyProperties: this.prepareCompanyProperties(company, user),
        event: "ac-item-created"
      });
    }
  }]);
  return ItemAnalyticEvent;
}(AnalyticEvent)));

;// CONCATENATED MODULE: ./src/events/index.js









;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/pricesList/PricesListForm.vue?vue&type=script&lang=js










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var PricesListFormvue_type_script_lang_js = ({
  mixins: [external_vuelidate_namespaceObject.validationMixin],
  props: {
    pricesListToEdit: {
      type: [String, Number],
      default: undefined
    }
  },
  data: function data() {
    return {
      pricesListModel: utils_pricesListModel(),
      currencies: []
    };
  },
  computed: _objectSpread2({
    form: function form() {
      return this.pricesListModel.data;
    },
    typeOptions: function typeOptions() {
      return [{
        name: this.$transF("pricesListsPage.percentage"),
        value: "percentage"
      }, {
        name: this.$transF("pricesListsPage.amount"),
        value: "amount"
      }];
    },
    currencyOptions: function currencyOptions() {
      return [this.company.currency].concat(_toConsumableArray(this.currencies)).filter(function (_ref) {
        var status = _ref.status;
        return status !== "inactive";
      });
    },
    multicurrency: function multicurrency() {
      var _this$company;
      return (_this$company = this.company) === null || _this$company === void 0 ? void 0 : _this$company.multicurrency;
    }
  }, (0,external_vuex_namespaceObject.mapGetters)({
    user: "session/user",
    company: "session/company"
  })),
  watch: {
    "$v.$invalid": function $v$invalid(newValue) {
      this.$emit("invalid", newValue);
    }
  },
  validations: function validations() {
    var _this = this;
    return {
      form: {
        name: {
          required: validators_namespaceObject.required
        },
        type: {
          required: validators_namespaceObject.required
        },
        /*currency: {
          required(value, model) {
            return !(model.type.value === "amount" && !value)
          }
        },*/
        percentage: {
          required: (0,validators_namespaceObject.requiredIf)(function () {
            return _this.form.type.value === "percentage";
          })
        }
      }
    };
  },
  created: function created() {
    var _this2 = this;
    return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee() {
      return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.pricesListToEdit) {
              _this2.$emit("loading", true);
              pricesList.detail(_this2.pricesListToEdit).then(function (_ref2) {
                var data = _ref2.data;
                _this2.pricesListModel.fillFromApi(data);
              }).catch(function (err) {
                logError(err, _this2, "created");
                showError(_this2, err, {
                  pathMessage: "pricesListsPage.errors.loadError"
                });
              }).finally(function () {
                return _this2.$emit("loading", false);
              });
            } /*else {
              this.form.currency = this.company.currency
              this.currencies = (await this.getCurrencies()) || []
              }*/
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread2({
    reset: function reset() {
      this.pricesListModel.init();
    },
    getCurrencies: function getCurrencies() {
      var _this3 = this;
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/(0,regeneratorRuntime/* default */.Z)().mark(function _callee2() {
        var _yield$currenciesApiS, data;
        return (0,regeneratorRuntime/* default */.Z)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this3.company.multicurrency) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return currencies.list();
            case 5:
              _yield$currenciesApiS = _context2.sent;
              data = _yield$currenciesApiS.data;
              return _context2.abrupt("return", data);
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](2);
              logError(_context2.t0, _this3, "getCurrencies");
              showError(_context2.t0, _this3);
            case 14:
              return _context2.abrupt("return", []);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 10]]);
      }))();
    },
    getTypeHelp: function getTypeHelp() {
      return this.$trans("pricesListsPage.".concat(this.form.type.value, "Help"));
    },
    handleEditPricesList: function handleEditPricesList(body) {
      var _this4 = this;
      this.editPricesList({
        id: this.pricesListToEdit,
        body: body
      }).then(function (data) {
        _this4.$smAlertSuc(_this4.$trans("itemsPage.successfulOperation"));
        _this4.$emit("success", data);
      }).catch(function (err) {
        _this4.$emit("error", err);
        logError(err, _this4, "handleEditPricesList");
        showError(err, _this4);
      }).finally(function () {
        _this4.$emit("loading", false);
      });
    },
    handleCreatePricesList: function handleCreatePricesList(body) {
      var _this5 = this;
      this.createPricesList(body).then(function (data) {
        PriceListAnalyticEvent.emitPriceListCreated(_this5.company, _this5.user, data);
        _this5.$smAlertSuc(_this5.$trans("itemsPage.successfulOperation"));
        _this5.$emit("success", data);
      }).catch(function (err) {
        _this5.$emit("error", err);
        logError(err, _this5, "handleCreatePricesList");
        showError(err, _this5);
      }).finally(function () {
        _this5.$emit("loading", false);
      });
    },
    handleSubmit: function handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        PriceListAnalyticEvent.emitPriceListCreated(this.company, this.user, {
          error: this.$trans("itemsPage.errors.form")
        });
        this.$smAlertErr(this.$trans("itemsPage.errors.form"));
        return;
      }
      var body = this.pricesListModel.getPricesListToSend();
      this.$emit("loading", true);
      if (this.pricesListToEdit) {
        this.handleEditPricesList(body);
      } else {
        this.handleCreatePricesList(body);
      }
    }
  }, (0,external_vuex_namespaceObject.mapActions)({
    editPricesList: paths.pricesLists.actions.editPricesList,
    createPricesList: paths.pricesLists.actions.createPricesList
  }))
});
;// CONCATENATED MODULE: ./src/components/pricesList/PricesListForm.vue?vue&type=script&lang=js
 /* harmony default export */ var pricesList_PricesListFormvue_type_script_lang_js = (PricesListFormvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/pricesList/PricesListForm.vue





/* normalize component */
;
var component = normalizeComponent(
  pricesList_PricesListFormvue_type_script_lang_js,
  PricesListFormvue_type_template_id_f301a65c_render,
  PricesListFormvue_type_template_id_f301a65c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PricesListForm = (component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/widgets/priceListForm.vue?vue&type=script&lang=js
//
//
//
//
//
//
//
//
//


/* harmony default export */ var priceListFormvue_type_script_lang_js = ({
  name: "PriceListWidget",
  components: {
    PricesListForm: PricesListForm
  },
  methods: {
    save: function save() {
      this.doSubmit();
    },
    reset: function reset() {
      this.$refs.priceListForm.reset();
    },
    doSubmit: function doSubmit() {
      this.$refs.priceListForm.handleSubmit();
    }
  }
});
;// CONCATENATED MODULE: ./src/widgets/priceListForm.vue?vue&type=script&lang=js
 /* harmony default export */ var widgets_priceListFormvue_type_script_lang_js = (priceListFormvue_type_script_lang_js); 
;// CONCATENATED MODULE: ./src/widgets/priceListForm.vue





/* normalize component */
;
var priceListForm_component = normalizeComponent(
  widgets_priceListFormvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  "7394b66e",
  null
  
)

/* harmony default export */ var priceListForm = (priceListForm_component.exports);
;// CONCATENATED MODULE: ./src/widgetPriceList.js






var install = function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!options.store) {
    throw new Error("Vuex store instance is required for installing priceList widget");
  }

  // Register the Store modules
  // Some widgets may share the some vuex modules. So in order to not register the module
  // twice use the "registerModuleOnce" version (or the classic as a fallback)
  var registerModuleFn = options.store.registerModuleOnce || options.store.registerModule;
  registerModuleFn([widgetModuleName], {
    namespaced: true,
    modules: {
      pricesLists: pricesLists
    }
  });

  // Register components
  Vue.component("SmPriceListWidget", priceListForm);
};

// Specify  the keys to retrive from the langs files
var dictionaryForWidget = convertDictionaryToObject(["pricesListsPage"]);
/* harmony default export */ var widgetPriceList = (install);

// Separate export, for installing only what you need

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (widgetPriceList);


}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=pricelist.common.js.map